webpackJsonp([1],{

/***/ "+nrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/J5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0RwB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0y7z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3wPb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4yKi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7+7V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Srh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "99qr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9qno":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cmg_logo.0b430ce.png";

/***/ }),

/***/ "DKTr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EmNs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FtE1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FzuW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H5Gy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HOju":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUqv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HWbf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcqS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JUtw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KcSI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KjLl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MSGY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N0om":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.css
var dist_vuetify = __webpack_require__("QCv7");
var dist_vuetify_default = /*#__PURE__*/__webpack_require__.n(dist_vuetify);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vuex-persistedstate/dist/vuex-persistedstate.es.js + 2 modules
var vuex_persistedstate_es = __webpack_require__("424j");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/api/index.js


// const BASE_URL = 'http://api.cmg.sisgroup.sg'
var token = localStorage.getItem('accesstoken');
if (token) {
  axios_default.a.defaults.headers.common['accesstoken'] = 'Bearer ' + token;
}
var httpInstance = axios_default.a.create({
  baseURL: 'http://dev.api.cmg.sisgroup.sg/',
  headers: {
    'content-type': 'application/json',
    deviceid: '123456'
  }
});

var pictureUploadInstance = axios_default.a.create({
  baseURL: 'http://dev.api.cmg.sisgroup.sg/',
  headers: {
    'content-type': 'multipart/form-data',
    deviceid: '123456'
  }
});
// CONCATENATED MODULE: ./src/store/mutation-types.js
var SET_USER = 'SET_USER';
var SIGN_OUT = 'SIGN_OUT';
var SET_ERR = 'SET_ERR';
var SET_PASSWORD_RESET_FLAG = 'SET_PASSWORD_RESET_FLAG';
var SET_ERR_MESSAGE = 'SET_ERR_MESSAGE';
var CHANGE_USER_PROFILE = 'CHANGE_USER_PROFILE';
var CHANGE_USER_PICTURE = 'CHANGE_USER_PICTURE';

var LOAD_RESPONSE = 'LOAD_RESPONSE';
var SET_LOADING = 'SET_LOADING';

var GET_ALL_COMPANIES = 'GET_ALL_COMPANIES';
var ADD_COMPANY = 'ADD_COMPANY';
var CHANGE_COMPANY = 'CHANGE_COMPANY';
var DELETE_COMPANY = 'DELETE_COMPANY';
var SET_ACTIVE_COMPANY = 'SET_ACTIVE_COMPANY';

var GET_ALL_DIVISIONS = 'GET_ALL_DIVISIONS';
var ADD_DIVISION = 'ADD_DIVISION';
var CHANGE_DIVISION = 'CHANGE_DIVISION';
var DELETE_DIVISION = 'DELETE_DIVISION';
var SET_ACTIVE_DIVISION = 'SET_ACTIVE_DIVISION';

var GET_ALL_DEPARTMENTS = 'GET_ALL_DEPARTMENTS';
var ADD_DEPARTMENT = 'ADD_DEPARTMENT';
var CHANGE_DEPARTMENT = 'CHANGE_DEPARTMENT';
var DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';
var SET_ACTIVE_DEPARTMENT = 'SET_ACTIVE_DEPARTMENT';

var GET_ALL_RANKS = 'GET_ALL_RANKS';
var ADD_RANK = 'ADD_RANK';
var CHANGE_RANK = 'CHANGE_RANK';
var DELETE_RANK = 'DELETE_RANK';
var SET_ACTIVE_RANK = 'SET_ACTIVE_RANK';

var GET_ALL_PLANTS = 'GET_ALL_PLANTS';
var ADD_PLANT = 'ADD_PLANT';
var CHANGE_PLANT = 'CHANGE_PLANT';
var DELETE_PLANT = 'DELETE_PLANT';
var SET_ACTIVE_PLANT = 'SET_ACTIVE_PLANT';

var GET_APPROVAL_PROFILES = 'GET_APPROVAL_PROFILES';
var ADD_APPROVAL_PROFILE = 'ADD_APPROVAL_PROFILE';
var CHANGE_APPROVAL_PROFILE = 'CHANGE_APPROVAL_PROFILE';
var DELETE_APPROVAL_PROFILE = 'DELETE_APPROVAL_PROFILE';
var SET_ACTIVE_APPROVAL_PROFILE = 'SET_ACTIVE_APPROVAL_PROFILE';

var GET_APPROVAL_LIMITS = 'GET_APPROVAL_LIMITS';
var ADD_APPROVAL_LIMIT = 'ADD_APPROVAL_LIMIT';
var CHANGE_APPROVAL_LIMIT = 'CHANGE_APPROVAL_LIMIT';
var DELETE_APPROVAL_LIMIT = 'DELETE_APPROVAL_LIMIT';

var GET_APPROVAL_USERS = 'GET_APPROVAL_USERS';
var ADD_APPROVAL_USER = 'ADD_APPROVAL_USER';
var CHANGE_APPROVAL_USER = 'CHANGE_APPROVAL_USER';
var DELETE_APPROVAL_USER = 'DELETE_APPROVAL_USER';
var BLOCK_APPROVAL_USER = 'BLOCK_APPROVAL_USER';
var SET_ACTIVE_APPROVAL_USER = 'SET_ACTIVE_APPROVAL_USER';

var GET_USER_DEVICES = 'GET_USER_DEVICES';
var BLOCK_USER_DEVICE = 'BLOCK_USER_DEVICE';

var GET_WORKFLOW = 'GET_WORKFLOW';
var ADD_WORKFLOW = 'ADD_WORKFLOW';
var CHANGE_WORKFLOW = 'CHANGE_WORKFLOW';
var DELETE_WORKFLOW = 'DELETE_WORKFLOW';
var SET_ACTIVE_WORKFLOW = 'SET_ACTIVE_WORKFLOW';

var GET_PR_REPORT = 'GET_PR_REPORT';
var GET_PO_REPORT = 'GET_PO_REPORT';

var GET_PENDING_PR = 'GET_PENDING_PR';
var GET_PENDING_PO = 'GET_PENDING_PO';
var GET_TOTAL_USERS = 'GET_TOTAL_USERS';
var GET_LOGIN_USERS = 'GET_LOGIN_USERS';

var GET_ALL_ADMIN = 'GET_ALL_ADMIN';
var SET_ACTIVE_ADMIN = 'SET_ACTIVE_ADMIN';
var ADD_ADMIN = 'ADD_ADMIN';
var CHANGE_ADMIN = 'CHANGE_ADMIN';
var DELETE_ADMIN = 'DELETE_ADMIN';
var GET_ACCESSIBLE_MENU = 'GET_ACCESSIBLE_MENU';
var SET_ACCESSIBLE_MENU = 'SET_ACCESSIBLE_MENU';
var CHANGE_ACCESSIBLE_MENU = 'CHANGE_ACCESSIBLE_MENU';

var GET_ALL_MENU_ITEMS = 'GET_ALL_MENU_ITEMS';
var GET_MENU_LIST_OPTIONS = 'GET_MENU_LIST_OPTIONS';
// CONCATENATED MODULE: ./src/store/modules/master-data.js




var _mutations;




var master_data_state = {
  divisions: [],
  activeDivision: {},
  plants: [],
  activePlant: {},
  departments: [],
  activeDepartment: {},
  companies: [],
  activeCompany: {},
  ranks: [],
  activeRank: {},
  httpResponse: {},
  loading: false
};

var getters = {
  getResponse: function getResponse(state) {
    return state.httpResponse;
  },
  getLoading: function getLoading(state) {
    return state.loading;
  },

  getAllCompanies: function getAllCompanies(state) {
    return state.companies;
  },
  getActiveCompany: function getActiveCompany(state) {
    return state.activeCompany;
  },

  getAllDivisions: function getAllDivisions(state) {
    return state.divisions;
  },
  getActiveDivision: function getActiveDivision(state) {
    return state.activeDivision;
  },

  getAllDepartments: function getAllDepartments(state) {
    return state.departments;
  },
  getActiveDepartment: function getActiveDepartment(state) {
    return state.activeDepartment;
  },

  getAllRanks: function getAllRanks(state) {
    return state.ranks;
  },
  getActiveRank: function getActiveRank(state) {
    return state.activeRank;
  },

  getAllPlants: function getAllPlants(state) {
    return state.plants;
  },
  getActivePlant: function getActivePlant(state) {
    return state.activePlant;
  }
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, LOAD_RESPONSE, function (state, payload) {
  state.httpResponse = payload;
}), defineProperty_default()(_mutations, SET_LOADING, function (state, payload) {
  state.loading = payload;
}), defineProperty_default()(_mutations, GET_ALL_COMPANIES, function (state, payload) {
  state.companies = payload;
}), defineProperty_default()(_mutations, ADD_COMPANY, function (state, payload) {
  state.companies.push(payload);
}), defineProperty_default()(_mutations, CHANGE_COMPANY, function (state, payload) {
  var atIndex = state.companies.findIndex(function (c) {
    return c.id === payload.id;
  });
  state.companies.splice(atIndex, 1);
  state.companies.splice(atIndex, 0, payload);
}), defineProperty_default()(_mutations, DELETE_COMPANY, function (state, payload) {
  var atIndex = state.divisions.findIndex(function (d) {
    return d.id === payload;
  });
  state.divisions.splice(atIndex, 1);
}), defineProperty_default()(_mutations, SET_ACTIVE_COMPANY, function (state, payload) {
  state.activeCompany = payload;
}), defineProperty_default()(_mutations, ADD_DIVISION, function (state, _ref) {
  var payload = _ref.payload;

  state.divisions.push(payload);
}), defineProperty_default()(_mutations, GET_ALL_DIVISIONS, function (state, payload) {
  state.divisions = payload;
}), defineProperty_default()(_mutations, CHANGE_DIVISION, function (state, payload) {
  var atIndex = state.divisions.findIndex(function (d) {
    return d.id === payload.id;
  });
  state.divisions.splice(atIndex, 1);
  state.divisions.splice(atIndex, 0, payload);
}), defineProperty_default()(_mutations, DELETE_DIVISION, function (state, payload) {
  var atIndex = state.divisions.findIndex(function (d) {
    return d.id === payload;
  });
  state.divisions.splice(atIndex, 1);
}), defineProperty_default()(_mutations, SET_ACTIVE_DIVISION, function (state, payload) {
  state.activeDivision = payload;
}), defineProperty_default()(_mutations, ADD_DEPARTMENT, function (state, _ref2) {
  var payload = _ref2.payload;

  state.departments.push(payload);
}), defineProperty_default()(_mutations, GET_ALL_DEPARTMENTS, function (state, payload) {
  state.departments = payload;
}), defineProperty_default()(_mutations, CHANGE_DEPARTMENT, function (state, payload) {
  var atIndex = state.departments.findIndex(function (d) {
    return d.id === payload.id;
  });
  state.departments.splice(atIndex, 1);
  state.departments.splice(atIndex, 0, payload);
}), defineProperty_default()(_mutations, DELETE_DEPARTMENT, function (state, payload) {
  var atIndex = state.departments.findIndex(function (d) {
    return d.id === payload;
  });
  state.departments.splice(atIndex, 1);
}), defineProperty_default()(_mutations, SET_ACTIVE_DEPARTMENT, function (state, payload) {
  state.activeDepartment = payload;
}), defineProperty_default()(_mutations, ADD_RANK, function (state, _ref3) {
  var payload = _ref3.payload;

  state.ranks.push(payload);
}), defineProperty_default()(_mutations, GET_ALL_RANKS, function (state, payload) {
  state.ranks = payload;
}), defineProperty_default()(_mutations, CHANGE_RANK, function (state, payload) {
  var atIndex = state.ranks.findIndex(function (rank) {
    return rank.id === payload.id;
  });
  state.ranks.splice(atIndex, 1);
  state.ranks.splice(atIndex, 0, payload);
}), defineProperty_default()(_mutations, DELETE_RANK, function (state, payload) {
  var atIndex = state.ranks.findIndex(function (rank) {
    return rank.id === payload;
  });
  state.ranks.splice(atIndex, 1);
}), defineProperty_default()(_mutations, SET_ACTIVE_RANK, function (state, payload) {
  state.activeRank = payload;
}), defineProperty_default()(_mutations, ADD_PLANT, function (state, _ref4) {
  var payload = _ref4.payload;

  state.plants.push(payload);
}), defineProperty_default()(_mutations, GET_ALL_PLANTS, function (state, payload) {
  state.plants = payload;
}), defineProperty_default()(_mutations, CHANGE_PLANT, function (state, payload) {
  var atIndex = state.plants.findIndex(function (plant) {
    return plant.id === payload.id;
  });
  state.plants.splice(atIndex, 1);
  state.plants.splice(atIndex, 0, payload);
}), defineProperty_default()(_mutations, DELETE_PLANT, function (state, payload) {
  var atIndex = state.plants.findIndex(function (plant) {
    return plant.id === payload;
  });
  state.plants.splice(atIndex, 1);
}), defineProperty_default()(_mutations, SET_ACTIVE_PLANT, function (state, payload) {
  state.activePlant = payload;
}), _mutations);

var actions = {
  fetchAllCompanies: function fetchAllCompanies(_ref5) {
    var _this = this;

    var commit = _ref5.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(SET_LOADING, true);
              _context.next = 3;
              return httpInstance.get('/company/list-unlimited').then(function (response) {
                commit(GET_ALL_COMPANIES, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  addCompany: function addCompany(_ref6, payload) {
    var _this2 = this;

    var commit = _ref6.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit(SET_LOADING, true);
              _context2.next = 3;
              return httpInstance.post('/company/add', payload).then(function (response) {
                commit(ADD_COMPANY, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  changeCompany: function changeCompany(_ref7, payload) {
    var _this3 = this;

    var commit = _ref7.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit(SET_LOADING, true);
              _context3.next = 3;
              return httpInstance.put('/company/' + payload.id + '/update', payload).then(function (response) {
                commit(CHANGE_COMPANY, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  setActiveCompany: function setActiveCompany(_ref8, id) {
    var _this4 = this;

    var commit = _ref8.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit(SET_LOADING, true);
              _context4.next = 3;
              return httpInstance.get('/company/' + id + '/get').then(function (response) {
                commit(SET_ACTIVE_COMPANY, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchAllDivisions: function fetchAllDivisions(_ref9) {
    var _this5 = this;

    var commit = _ref9.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit(SET_LOADING, true);
              _context5.next = 3;
              return httpInstance.get('/division/list-unlimited').then(function (response) {
                commit(GET_ALL_DIVISIONS, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  setActiveDivision: function setActiveDivision(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit(SET_LOADING, true);
              _context6.next = 3;
              return httpInstance.get('/division/' + id + '/get').then(function (response) {
                commit(SET_ACTIVE_DIVISION, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  changeDivision: function changeDivision(_ref11, payload) {
    var _this7 = this;

    var commit = _ref11.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit(SET_LOADING, true);
              _context7.next = 3;
              return httpInstance.put('/division/' + payload.id + '/update', {
                initial: payload.initial,
                description: payload.description
              }).then(function (response) {
                commit(CHANGE_DIVISION, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  addNewDivision: function addNewDivision(_ref12, payload) {
    var _this8 = this;

    var commit = _ref12.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit(SET_LOADING, true);
              _context8.next = 3;
              return httpInstance.post('/division/add', {
                initial: payload.initial,
                description: payload.description
              }).then(function (response) {
                commit(ADD_DIVISION, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  deleteDivision: function deleteDivision(_ref13, id) {
    var _this9 = this;

    var commit = _ref13.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit(SET_LOADING, true);
              _context9.next = 3;
              return httpInstance.delete('/division/' + id + '/delete').then(function (response) {
                commit(DELETE_DIVISION, id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  fetchAllDepartments: function fetchAllDepartments(_ref14) {
    var _this10 = this;

    var commit = _ref14.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit(SET_LOADING, true);
              _context10.next = 3;
              return httpInstance.get('/department/list-unlimited').then(function (response) {
                commit(GET_ALL_DEPARTMENTS, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  setActiveDepartment: function setActiveDepartment(_ref15, id) {
    var _this11 = this;

    var commit = _ref15.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
      return regenerator_default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit(SET_LOADING, true);
              _context11.next = 3;
              return httpInstance.get('/department/' + id + '/get').then(function (response) {
                commit(SET_ACTIVE_DEPARTMENT, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  changeDepartment: function changeDepartment(_ref16, payload) {
    var _this12 = this;

    var commit = _ref16.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
      return regenerator_default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              commit(SET_LOADING, true);
              _context12.next = 3;
              return httpInstance.put('/department/' + payload.id + '/update', {
                initial: payload.initial,
                description: payload.description
              }).then(function (response) {
                commit(CHANGE_DEPARTMENT, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  addNewDepartment: function addNewDepartment(_ref17, payload) {
    var _this13 = this;

    var commit = _ref17.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
      return regenerator_default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit(SET_LOADING, true);
              _context13.next = 3;
              return httpInstance.post('/department/add', {
                initial: payload.initial,
                description: payload.description
              }).then(function (response) {
                commit(ADD_DEPARTMENT, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  deleteDepartment: function deleteDepartment(_ref18, id) {
    var _this14 = this;

    var commit = _ref18.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
      return regenerator_default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              commit(SET_LOADING, true);
              _context14.next = 3;
              return httpInstance.delete('/department/' + id + '/delete').then(function (response) {
                commit(DELETE_DEPARTMENT, id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  fetchAllRanks: function fetchAllRanks(_ref19) {
    var _this15 = this;

    var commit = _ref19.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
      return regenerator_default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              commit(SET_LOADING, true);
              _context15.next = 3;
              return httpInstance.get('/rank/list-unlimited').then(function (response) {
                commit(GET_ALL_RANKS, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  setActiveRank: function setActiveRank(_ref20, id) {
    var _this16 = this;

    var commit = _ref20.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
      return regenerator_default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              commit(SET_LOADING, true);
              _context16.next = 3;
              return httpInstance.get('/rank/' + id + '/get').then(function (response) {
                commit(SET_ACTIVE_RANK, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  },
  changeRank: function changeRank(_ref21, payload) {
    var _this17 = this;

    var commit = _ref21.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
      return regenerator_default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              commit(SET_LOADING, true);
              _context17.next = 3;
              return httpInstance.put('/rank/' + payload.id + '/update', {
                description: payload.description,
                rank_initial: payload.rank_initial
              }).then(function (response) {
                commit(CHANGE_RANK, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17);
    }))();
  },
  addNewRank: function addNewRank(_ref22, payload) {
    var _this18 = this;

    var commit = _ref22.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
      return regenerator_default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              commit(SET_LOADING, true);
              _context18.next = 3;
              return httpInstance.post('/rank/add', {
                description: payload.description,
                rank_initial: payload.rank_initial
              }).then(function (response) {
                commit(ADD_RANK, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18);
    }))();
  },
  deleteRank: function deleteRank(_ref23, id) {
    var _this19 = this;

    var commit = _ref23.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
      return regenerator_default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              commit(SET_LOADING, true);
              _context19.next = 3;
              return httpInstance.delete('/rank/' + id + '/delete').then(function (response) {
                commit(DELETE_RANK, id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                commit(LOAD_RESPONSE, error.response);
                console.log(error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19);
    }))();
  },
  fetchAllPlants: function fetchAllPlants(_ref24) {
    var _this20 = this;

    var commit = _ref24.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20() {
      return regenerator_default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              commit(SET_LOADING, true);
              _context20.next = 3;
              return httpInstance.get('/plant/list-unlimited').then(function (response) {
                commit(GET_ALL_PLANTS, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(SET_LOADING, false);
                commit(LOAD_RESPONSE, error.response);
              });

            case 3:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20);
    }))();
  },
  setActivePlant: function setActivePlant(_ref25, id) {
    var _this21 = this;

    var commit = _ref25.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21() {
      return regenerator_default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              commit(SET_LOADING, true);
              _context21.next = 3;
              return httpInstance.get('/plant/' + id + '/get').then(function (response) {
                commit(SET_ACTIVE_PLANT, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(SET_LOADING, false);
                commit(LOAD_RESPONSE, error.response);
              });

            case 3:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this21);
    }))();
  },
  changePlant: function changePlant(_ref26, payload) {
    var _this22 = this;

    var commit = _ref26.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22() {
      return regenerator_default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              commit(SET_LOADING, true);
              _context22.next = 3;
              return httpInstance.put('/plant/' + payload.id + '/update', {
                plant: payload.plant,
                description: payload.description,
                company_code: payload.company_code
              }).then(function (response) {
                commit(CHANGE_PLANT, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this22);
    }))();
  },
  addNewPlant: function addNewPlant(_ref27, payload) {
    var _this23 = this;

    var commit = _ref27.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23() {
      return regenerator_default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              commit(SET_LOADING, true);
              _context23.next = 3;
              return httpInstance.post('/plant/add', {
                plant: payload.plant,
                description: payload.description,
                company_code: payload.company_code
              }).then(function (response) {
                commit(ADD_PLANT, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this23);
    }))();
  },
  deletePlant: function deletePlant(_ref28, id) {
    var _this24 = this;

    var commit = _ref28.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee24() {
      return regenerator_default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              commit(SET_LOADING, true);
              _context24.next = 3;
              return httpInstance.delete('/plant/' + id + '/delete').then(function (response) {
                commit(DELETE_PLANT, id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this24);
    }))();
  }
};

/* harmony default export */ var master_data = ({
  state: master_data_state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/Main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Main = ({
  name: 'mainPage',
  data: function data() {
    return {
      clipped: false,
      drawer: null,
      miniVariant: false,
      right: false,
      rightDrawer: false,
      title: '',
      fav: true,
      menu: false,
      message: false,
      hints: true
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    activeUser: 'getActiveUser',
    items: 'getMenuForDrawer'
  }), {

    imageUrl: function imageUrl() {
      return '' + httpInstance.defaults.baseURL + this.activeUser.normal_photo;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['signOut']), {

    toProfile: function toProfile() {
      this.menu = false;
      this.$router.push({ name: 'profileDetail' });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694a0f57","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{attrs:{"fixed":"","mini-variant":_vm.miniVariant,"clipped":_vm.clipped,"transition":"slide-x-transition","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":""}},[_c('v-list',[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('router-link',{attrs:{"to":"/dashboard"}},[_c('v-avatar',{attrs:{"size":"50"}},[_c('img',{attrs:{"src":__webpack_require__("9qno")}})])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheading"},[_c('router-link',{staticStyle:{"cursor":"pointer","font-weight":"bold"},attrs:{"to":"/","tag":"span"}},[_vm._v("\n                CHIP MONG\n                "),_c('span',{staticClass:"primary--text"},[_vm._v("GROUP")])])],1)],1)],1),_vm._v(" "),_c('v-divider')],1)],1),_vm._v(" "),_c('v-list',[_vm._l((_vm.items),function(item){return [(item.header)?_c('v-subheader',{key:item.title,domProps:{"textContent":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{key:item.title}):_c('v-list-tile',{key:item.title,attrs:{"to":item.to}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}})],1)],1)]}),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.signOut}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("input")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Sign out")])],1)],1)],2)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"primary",attrs:{"fixed":"","app":"","clipped-left":_vm.clipped,"dark":"","transition":"slide-y-transition"}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.miniVariant = !_vm.miniVariant}}},[_c('v-icon',{domProps:{"innerHTML":_vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')}})],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}}},[_c('v-icon',[_vm._v("web")])],1),_vm._v(" "),_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","close-on-content-click":false,"nudge-width":200},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{attrs:{"src":_vm.imageUrl}})])],1),_vm._v(" "),_c('v-card',[_c('v-list',[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.imageUrl,"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.activeUser.firstName)+" "+_vm._s(_vm.activeUser.lastName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.activeUser.email))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.toProfile()}}},[_vm._v("my profile")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.signOut()}}},[_vm._v("sign out")])],1)],1)],1)],1),_vm._v(" "),_c('v-content',{attrs:{"transition":"slide-y-transition"}},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear()))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dashboard_Main = (esExports);
// CONCATENATED MODULE: ./src/components/dashboard/Main.vue
function injectStyle (ssrContext) {
  __webpack_require__("WSIB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-694a0f57"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Main,
  dashboard_Main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_dashboard_Main = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/Signin.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Signin = ({
  name: 'signin',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      email: null,
      isForgotPass: false,
      e1: true,
      e2: true,
      e3: true,
      isErr: false,
      alert: false,
      loader: null,
      user: {
        employee_id: '',
        password: ''
      },
      reset: {},
      isSending: false,
      isSigning: false,
      isError: false,
      snackbar: false,
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    err: 'getErr',
    token: 'getToken',
    activeUser: 'getActiveUser',
    isLoading: 'getLoading',
    getErrMessage: 'getErrMessage',
    getResponse: 'getResponse'
  }), {
    errMessage: function errMessage() {
      return this.getErrMessage || '';
    },
    isPasswordReset: function isPasswordReset() {
      return this.$store.state.users.isPasswordReset;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['signIn', 'sendForgotPassCode', 'resetPasswordWithCode']), {
    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll('formSignIn').then(function (result) {
        if (result) {
          _this.isSigning = true;
          var payload = {
            user: _this.user,
            redirect: _this.$route.query.redirect
          };
          _this.signIn(payload).then(function () {
            _this.isSigning = false;
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Sign in successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    },
    submitForgotPass: function submitForgotPass() {
      var _this2 = this;

      this.$validator.validateAll('formSendResetCode').then(function (result) {
        if (result) {
          _this2.isSending = true;
          _this2.sendForgotPassCode({ email: _this2.email }).then(function () {
            _this2.isSending = false;
            var response = _this2.getResponse;
            if (response.status === 200) {
              _this2.isForgotPass = false;
            }
            _this2.snackbar = true;
            _this2.text = response.status === 200 ? 'Reset code sent to your email successfully.' : response.data.message;
            _this2.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    },
    submitResetPassword: function submitResetPassword() {
      var _this3 = this;

      this.$validator.validateAll('formResetPassword').then(function (result) {
        if (result) {
          _this3.isSending = true;
          _this3.resetPasswordWithCode(_this3.reset).then(function () {
            _this3.isSending = false;
            var response = _this3.getResponse;
            if (response.status === 200) {
              _this3.isForgotPass = false;
            }
            _this3.snackbar = true;
            _this3.text = response.status === 200 ? 'Reset code sent to your email successfully.' : response.data.message;
            _this3.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    },
    onCancel: function onCancel() {
      this.$store.commit(SET_PASSWORD_RESET_FLAG, false);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8954b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Signin.vue
var Signin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"singInBg"},[_c('v-dialog',{attrs:{"value":true,"persistent":"","max-width":"400px","hide-overlay":""}},[_c('v-card',[_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('img',{attrs:{"src":__webpack_require__("9qno"),"alt":"Chip Mong Industries","height":"96"}})]),_vm._v(" "),_c('v-flex',{staticClass:"ma-3",attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.isPasswordReset ? "Reset your password" : "Welcome back. Please sign in"))])])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(!_vm.isPasswordReset)?_c('v-card-text',[_c('form',{attrs:{"data-vv-scope":"formSignIn"},on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-layout',{staticClass:"ml-3 mr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","label":"Employee ID","error-messages":_vm.errors.collect('employee id'),"data-vv-name":"employee id","prepend-icon":"account_circle"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.formSubmit($event)}},model:{value:(_vm.user.employee_id),callback:function ($$v) {_vm.$set(_vm.user, "employee_id", $$v)},expression:"user.employee_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","label":"Password","error-messages":_vm.errors.collect('password'),"data-vv-name":"password","append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"prepend-icon":"lock"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.formSubmit($event)}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"block":"","color":"primary","dark":"","loading":_vm.isSigning,"disable":_vm.isSigning},on:{"click":_vm.formSubmit}},[_vm._v("\n                sign in\n              ")])],1)],1)],1)]):_vm._e(),_vm._v(" "),(!_vm.isPasswordReset)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.isForgotPass = !_vm.isForgotPass}}},[_vm._v("forgot password?")])],1):_vm._e(),_vm._v(" "),(_vm.isForgotPass)?_c('v-card',{attrs:{"flat":""}},[_c('form',{attrs:{"data-vv-scope":"formSendResetCode"},on:{"submit":function($event){$event.preventDefault();_vm.submitForgotPass($event)}}},[_c('v-layout',{staticClass:"ml-3 mr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-title',[_c('div',{staticClass:"body-1"},[_vm._v("Please input your correct email. We will send reset code to you shortly.")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"type":"email","required":"","label":"Email","error-messages":_vm.errors.collect('email'),"data-vv-name":"email","prepend-icon":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-actions',[_c('v-btn',{attrs:{"block":"","dark":"","type":"submit","loading":_vm.isSending,"color":"primary","disable":_vm.isSending}},[_vm._v("send")])],1)],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.isPasswordReset)?_c('v-card',[_c('v-card-text',[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"grid-list-xs":"","fluid":""}},[_c('form',{attrs:{"data-vv-scope":"formResetPassword"},on:{"submit":function($event){$event.preventDefault();_vm.submitResetPassword($event)}}},[_c('v-layout',{staticClass:"ml-3 mr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"required":"","label":"Reset Code","error-messages":_vm.errors.collect('reset code'),"data-vv-name":"reset code"},model:{value:(_vm.reset.code),callback:function ($$v) {_vm.$set(_vm.reset, "code", $$v)},expression:"reset.code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"required":"","name":"newPassword","label":"New password","error-messages":_vm.errors.collect('new password'),"data-vv-name":"new password","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text'},model:{value:(_vm.reset.new_password),callback:function ($$v) {_vm.$set(_vm.reset, "new_password", $$v)},expression:"reset.new_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:newPassword|min:6'),expression:"'required|confirmed:newPassword|min:6'"}],attrs:{"required":"","name":"confirmPassword","label":"Password confirmation","error-messages":_vm.errors.collect('password confirmation'),"data-vv-name":"password confirmation","append-icon":_vm.e3 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e3 = !_vm.e3); },"type":_vm.e3 ? 'password' : 'text'},model:{value:(_vm.reset.retype_password),callback:function ($$v) {_vm.$set(_vm.reset, "retype_password", $$v)},expression:"reset.retype_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","type":"submit","color":"primary","dark":"","loading":_vm.isSending,"disable":_vm.isSending}},[_vm._v("\n                    reset password\n                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","color":"accent","dark":""},on:{"click":_vm.onCancel}},[_vm._v("\n                    cancel\n                  ")])],1)],1)],1)])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var Signin_staticRenderFns = []
var Signin_esExports = { render: Signin_render, staticRenderFns: Signin_staticRenderFns }
/* harmony default export */ var user_Signin = (Signin_esExports);
// CONCATENATED MODULE: ./src/components/user/Signin.vue
function Signin_injectStyle (ssrContext) {
  __webpack_require__("WdJb")
}
var Signin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Signin___vue_template_functional__ = false
/* styles */
var Signin___vue_styles__ = Signin_injectStyle
/* scopeId */
var Signin___vue_scopeId__ = "data-v-1c8954b0"
/* moduleIdentifier (server only) */
var Signin___vue_module_identifier__ = null
var Signin_Component = Signin_normalizeComponent(
  Signin,
  user_Signin,
  Signin___vue_template_functional__,
  Signin___vue_styles__,
  Signin___vue_scopeId__,
  Signin___vue_module_identifier__
)

/* harmony default export */ var components_user_Signin = (Signin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/Dashboard.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Dashboard = ({
  name: 'Dashboard',
  data: function data() {
    return {
      search: '',
      selected: [],
      headers: [{
        text: 'Action',
        align: 'left',
        value: 'action',
        sortable: false
      }, {
        text: 'Date',
        align: 'left',
        value: 'created_date'
      }, {
        text: 'Device Name',
        align: 'left',
        value: 'device_name'
      }, {
        text: 'Employee ID',
        align: 'left',
        value: 'employee_id'
      }, {
        text: 'First name',
        align: 'left',
        value: 'first_name'
      }, {
        text: 'Last name',
        align: 'left',
        value: 'last_name'
      }, {
        text: 'Status',
        align: 'left',
        value: 'status'
      }],
      currentLoginUserHeaders: [{
        text: 'Employee ID',
        align: 'left',
        value: 'employee_id'
      }, {
        text: 'First name',
        align: 'left',
        value: 'first_name'
      }, {
        text: 'Last name',
        align: 'left',
        value: 'last_name'
      }, {
        text: 'Device Name',
        align: 'left',
        value: 'device_name'
      }, {
        text: 'Login since',
        align: 'left',
        value: 'last_log_in_date'
      }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getUserNotNullDevices', 'getPendingPR', 'getPendingPO', 'getTotalUser', 'getLoading', 'getResponse', 'getCurrentLoginUsers'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchBlockedDevices', 'blockUserDevice', 'fetchPendingPR', 'fetchPendingPO', 'fetchTotalUser', 'fetchCurrentLoginUsers']), {
    setDeviceStatus: function setDeviceStatus(_id, _status) {
      var status = _status === 1 ? 0 : 1;
      this.blockUserDevice({ id: _id, is_blocked: status }).then(function () {
        // do nothing
      });
    }
  }),
  mounted: function mounted() {
    this.fetchBlockedDevices().then(function () {
      // do nothing
    });
    this.fetchPendingPR().then(function () {
      // do nothing
    });
    this.fetchPendingPO().then(function () {
      // do nothing
    });
    this.fetchTotalUser().then(function () {
      // do nothing
    });
    this.fetchCurrentLoginUsers().then(function () {
      // do nothing
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ea6726","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
var Dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Dashboard")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"secondary","to":"/report/pr-report"}},[_c('v-card-title',[_c('div',{staticClass:"text-xs-center title"},[_vm._v("Pending PR")])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text-xs-center display-4"},[_vm._v(_vm._s(_vm.getPendingPR))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"purple","to":"/report/po-report"}},[_c('v-card-title',[_c('div',{staticClass:"text-xs-center title"},[_vm._v("Pending PO")])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text-xs-center display-4"},[_vm._v(_vm._s(_vm.getPendingPO))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"primary","to":"/approver"}},[_c('v-card-title',[_c('div',{staticClass:"text-xs-center title"},[_vm._v("Active Users")])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text-xs-center display-4"},[_vm._v(_vm._s(_vm.getTotalUser))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("List of unauthorized/blocked devices")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[(!_vm.getLoading)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.getUserNotNullDevices,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\r\n                "+_vm._s(props.header.text)+"\r\n              ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[(props.item.is_blocked === 0)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"red"},on:{"click":function($event){_vm.setDeviceStatus(props.item.id, props.item.is_blocked)}},slot:"activator"},[_c('v-icon',[_vm._v("block")])],1),_vm._v(" "),_c('span',[_vm._v("Deactivate")])],1):_vm._e(),_vm._v(" "),(props.item.is_blocked === 1)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.setDeviceStatus(props.item.id, props.item.is_blocked)}},slot:"activator"},[_c('v-icon',[_vm._v("check_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Activate")])],1):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_date)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.device_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.employee_id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.is_blocked === 1 ? "Inactive" : "Activate"))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("List of current login users")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[(!_vm.getLoading)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"loading":"true","headers":_vm.currentLoginUserHeaders,"items":_vm.getCurrentLoginUsers,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\r\n                "+_vm._s(props.header.text)+"\r\n              ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.employee_id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.device_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("formatDate")(props.item.last_log_in_date)))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}})],1)],1)}
var Dashboard_staticRenderFns = []
var Dashboard_esExports = { render: Dashboard_render, staticRenderFns: Dashboard_staticRenderFns }
/* harmony default export */ var dashboard_Dashboard = (Dashboard_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/Dashboard.vue
function Dashboard_injectStyle (ssrContext) {
  __webpack_require__("/J5b")
}
var Dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Dashboard___vue_template_functional__ = false
/* styles */
var Dashboard___vue_styles__ = Dashboard_injectStyle
/* scopeId */
var Dashboard___vue_scopeId__ = "data-v-15ea6726"
/* moduleIdentifier (server only) */
var Dashboard___vue_module_identifier__ = null
var Dashboard_Component = Dashboard_normalizeComponent(
  Dashboard,
  dashboard_Dashboard,
  Dashboard___vue_template_functional__,
  Dashboard___vue_styles__,
  Dashboard___vue_scopeId__,
  Dashboard___vue_module_identifier__
)

/* harmony default export */ var components_dashboard_Dashboard = (Dashboard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile-user/Approver.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Approver = ({
  name: 'approver'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6b2da6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-user/Approver.vue
var Approver_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Approval users")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('router-view')],1)],1)}
var Approver_staticRenderFns = []
var Approver_esExports = { render: Approver_render, staticRenderFns: Approver_staticRenderFns }
/* harmony default export */ var mobile_user_Approver = (Approver_esExports);
// CONCATENATED MODULE: ./src/components/mobile-user/Approver.vue
function Approver_injectStyle (ssrContext) {
  __webpack_require__("UYk3")
}
var Approver_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Approver___vue_template_functional__ = false
/* styles */
var Approver___vue_styles__ = Approver_injectStyle
/* scopeId */
var Approver___vue_scopeId__ = "data-v-1c6b2da6"
/* moduleIdentifier (server only) */
var Approver___vue_module_identifier__ = null
var Approver_Component = Approver_normalizeComponent(
  Approver,
  mobile_user_Approver,
  Approver___vue_template_functional__,
  Approver___vue_styles__,
  Approver___vue_scopeId__,
  Approver___vue_module_identifier__
)

/* harmony default export */ var components_mobile_user_Approver = (Approver_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile-user/ApproverDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ApproverDetail = ({
  name: 'approver-detail',
  data: function data() {
    return {
      switch1: true,
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      rowsPerPageItems: [10, 15, 25, { text: 'All', value: -1 }],
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'Employee ID',
        align: 'left',
        value: 'employee_id'
      },
      // {
      //   text: 'Salutation',
      //   align: 'left',
      //   value: 'salutation'
      // },
      {
        text: 'First name',
        align: 'left',
        value: 'first_name'
      }, {
        text: 'Last name',
        align: 'left',
        value: 'last_name'
      },
      // {
      //   text: 'E-mail',
      //   align: 'left',
      //   value: 'email'
      // },
      {
        text: 'Release description',
        align: 'left',
        value: 'release_description'
      }, {
        text: 'Status',
        align: 'left',
        value: 'status'
      }],
      items: [],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchApprovalUsers', 'deleteApprovalUser', 'blockApprovalUser']), {
    editApprovalUserById: function editApprovalUserById(id) {
      this.$router.push({ name: 'changeApprover', params: { id: id } });
    },


    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },

    deleteApprovalUserById: function deleteApprovalUserById() {
      var _this = this;

      this.deleteApprovalUser(this.selectedId).then(function () {
        _this.dialog = false;
        var response = _this.getResponse;
        _this.snackbar = true;
        _this.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this.color = response.status === 200 ? 'success' : 'error';
      });
    },
    setUserStatus: function setUserStatus(_id, _status) {
      var status = _status === 1 ? 0 : 1;
      this.blockApprovalUser({ id: _id, is_blocked: status }).then(function () {
        // do nothing
      });
    }
  }),
  mounted: function mounted() {
    this.fetchApprovalUsers();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getApprovalUsers', 'getLoading', 'getResponse']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d935750a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-user/ApproverDetail.vue
var ApproverDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected approval user?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected approval user.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.deleteApprovalUserById}},[_vm._v("\n              delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',{staticClass:"elevation-0",attrs:{"flat":""}},[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent","to":"/approver/new"}},[_vm._v("new approver")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-card-text',[(!_vm.getLoading)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.getApprovalUsers,"search":_vm.search,"item-key":"id","rows-per-page-items":_vm.rowsPerPageItems},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n                "+_vm._s(props.header.text)+"\n              ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[(props.item.is_blocked === 0)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"red"},on:{"click":function($event){_vm.setUserStatus(props.item.id, props.item.is_blocked)}},slot:"activator"},[_c('v-icon',[_vm._v("block")])],1),_vm._v(" "),_c('span',[_vm._v("Deactivate")])],1):_vm._e(),_vm._v(" "),(props.item.is_blocked === 1)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.setUserStatus(props.item.id, props.item.is_blocked)}},slot:"activator"},[_c('v-icon',[_vm._v("check_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Reactivate")])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editApprovalUserById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.employee_id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.rank_description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.is_blocked === 1 ? "Inactive" : "Activate"))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1),_vm._v(" "),(_vm.getLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)}
var ApproverDetail_staticRenderFns = []
var ApproverDetail_esExports = { render: ApproverDetail_render, staticRenderFns: ApproverDetail_staticRenderFns }
/* harmony default export */ var mobile_user_ApproverDetail = (ApproverDetail_esExports);
// CONCATENATED MODULE: ./src/components/mobile-user/ApproverDetail.vue
function ApproverDetail_injectStyle (ssrContext) {
  __webpack_require__("V3l2")
  __webpack_require__("FzuW")
}
var ApproverDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ApproverDetail___vue_template_functional__ = false
/* styles */
var ApproverDetail___vue_styles__ = ApproverDetail_injectStyle
/* scopeId */
var ApproverDetail___vue_scopeId__ = "data-v-d935750a"
/* moduleIdentifier (server only) */
var ApproverDetail___vue_module_identifier__ = null
var ApproverDetail_Component = ApproverDetail_normalizeComponent(
  ApproverDetail,
  mobile_user_ApproverDetail,
  ApproverDetail___vue_template_functional__,
  ApproverDetail___vue_styles__,
  ApproverDetail___vue_scopeId__,
  ApproverDetail___vue_module_identifier__
)

/* harmony default export */ var components_mobile_user_ApproverDetail = (ApproverDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile-user/ChangeApprover.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ChangeApprover = ({
  name: 'change-approver',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      // imagePath: `${axios.defaults.baseURL}${
      //   this.$store.state.workflow.activeApprovalUser.small_photo
      // }`,
      approver: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      search: '',
      selected: [],
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'Device Name',
        align: 'left',
        value: 'device_name'
      }, {
        text: 'OS',
        align: 'left',
        value: 'device_os'
      },
      // {
      //   text: 'UUID',
      //   align: 'left',
      //   value: 'device_uuid'
      // },
      {
        text: 'Version',
        align: 'left',
        value: 'device_version'
      }, {
        text: 'Status',
        align: 'left',
        value: 'status'
      }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllRanks', 'getActiveApprovalUser', 'getUserDevices', 'getUserNotNullDevices', 'getAllCompanies']), {
    imagePath: function imagePath() {
      return '' + httpInstance.defaults.baseURL + this.$store.state.workflow.activeApprovalUser.small_photo;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllRanks', 'setActiveApprovalUser', 'changeApprovalUser', 'fetchUserDevices', 'blockUserDevice', 'fetchAllCompanies']), {
    editApproverPasswordById: function editApproverPasswordById(id) {
      this.$router.push({ name: 'ChangeApproverPassword', params: { id: id } });
    },
    clear: function clear() {
      this.$refs.form.reset();
      this.$validator.reset();
    },


    onFormApprovalUserSubmit: function onFormApprovalUserSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.changeApprovalUser(_this.approver).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    },
    setDeviceStatus: function setDeviceStatus(_id, _status) {
      var status = _status === 1 ? 0 : 1;
      this.blockUserDevice({ id: _id, is_blocked: status }).then(function () {
        // do nothing
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.fetchAllRanks();
    this.fetchAllCompanies();

    this.setActiveApprovalUser(this.id).then(function () {
      _this2.approver = assign_default()({}, _this2.getActiveApprovalUser);
      // this.imagePath = `${axios.defaults.baseURL}${
      //   this.$store.state.workflow.activeApprovalUser.small_photo
      // }`
    }).catch(function (error) {
      console.log(error);
    });
    this.fetchUserDevices(this.id).then(function () {
      //  do nothing
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6842e074","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-user/ChangeApprover.vue
var ChangeApprover_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Change approval user information")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","offset-xs3":"","md3":"","offset-md5":""}},[_c('v-avatar',{attrs:{"size":"128"}},[_c('img',{attrs:{"src":_vm.imagePath,"width":"128"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Employee ID","error-messages":_vm.errors.collect('employee id'),"data-vv-name":"employee id","required":""},model:{value:(_vm.approver.employee_id),callback:function ($$v) {_vm.$set(_vm.approver, "employee_id", $$v)},expression:"approver.employee_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Salutation","error-messages":_vm.errors.collect('salutation'),"data-vv-name":"salutation","required":""},model:{value:(_vm.approver.salutation),callback:function ($$v) {_vm.$set(_vm.approver, "salutation", $$v)},expression:"approver.salutation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"First name","error-messages":_vm.errors.collect('first name'),"data-vv-name":"first name","required":""},model:{value:(_vm.approver.first_name),callback:function ($$v) {_vm.$set(_vm.approver, "first_name", $$v)},expression:"approver.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Last name","error-messages":_vm.errors.collect('last name'),"data-vv-name":"last name","required":""},model:{value:(_vm.approver.last_name),callback:function ($$v) {_vm.$set(_vm.approver, "last_name", $$v)},expression:"approver.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllRanks,"label":"Release code","item-value":"id","error-messages":_vm.errors.collect('rank'),"data-vv-name":"rank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.rank_initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.rank_initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.approver.rank_id),callback:function ($$v) {_vm.$set(_vm.approver, "rank_id", $$v)},expression:"approver.rank_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"E-mail","error-messages":_vm.errors.collect('email'),"data-vv-name":"email","required":""},model:{value:(_vm.approver.email),callback:function ($$v) {_vm.$set(_vm.approver, "email", $$v)},expression:"approver.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"item-value":"company_code","item-text":"description","label":"Company code","multiple":"","chips":"","hint":"Choose one or more company code","persistent-hint":"","error-messages":_vm.errors.collect('company_code'),"data-vv-name":"company_code","required":""},model:{value:(_vm.approver.company_code),callback:function ($$v) {_vm.$set(_vm.approver, "company_code", $$v)},expression:"approver.company_code"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"accent"},on:{"click":function($event){_vm.editApproverPasswordById(_vm.id)}}},[_vm._v("change password")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.onFormApprovalUserSubmit}},[_vm._v("save\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary"},on:{"click":function($event){_vm.clear()}}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/approver"}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Change user's devices")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[(!_vm.getLoading)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.getUserNotNullDevices,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n                "+_vm._s(props.header.text)+"\n              ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[(props.item.is_blocked === 0)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"red"},on:{"click":function($event){_vm.setDeviceStatus(props.item.id, props.item.is_blocked)}},slot:"activator"},[_c('v-icon',[_vm._v("block")])],1),_vm._v(" "),_c('span',[_vm._v("Deactivate")])],1):_vm._e(),_vm._v(" "),(props.item.is_blocked === 1)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.setDeviceStatus(props.item.id, props.item.is_blocked)}},slot:"activator"},[_c('v-icon',[_vm._v("check_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Activate")])],1):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.device_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.device_os))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.device_version))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.is_blocked === 1 ? "Inactive" : "Activate"))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      "+_vm._s(_vm.text)+"\n      "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)}
var ChangeApprover_staticRenderFns = []
var ChangeApprover_esExports = { render: ChangeApprover_render, staticRenderFns: ChangeApprover_staticRenderFns }
/* harmony default export */ var mobile_user_ChangeApprover = (ChangeApprover_esExports);
// CONCATENATED MODULE: ./src/components/mobile-user/ChangeApprover.vue
function ChangeApprover_injectStyle (ssrContext) {
  __webpack_require__("Xm9g")
}
var ChangeApprover_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeApprover___vue_template_functional__ = false
/* styles */
var ChangeApprover___vue_styles__ = ChangeApprover_injectStyle
/* scopeId */
var ChangeApprover___vue_scopeId__ = "data-v-6842e074"
/* moduleIdentifier (server only) */
var ChangeApprover___vue_module_identifier__ = null
var ChangeApprover_Component = ChangeApprover_normalizeComponent(
  ChangeApprover,
  mobile_user_ChangeApprover,
  ChangeApprover___vue_template_functional__,
  ChangeApprover___vue_styles__,
  ChangeApprover___vue_scopeId__,
  ChangeApprover___vue_module_identifier__
)

/* harmony default export */ var components_mobile_user_ChangeApprover = (ChangeApprover_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile-user/NewApprover.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewApprover = ({
  name: 'new-approver',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      approver: {
        company_code: [],
        employee_id: '',
        rank_id: '',
        email: '',
        password: '',
        retype_password: '',
        first_name: '',
        last_name: '',
        phone_no: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      e2: true,
      e3: true
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllRanks', 'getAllCompanies'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllRanks', 'addApprovalUser', 'fetchAllCompanies']), {
    clear: function clear() {
      this.$refs.form.reset();
      this.$validator.reset();
    },


    onFormApprovalUserSubmit: function onFormApprovalUserSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.addApprovalUser(_this.approver).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
            if (response.status === 200) {
              _this.clear();
            }
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    this.fetchAllRanks();
    this.fetchAllCompanies();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e07b7ad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-user/NewApprover.vue
var NewApprover_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Create new approval user for mobile login")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Employee ID","error-messages":_vm.errors.collect('employee id'),"data-vv-name":"employee id","required":""},model:{value:(_vm.approver.employee_id),callback:function ($$v) {_vm.$set(_vm.approver, "employee_id", $$v)},expression:"approver.employee_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Salutation","error-messages":_vm.errors.collect('salutation'),"data-vv-name":"salutation","required":""},model:{value:(_vm.approver.salutation),callback:function ($$v) {_vm.$set(_vm.approver, "salutation", $$v)},expression:"approver.salutation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"First name","error-messages":_vm.errors.collect('first name'),"data-vv-name":"first name","required":""},model:{value:(_vm.approver.first_name),callback:function ($$v) {_vm.$set(_vm.approver, "first_name", $$v)},expression:"approver.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Last name","error-messages":_vm.errors.collect('last name'),"data-vv-name":"last name","required":""},model:{value:(_vm.approver.last_name),callback:function ($$v) {_vm.$set(_vm.approver, "last_name", $$v)},expression:"approver.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllRanks,"label":"Release code","item-value":"id","error-messages":_vm.errors.collect('release code'),"data-vv-name":"release code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.rank_initial)+" - "+_vm._s(data.item.description)+"\n                ")]}},{key:"item",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.rank_initial)+" - "+_vm._s(data.item.description)+"\n                ")]}}]),model:{value:(_vm.approver.rank_id),callback:function ($$v) {_vm.$set(_vm.approver, "rank_id", $$v)},expression:"approver.rank_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"E-mail","error-messages":_vm.errors.collect('email'),"data-vv-name":"email","required":""},model:{value:(_vm.approver.email),callback:function ($$v) {_vm.$set(_vm.approver, "email", $$v)},expression:"approver.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"label":"Password","name":"password","error-messages":_vm.errors.collect('password'),"data-vv-name":"password","required":"","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text'},model:{value:(_vm.approver.password),callback:function ($$v) {_vm.$set(_vm.approver, "password", $$v)},expression:"approver.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:password|min:6'),expression:"'required|confirmed:password|min:6'"}],attrs:{"label":"Confirm password","error-messages":_vm.errors.collect('confirm password'),"data-vv-name":"confirm password","required":"","append-icon":_vm.e3 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e3 = !_vm.e3); },"type":_vm.e3 ? 'password' : 'text'},model:{value:(_vm.approver.retype_password),callback:function ($$v) {_vm.$set(_vm.approver, "retype_password", $$v)},expression:"approver.retype_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"company_code","items":_vm.getAllCompanies,"item-value":"company_code","item-text":"description","label":"Company code","multiple":"","chips":"","error-messages":_vm.errors.collect('company_code'),"data-vv-name":"company_code","hint":"Choose one or more company code","persistent-hint":"","required":""},model:{value:(_vm.approver.company_code),callback:function ($$v) {_vm.$set(_vm.approver, "company_code", $$v)},expression:"approver.company_code"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.onFormApprovalUserSubmit}},[_vm._v("save\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent"},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/approver"}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var NewApprover_staticRenderFns = []
var NewApprover_esExports = { render: NewApprover_render, staticRenderFns: NewApprover_staticRenderFns }
/* harmony default export */ var mobile_user_NewApprover = (NewApprover_esExports);
// CONCATENATED MODULE: ./src/components/mobile-user/NewApprover.vue
function NewApprover_injectStyle (ssrContext) {
  __webpack_require__("NxF2")
}
var NewApprover_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewApprover___vue_template_functional__ = false
/* styles */
var NewApprover___vue_styles__ = NewApprover_injectStyle
/* scopeId */
var NewApprover___vue_scopeId__ = "data-v-3e07b7ad"
/* moduleIdentifier (server only) */
var NewApprover___vue_module_identifier__ = null
var NewApprover_Component = NewApprover_normalizeComponent(
  NewApprover,
  mobile_user_NewApprover,
  NewApprover___vue_template_functional__,
  NewApprover___vue_styles__,
  NewApprover___vue_scopeId__,
  NewApprover___vue_module_identifier__
)

/* harmony default export */ var components_mobile_user_NewApprover = (NewApprover_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile-user/ChangeApproverPassword.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ChangeApproverPassword = ({
  name: 'ChangeApproverPassword',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      e2: true,
      e3: true,
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      user: {
        new_password: '',
        retype_password: ''
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changeApprovalPassword', 'signOut']), {
    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var payload = {
            id: _this.id,
            user: _this.user
          };
          _this.changeApprovalPassword(payload).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba41340","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-user/ChangeApproverPassword.vue
var ChangeApproverPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('v-card-title',[_c('div',[_c('h1',{staticClass:"title"},[_vm._v("Password")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"required":"","name":"newPassword","label":"New password","error-messages":_vm.errors.collect('new password'),"data-vv-name":"new password","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text'},model:{value:(_vm.user.new_password),callback:function ($$v) {_vm.$set(_vm.user, "new_password", $$v)},expression:"user.new_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:newPassword|min:6'),expression:"'required|confirmed:newPassword|min:6'"}],attrs:{"required":"","label":"Password confirmation","error-messages":_vm.errors.collect('password confirmation'),"data-vv-name":"password confirmation","append-icon":_vm.e3 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e3 = !_vm.e3); },"type":_vm.e3 ? 'password' : 'text'},model:{value:(_vm.user.retype_password),callback:function ($$v) {_vm.$set(_vm.user, "retype_password", $$v)},expression:"user.retype_password"}})],1)],1),_vm._v(" "),_c('div',[_c('span',{staticClass:"caption"},[_vm._v("*After password reset, the new password will be effective next time user login.")])])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"to":"/approver"}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.formSubmit}},[_vm._v("change password\n            ")])],1)],1)])],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeApproverPassword_staticRenderFns = []
var ChangeApproverPassword_esExports = { render: ChangeApproverPassword_render, staticRenderFns: ChangeApproverPassword_staticRenderFns }
/* harmony default export */ var mobile_user_ChangeApproverPassword = (ChangeApproverPassword_esExports);
// CONCATENATED MODULE: ./src/components/mobile-user/ChangeApproverPassword.vue
function ChangeApproverPassword_injectStyle (ssrContext) {
  __webpack_require__("0y7z")
}
var ChangeApproverPassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeApproverPassword___vue_template_functional__ = false
/* styles */
var ChangeApproverPassword___vue_styles__ = ChangeApproverPassword_injectStyle
/* scopeId */
var ChangeApproverPassword___vue_scopeId__ = "data-v-2ba41340"
/* moduleIdentifier (server only) */
var ChangeApproverPassword___vue_module_identifier__ = null
var ChangeApproverPassword_Component = ChangeApproverPassword_normalizeComponent(
  ChangeApproverPassword,
  mobile_user_ChangeApproverPassword,
  ChangeApproverPassword___vue_template_functional__,
  ChangeApproverPassword___vue_styles__,
  ChangeApproverPassword___vue_scopeId__,
  ChangeApproverPassword___vue_module_identifier__
)

/* harmony default export */ var components_mobile_user_ChangeApproverPassword = (ChangeApproverPassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/workflow/Workflow.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Workflow = ({
  name: 'workflow'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2616e982","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/Workflow.vue
var Workflow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Workflow configuration")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)}
var Workflow_staticRenderFns = []
var Workflow_esExports = { render: Workflow_render, staticRenderFns: Workflow_staticRenderFns }
/* harmony default export */ var workflow_Workflow = (Workflow_esExports);
// CONCATENATED MODULE: ./src/components/workflow/Workflow.vue
function Workflow_injectStyle (ssrContext) {
  __webpack_require__("99qr")
}
var Workflow_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Workflow___vue_template_functional__ = false
/* styles */
var Workflow___vue_styles__ = Workflow_injectStyle
/* scopeId */
var Workflow___vue_scopeId__ = "data-v-2616e982"
/* moduleIdentifier (server only) */
var Workflow___vue_module_identifier__ = null
var Workflow_Component = Workflow_normalizeComponent(
  Workflow,
  workflow_Workflow,
  Workflow___vue_template_functional__,
  Workflow___vue_styles__,
  Workflow___vue_scopeId__,
  Workflow___vue_module_identifier__
)

/* harmony default export */ var components_workflow_Workflow = (Workflow_Component.exports);

// EXTERNAL MODULE: ./node_modules/papaparse/papaparse.js
var papaparse = __webpack_require__("lxTf");
var papaparse_default = /*#__PURE__*/__webpack_require__.n(papaparse);

// EXTERNAL MODULE: ./node_modules/blob/index.js
var node_modules_blob = __webpack_require__("6mly");
var blob_default = /*#__PURE__*/__webpack_require__.n(node_modules_blob);

// EXTERNAL MODULE: ./node_modules/file-saver/FileSaver.js
var FileSaver = __webpack_require__("lDdF");
var FileSaver_default = /*#__PURE__*/__webpack_require__.n(FileSaver);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/workflow/WorkflowDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var WorkflowDetail = ({
  name: 'workflow-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      workflow: {
        companyId: '',
        plantId: '',
        divisionId: '',
        departmentId: '',
        approvalProfileId: ''
      },
      rowsPerPageItems: [10, 15, 25, { text: 'All', value: -1 }],
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'ID',
        align: 'left',
        value: 'id'
      }, {
        text: 'Company code',
        align: 'left',
        value: 'company_code'
      }, {
        text: 'Division',
        align: 'left',
        value: 'division_name'
      }, {
        text: 'Plant',
        align: 'left',
        value: 'plant_code'
      }, {
        text: 'Department',
        align: 'left',
        value: 'department_code'
      }, {
        text: 'Approval profile',
        align: 'left',
        value: 'approval_profile'
      }, {
        text: 'Requisitioner',
        align: 'left',
        value: 'requisitioner'
      }, {
        text: 'Max limit',
        align: 'left',
        value: 'total_value_to'
      }, {
        text: 'Level 1',
        align: 'left',
        value: 'approval_level_1'
      }, {
        text: 'Level 2',
        align: 'left',
        value: 'approval_level_2'
      }, {
        text: 'Level 3',
        align: 'left',
        value: 'approval_level_3'
      }, {
        text: 'Level 4',
        align: 'left',
        value: 'approval_level_4'
      }, {
        text: 'Level 5',
        align: 'left',
        value: 'approval_level_5'
      }, {
        text: 'Level 6',
        align: 'left',
        value: 'approval_level_6'
      }, {
        text: 'Level 7',
        align: 'left',
        value: 'approval_level_7'
      }, {
        text: 'Level 8',
        align: 'left',
        value: 'approval_level_8'
      }],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      csv: []
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchWorkflow', 'deleteWorkflow', 'fetchAllCompanies', 'fetchAllDivisions', 'fetchAllDepartments', 'fetchAllPlants', 'fetchAllApprovalProfiles', 'searchWorkflow']), {

    editWorkflowById: function editWorkflowById(id) {
      this.$router.push({ name: 'changeWorkflow', params: { id: id } });
    },

    deleteWorkflowById: function deleteWorkflowById() {
      var _this = this;

      this.deleteWorkflow(this.selectedId).then(function () {
        _this.dialog = false;
        var response = _this.getResponse;
        _this.snackbar = true;
        _this.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this.color = response.status === 200 ? 'success' : 'error';
      });
    },

    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },

    loadWorkflow: function loadWorkflow() {
      this.fetchWorkflow().then(function () {
        //  do nothing
      }).catch(function (error) {
        console.log(error);
      });
    },

    frmSearch: function frmSearch() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.searchWorkflow(_this2.workflow);
        }
      });
    },

    parseJSONtoCSV: function parseJSONtoCSV() {
      var _this3 = this;

      this.csv = [];
      this.getWorkflow.forEach(function (element) {
        var row = {
          'Company code': null,
          'Plant': null,
          'Division': null,
          'Department': null,
          'Max limit': null,
          'Requisitioner': null,
          'Type': null,
          'Level 1': null,
          'Level 2': null,
          'Level 3': null,
          'Level 4': null,
          'Level 5': null,
          'Level 6': null,
          'Level 7': null,
          'Level 8': null
        };

        row['Company code'] = element.company_code;
        row['Plant'] = element.plant_code;
        row['Division'] = element.division_name;
        row['Department'] = element.department_code;
        row['Max limit'] = element.total_value_to === 0 ? 'Unlimited' : _this3.$options.filters.currency(element.total_value_to);
        row['Requisitioner'] = element.requisitioner;
        row['Type'] = element.type;
        row['Level 1'] = element.approval_level_1 !== 'NULL' ? element.approval_level_1 : '';
        row['Level 2'] = element.approval_level_2 !== 'NULL' ? element.approval_level_2 : '';
        row['Level 3'] = element.approval_level_3 !== 'NULL' ? element.approval_level_3 : '';
        row['Level 4'] = element.approval_level_4 !== 'NULL' ? element.approval_level_4 : '';
        row['Level 5'] = element.approval_level_5 !== 'NULL' ? element.approval_level_5 : '';
        row['Level 6'] = element.approval_level_6 !== 'NULL' ? element.approval_level_6 : '';
        row['Level 7'] = element.approval_level_7 !== 'NULL' ? element.approval_level_7 : '';
        row['Level 8'] = element.approval_level_8 !== 'NULL' ? element.approval_level_8 : '';
        _this3.csv.push(row);
      });
      return papaparse_default.a.unparse(this.csv, { headers: true });
    },
    saveToCSV: function saveToCSV() {
      var blob = new blob_default.a([this.parseJSONtoCSV()], { type: 'text/csv' });
      FileSaver_default.a.saveAs(blob, 'workflow_configuration.csv');
    }
  }),
  mounted: function mounted() {
    this.loadWorkflow();
    this.fetchAllCompanies();
    this.fetchAllDivisions();
    this.fetchAllDepartments();
    this.fetchAllPlants();
    this.fetchAllApprovalProfiles();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getWorkflow', 'getLoading', 'getResponse', 'getAllCompanies', 'getAllDivisions', 'getAllDepartments', 'getAllPlants', 'getApprovalProfiles']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e102855","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/WorkflowDetail.vue
var WorkflowDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected workflow?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected workflow.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.deleteWorkflowById}},[_vm._v("\n              delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();_vm.frmSearch($event)}}},[_c('v-container',{staticClass:"pa-0 ma-0",attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"label":"Company code","item-value":"id","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                      ")]}},{key:"item",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                      ")]}}]),model:{value:(_vm.workflow.companyId),callback:function ($$v) {_vm.$set(_vm.workflow, "companyId", $$v)},expression:"workflow.companyId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllDivisions,"label":"Division","item-value":"id","error-messages":_vm.errors.collect('division'),"data-vv-name":"division","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                      ")]}},{key:"item",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                      ")]}}]),model:{value:(_vm.workflow.divisionId),callback:function ($$v) {_vm.$set(_vm.workflow, "divisionId", $$v)},expression:"workflow.divisionId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllPlants,"label":"Plant","item-value":"id","error-messages":_vm.errors.collect('plant'),"data-vv-name":"plant","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                      ")]}},{key:"item",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                      ")]}}]),model:{value:(_vm.workflow.plantId),callback:function ($$v) {_vm.$set(_vm.workflow, "plantId", $$v)},expression:"workflow.plantId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllDepartments,"label":"Department","item-value":"id","error-messages":_vm.errors.collect('department'),"data-vv-name":"department","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.description)+"\n                      ")]}},{key:"item",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.description)+"\n                      ")]}}]),model:{value:(_vm.workflow.departmentId),callback:function ($$v) {_vm.$set(_vm.workflow, "departmentId", $$v)},expression:"workflow.departmentId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalProfiles,"label":"Approval profile","item-value":"id","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.description)+"\n                      ")]}},{key:"item",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.description)+"\n                      ")]}}]),model:{value:(_vm.workflow.approvalProfileId),callback:function ($$v) {_vm.$set(_vm.workflow, "approvalProfileId", $$v)},expression:"workflow.approvalProfileId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('v-btn',{attrs:{"block":"","color":"grey lighten-3"},on:{"click":function($event){_vm.frmSearch()}}},[_vm._v("search")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('v-btn',{attrs:{"block":"","color":"grey lighten-3"},on:{"click":function($event){_vm.loadWorkflow()}}},[_vm._v("show all")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0",attrs:{"flat":""}},[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent","to":"/workflow/new"}},[_vm._v("new workflow")]),_vm._v(" "),(this.getWorkflow.length > 0)?_c('v-btn',{attrs:{"dark":"","color":"accent"},on:{"click":function($event){_vm.saveToCSV()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cloud_download")]),_vm._v("\n              Download\n            ")],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-card-text',[(!_vm.getLoading)?_c('v-data-table',{attrs:{"loading":"true","headers":_vm.headers,"items":_vm.getWorkflow,"search":_vm.search,"item-key":"id","rows-per-page-items":_vm.rowsPerPageItems},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n                  "+_vm._s(props.header.text)+"\n                ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left",staticStyle:{"min-width":"160px"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editWorkflowById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.company_code))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.division_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.plant_code))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.department_code))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.approval_profile_description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.requisitioner))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.total_value_to === 0 ? "Unlimited" : _vm.$options.filters.currency(props.item.total_value_to))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.approval_level_1 !== 'NULL' ? props.item.approval_level_1 : "-")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.approval_level_2 !== 'NULL' ? props.item.approval_level_2 : "-")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.approval_level_3 !== 'NULL' ? props.item.approval_level_3 : "-")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.approval_level_4 !== 'NULL' ? props.item.approval_level_4 : "-")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.approval_level_5 !== 'NULL' ? props.item.approval_level_5 : "-")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.approval_level_6 !== 'NULL' ? props.item.approval_level_6 : "-")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.approval_level_7 !== 'NULL' ? props.item.approval_level_7 : "-")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.approval_level_8 !== 'NULL' ? props.item.approval_level_8 : "-")+"\n                ")])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e(),_vm._v(" "),(_vm.getLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)],1)],1)}
var WorkflowDetail_staticRenderFns = []
var WorkflowDetail_esExports = { render: WorkflowDetail_render, staticRenderFns: WorkflowDetail_staticRenderFns }
/* harmony default export */ var workflow_WorkflowDetail = (WorkflowDetail_esExports);
// CONCATENATED MODULE: ./src/components/workflow/WorkflowDetail.vue
function WorkflowDetail_injectStyle (ssrContext) {
  __webpack_require__("Rloa")
  __webpack_require__("rsSS")
}
var WorkflowDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WorkflowDetail___vue_template_functional__ = false
/* styles */
var WorkflowDetail___vue_styles__ = WorkflowDetail_injectStyle
/* scopeId */
var WorkflowDetail___vue_scopeId__ = "data-v-4e102855"
/* moduleIdentifier (server only) */
var WorkflowDetail___vue_module_identifier__ = null
var WorkflowDetail_Component = WorkflowDetail_normalizeComponent(
  WorkflowDetail,
  workflow_WorkflowDetail,
  WorkflowDetail___vue_template_functional__,
  WorkflowDetail___vue_styles__,
  WorkflowDetail___vue_scopeId__,
  WorkflowDetail___vue_module_identifier__
)

/* harmony default export */ var components_workflow_WorkflowDetail = (WorkflowDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/workflow/ChangeWorkflow.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangeWorkflow = ({
  name: 'change-workflow',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      workflow: {},
      loader: null,
      snackbar: false,
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  watch: {
    approval_profile_id: function approval_profile_id(val, oldVal) {
      this.fetchApprovalLimits(val);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllCompanies', 'getAllDivisions', 'getAllDepartments', 'getAllPlants', 'getApprovalProfiles', 'getApprovalLimits', 'getApprovalUsers', 'getActiveWorkflow']), {
    approval_profile_id: function approval_profile_id() {
      return this.workflow.approval_profile_id;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllCompanies', 'fetchAllDivisions', 'fetchAllDepartments', 'fetchAllPlants', 'fetchAllApprovalProfiles', 'fetchApprovalLimits', 'fetchApprovalUsers', 'setActiveWorkflow', 'changeWorkflow']), {

    onFormWorkflowSubmit: function onFormWorkflowSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        _this.changeWorkflow(_this.workflow).then(function () {
          var response = _this.getResponse;
          _this.snackbar = true;
          _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
          _this.color = response.status === 200 ? 'success' : 'error';
        });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.fetchAllCompanies();
    this.fetchAllDivisions();
    this.fetchAllDepartments();
    this.fetchAllPlants();
    this.fetchAllApprovalProfiles();
    this.fetchApprovalUsers();
    this.setActiveWorkflow(this.id).then(function () {
      _this2.workflow = assign_default()({}, _this2.getActiveWorkflow);
    }).catch(function (error) {
      console.log(error);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff56114","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/ChangeWorkflow.vue
var ChangeWorkflow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Workflow assignment")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',[_c('v-flex',{staticClass:"subheading grey lighten-3",attrs:{"xs12":""}},[_vm._v("\n                Organization\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"label":"Company code","item-value":"id","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.company_id),callback:function ($$v) {_vm.$set(_vm.workflow, "company_id", $$v)},expression:"workflow.company_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllDivisions,"label":"Division","item-value":"id","error-messages":_vm.errors.collect('division'),"data-vv-name":"division","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.division_id),callback:function ($$v) {_vm.$set(_vm.workflow, "division_id", $$v)},expression:"workflow.division_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllPlants,"label":"Plant","item-value":"id","error-messages":_vm.errors.collect('plant'),"data-vv-name":"plant","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.plant_id),callback:function ($$v) {_vm.$set(_vm.workflow, "plant_id", $$v)},expression:"workflow.plant_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllDepartments,"label":"Department","item-value":"id","error-messages":_vm.errors.collect('department'),"data-vv-name":"department","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"x\n                  ")]}}]),model:{value:(_vm.workflow.department_id),callback:function ($$v) {_vm.$set(_vm.workflow, "department_id", $$v)},expression:"workflow.department_id"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"subheading grey lighten-3",attrs:{"xs12":""}},[_vm._v("\n                Approval profile & Requisitioner\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getApprovalProfiles,"label":"Approval profile","item-value":"id","error-messages":_vm.errors.collect('approval profile'),"data-vv-name":"approval profile","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_profile_id),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_profile_id", $$v)},expression:"workflow.approval_profile_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:12'),expression:"'required|max:12'"}],attrs:{"required":"","label":"Requisitioner","error-messages":_vm.errors.collect('requisitioner'),"data-vv-name":"requisitioner","counter":12,"persistent-hint":"","hint":"e.g. SALE-CRT"},model:{value:(_vm.workflow.requisitioner),callback:function ($$v) {_vm.$set(_vm.workflow, "requisitioner", $$v)},expression:"workflow.requisitioner"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"subheading grey lighten-3",attrs:{"xs12":""}},[_vm._v("\n                Max limit & approvers assignment\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getApprovalLimits,"label":"Max limit","item-value":"id","error-messages":_vm.errors.collect('max limit'),"data-vv-name":"max limit","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(_vm._f("currency")(data.item.total_value_to === 0 ? 'Unlimited' : data.item.total_value_to))+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(_vm._f("currency")(data.item.total_value_to === 0 ? 'Unlimited' : data.item.total_value_to))+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_limit_id),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_limit_id", $$v)},expression:"workflow.approval_limit_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getApprovalUsers,"label":"Level 1","item-value":"employee_id","error-messages":_vm.errors.collect('level 1'),"data-vv-name":"level 1","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_level_1),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_level_1", $$v)},expression:"workflow.approval_level_1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 2","item-value":"employee_id","error-messages":_vm.errors.collect('level 2'),"data-vv-name":"level 2","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_level_2),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_level_2", $$v)},expression:"workflow.approval_level_2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 3","item-value":"employee_id","error-messages":_vm.errors.collect('level 3'),"data-vv-name":"level 3","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_level_3),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_level_3", $$v)},expression:"workflow.approval_level_3"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 4","item-value":"employee_id","error-messages":_vm.errors.collect('level 4'),"data-vv-name":"level 4","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_level_4),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_level_4", $$v)},expression:"workflow.approval_level_4"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 5","item-value":"employee_id","error-messages":_vm.errors.collect('level 5'),"data-vv-name":"level 5","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_level_5),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_level_5", $$v)},expression:"workflow.approval_level_5"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 6","item-value":"employee_id","error-messages":_vm.errors.collect('level 6'),"data-vv-name":"level 6","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_level_6),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_level_6", $$v)},expression:"workflow.approval_level_6"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 7","item-value":"employee_id","error-messages":_vm.errors.collect('level 7'),"data-vv-name":"level 7","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_level_7),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_level_7", $$v)},expression:"workflow.approval_level_7"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 8","item-value":"employee_id","error-messages":_vm.errors.collect('level 8'),"data-vv-name":"level 8","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_level_8),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_level_8", $$v)},expression:"workflow.approval_level_8"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.onFormWorkflowSubmit}},[_vm._v("save\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/workflow"}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeWorkflow_staticRenderFns = []
var ChangeWorkflow_esExports = { render: ChangeWorkflow_render, staticRenderFns: ChangeWorkflow_staticRenderFns }
/* harmony default export */ var workflow_ChangeWorkflow = (ChangeWorkflow_esExports);
// CONCATENATED MODULE: ./src/components/workflow/ChangeWorkflow.vue
function ChangeWorkflow_injectStyle (ssrContext) {
  __webpack_require__("eMzH")
}
var ChangeWorkflow_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeWorkflow___vue_template_functional__ = false
/* styles */
var ChangeWorkflow___vue_styles__ = ChangeWorkflow_injectStyle
/* scopeId */
var ChangeWorkflow___vue_scopeId__ = "data-v-0ff56114"
/* moduleIdentifier (server only) */
var ChangeWorkflow___vue_module_identifier__ = null
var ChangeWorkflow_Component = ChangeWorkflow_normalizeComponent(
  ChangeWorkflow,
  workflow_ChangeWorkflow,
  ChangeWorkflow___vue_template_functional__,
  ChangeWorkflow___vue_styles__,
  ChangeWorkflow___vue_scopeId__,
  ChangeWorkflow___vue_module_identifier__
)

/* harmony default export */ var components_workflow_ChangeWorkflow = (ChangeWorkflow_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/workflow/NewWorkflow.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewWorkflow = ({
  name: 'new-workflow',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      workflow: {
        company_id: '',
        plant_id: '',
        division_id: '',
        department_id: '',
        approval_profile_id: '',
        approval_limit_id: '',
        employee_id_level_1: '',
        employee_id_level_2: '',
        employee_id_level_3: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  watch: {
    approval_profile_id: function approval_profile_id(val, oldVal) {
      this.fetchApprovalLimits(val);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllCompanies', 'getAllDivisions', 'getAllDepartments', 'getAllPlants', 'getApprovalProfiles', 'getApprovalLimits', 'getApprovalUsers']), {
    approval_profile_id: function approval_profile_id() {
      return this.workflow.approval_profile_id;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllCompanies', 'fetchAllDivisions', 'fetchAllDepartments', 'fetchAllPlants', 'fetchAllApprovalProfiles', 'fetchApprovalLimits', 'fetchApprovalUsers', 'addWorkflow']), {
    onFormWorkflowSubmit: function onFormWorkflowSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        _this.addWorkflow(_this.workflow).then(function () {
          var response = _this.getResponse;
          _this.snackbar = true;
          _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
          _this.color = response.status === 200 ? 'success' : 'error';
        });
      });
    },
    setRequisitioner: function setRequisitioner(e) {
      // let id = e.target
      console.log(e);
    }
  }),
  mounted: function mounted() {
    this.fetchAllCompanies();
    this.fetchAllDivisions();
    this.fetchAllDepartments();
    this.fetchAllPlants();
    this.fetchAllApprovalProfiles();
    this.fetchApprovalUsers();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493576e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/NewWorkflow.vue
var NewWorkflow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Workflow assignment")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',[_c('v-flex',{staticClass:"subheading grey lighten-3",attrs:{"xs12":""}},[_vm._v("\n                Organization\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"label":"Company code","item-value":"id","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.company_id),callback:function ($$v) {_vm.$set(_vm.workflow, "company_id", $$v)},expression:"workflow.company_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllDivisions,"label":"Division","item-value":"id","error-messages":_vm.errors.collect('division'),"item-text":"initial","data-vv-name":"division","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.division_id),callback:function ($$v) {_vm.$set(_vm.workflow, "division_id", $$v)},expression:"workflow.division_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllPlants,"label":"Plant","item-value":"id","error-messages":_vm.errors.collect('plant'),"data-vv-name":"plant","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.plant_id),callback:function ($$v) {_vm.$set(_vm.workflow, "plant_id", $$v)},expression:"workflow.plant_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllDepartments,"label":"Department","item-value":"id","error-messages":_vm.errors.collect('department'),"data-vv-name":"department","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                     "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                     "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.department_id),callback:function ($$v) {_vm.$set(_vm.workflow, "department_id", $$v)},expression:"workflow.department_id"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"subheading grey lighten-3",attrs:{"xs12":""}},[_vm._v("\n                Approval profile & Requisitioner\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getApprovalProfiles,"label":"Approval profile","item-value":"id","error-messages":_vm.errors.collect('approval profile'),"data-vv-name":"approval profile","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_profile_id),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_profile_id", $$v)},expression:"workflow.approval_profile_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:12'),expression:"'required|max:12'"}],attrs:{"required":"","label":"Requisitioner","error-messages":_vm.errors.collect('requisitioner'),"data-vv-name":"requisitioner","counter":12,"persistent-hint":"","hint":"e.g. SALE-CRT"},model:{value:(_vm.workflow.requisitioner),callback:function ($$v) {_vm.$set(_vm.workflow, "requisitioner", $$v)},expression:"workflow.requisitioner"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"subheading grey lighten-3",attrs:{"xs12":""}},[_vm._v("\n                Max limit & approvers assignment\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getApprovalLimits,"label":"Max limit","item-value":"id","error-messages":_vm.errors.collect('max limit'),"data-vv-name":"max limit","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(_vm._f("currency")(data.item.total_value_to === 0 ? 'Unlimited' : data.item.total_value_to))+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(_vm._f("currency")(data.item.total_value_to === 0 ? 'Unlimited' : data.item.total_value_to))+"\n                  ")]}}]),model:{value:(_vm.workflow.approval_limit_id),callback:function ($$v) {_vm.$set(_vm.workflow, "approval_limit_id", $$v)},expression:"workflow.approval_limit_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getApprovalUsers,"label":"Level 1","item-value":"employee_id","error-messages":_vm.errors.collect('level 1'),"data-vv-name":"level 1","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.employee_id_level_1),callback:function ($$v) {_vm.$set(_vm.workflow, "employee_id_level_1", $$v)},expression:"workflow.employee_id_level_1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 2","item-value":"employee_id","error-messages":_vm.errors.collect('level 2'),"data-vv-name":"level 2","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.employee_id_level_2),callback:function ($$v) {_vm.$set(_vm.workflow, "employee_id_level_2", $$v)},expression:"workflow.employee_id_level_2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 3","item-value":"employee_id","error-messages":_vm.errors.collect('level 3'),"data-vv-name":"level 3","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.employee_id_level_3),callback:function ($$v) {_vm.$set(_vm.workflow, "employee_id_level_3", $$v)},expression:"workflow.employee_id_level_3"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 4","item-value":"employee_id","error-messages":_vm.errors.collect('level 4'),"data-vv-name":"level 4","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.employee_id_level_4),callback:function ($$v) {_vm.$set(_vm.workflow, "employee_id_level_4", $$v)},expression:"workflow.employee_id_level_4"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 5","item-value":"employee_id","error-messages":_vm.errors.collect('level 5'),"data-vv-name":"level 5","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.employee_id_level_5),callback:function ($$v) {_vm.$set(_vm.workflow, "employee_id_level_5", $$v)},expression:"workflow.employee_id_level_5"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 6","item-value":"employee_id","error-messages":_vm.errors.collect('level 6'),"data-vv-name":"level 6","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.employee_id_level_6),callback:function ($$v) {_vm.$set(_vm.workflow, "employee_id_level_6", $$v)},expression:"workflow.employee_id_level_6"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 7","item-value":"employee_id","error-messages":_vm.errors.collect('level 7'),"data-vv-name":"level 7","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.employee_id_level_7),callback:function ($$v) {_vm.$set(_vm.workflow, "employee_id_level_7", $$v)},expression:"workflow.employee_id_level_7"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getApprovalUsers,"label":"Level 8","item-value":"employee_id","error-messages":_vm.errors.collect('level 8'),"data-vv-name":"level 8","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.employee_id)+" - "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                  ")]}}]),model:{value:(_vm.workflow.employee_id_level_8),callback:function ($$v) {_vm.$set(_vm.workflow, "employee_id_level_8", $$v)},expression:"workflow.employee_id_level_8"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.onFormWorkflowSubmit}},[_vm._v("save\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/workflow"}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var NewWorkflow_staticRenderFns = []
var NewWorkflow_esExports = { render: NewWorkflow_render, staticRenderFns: NewWorkflow_staticRenderFns }
/* harmony default export */ var workflow_NewWorkflow = (NewWorkflow_esExports);
// CONCATENATED MODULE: ./src/components/workflow/NewWorkflow.vue
function NewWorkflow_injectStyle (ssrContext) {
  __webpack_require__("4yKi")
}
var NewWorkflow_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewWorkflow___vue_template_functional__ = false
/* styles */
var NewWorkflow___vue_styles__ = NewWorkflow_injectStyle
/* scopeId */
var NewWorkflow___vue_scopeId__ = "data-v-493576e6"
/* moduleIdentifier (server only) */
var NewWorkflow___vue_module_identifier__ = null
var NewWorkflow_Component = NewWorkflow_normalizeComponent(
  NewWorkflow,
  workflow_NewWorkflow,
  NewWorkflow___vue_template_functional__,
  NewWorkflow___vue_styles__,
  NewWorkflow___vue_scopeId__,
  NewWorkflow___vue_module_identifier__
)

/* harmony default export */ var components_workflow_NewWorkflow = (NewWorkflow_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/division/Division.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Division = ({
  name: 'division'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0813d76b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/division/Division.vue
var Division_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Divisions")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)}
var Division_staticRenderFns = []
var Division_esExports = { render: Division_render, staticRenderFns: Division_staticRenderFns }
/* harmony default export */ var division_Division = (Division_esExports);
// CONCATENATED MODULE: ./src/components/division/Division.vue
function Division_injectStyle (ssrContext) {
  __webpack_require__("7Srh")
}
var Division_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Division___vue_template_functional__ = false
/* styles */
var Division___vue_styles__ = Division_injectStyle
/* scopeId */
var Division___vue_scopeId__ = "data-v-0813d76b"
/* moduleIdentifier (server only) */
var Division___vue_module_identifier__ = null
var Division_Component = Division_normalizeComponent(
  Division,
  division_Division,
  Division___vue_template_functional__,
  Division___vue_styles__,
  Division___vue_scopeId__,
  Division___vue_module_identifier__
)

/* harmony default export */ var components_division_Division = (Division_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/division/DivisionDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DivisionDetail = ({
  name: 'division-detail',
  data: function data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'ID',
        align: 'left',
        value: 'id'
      }, {
        text: 'Description',
        align: 'left',
        value: 'description'
      }, {
        text: 'Initial/Abbreviation',
        align: 'left',
        value: 'initial'
      }],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllDivisions', 'deleteDivision']), {
    /**
     *
     * @param id
     */
    editDivisionById: function editDivisionById(id) {
      this.$router.push({ name: 'changeDivision', params: { id: id } });
    },
    /**
     *
     * @param id
     */
    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },
    /**
     *
     */
    deleteDivisionById: function deleteDivisionById() {
      var _this = this;

      this.deleteDivision(this.selectedId).then(function () {
        _this.dialog = false;
        var response = _this.getResponse;
        _this.snackbar = true;
        _this.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this.color = response.status === 200 ? 'success' : 'error';
      });
    },
    /**
     *
     */
    loadDivisions: function loadDivisions() {
      this.fetchAllDivisions().then(function () {
        //  do nothing
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  mounted: function mounted() {
    this.loadDivisions();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    items: 'getAllDivisions',
    isLoading: 'getLoading',
    getResponse: 'getResponse'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2850dca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/division/DivisionDetail.vue
var DivisionDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected division?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected division.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.deleteDivisionById}},[_vm._v("delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent","to":"/division/new"}},[_vm._v("new division")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(!_vm.isLoading)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n            "+_vm._s(props.header.text)+"\n          ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editDivisionById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.initial))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)}
var DivisionDetail_staticRenderFns = []
var DivisionDetail_esExports = { render: DivisionDetail_render, staticRenderFns: DivisionDetail_staticRenderFns }
/* harmony default export */ var division_DivisionDetail = (DivisionDetail_esExports);
// CONCATENATED MODULE: ./src/components/division/DivisionDetail.vue
function DivisionDetail_injectStyle (ssrContext) {
  __webpack_require__("m0t3")
  __webpack_require__("KcSI")
}
var DivisionDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DivisionDetail___vue_template_functional__ = false
/* styles */
var DivisionDetail___vue_styles__ = DivisionDetail_injectStyle
/* scopeId */
var DivisionDetail___vue_scopeId__ = "data-v-b2850dca"
/* moduleIdentifier (server only) */
var DivisionDetail___vue_module_identifier__ = null
var DivisionDetail_Component = DivisionDetail_normalizeComponent(
  DivisionDetail,
  division_DivisionDetail,
  DivisionDetail___vue_template_functional__,
  DivisionDetail___vue_styles__,
  DivisionDetail___vue_scopeId__,
  DivisionDetail___vue_module_identifier__
)

/* harmony default export */ var components_division_DivisionDetail = (DivisionDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/division/NewDivision.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewDivision = ({
  name: 'new-division',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      division: {
        description: '',
        initial: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    isLoading: 'getLoading',
    getResponse: 'getResponse'
  })),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addNewDivision']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.loader = 'loading';

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.addNewDivision(_this.division).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },
    /**
     *
     */
    clear: function clear() {
      this.division.description = '';
      this.division.initial = '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a802788e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/division/NewDivision.vue
var NewDivision_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("New")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:3'),expression:"'required|max:3'"}],attrs:{"label":"Initial","error-messages":_vm.errors.collect('initial'),"counter":3,"data-vv-name":"initial","required":""},model:{value:(_vm.division.initial),callback:function ($$v) {_vm.$set(_vm.division, "initial", $$v)},expression:"division.initial"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.division.description),callback:function ($$v) {_vm.$set(_vm.division, "description", $$v)},expression:"division.description"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/division"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var NewDivision_staticRenderFns = []
var NewDivision_esExports = { render: NewDivision_render, staticRenderFns: NewDivision_staticRenderFns }
/* harmony default export */ var division_NewDivision = (NewDivision_esExports);
// CONCATENATED MODULE: ./src/components/division/NewDivision.vue
function NewDivision_injectStyle (ssrContext) {
  __webpack_require__("3wPb")
}
var NewDivision_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewDivision___vue_template_functional__ = false
/* styles */
var NewDivision___vue_styles__ = NewDivision_injectStyle
/* scopeId */
var NewDivision___vue_scopeId__ = "data-v-a802788e"
/* moduleIdentifier (server only) */
var NewDivision___vue_module_identifier__ = null
var NewDivision_Component = NewDivision_normalizeComponent(
  NewDivision,
  division_NewDivision,
  NewDivision___vue_template_functional__,
  NewDivision___vue_styles__,
  NewDivision___vue_scopeId__,
  NewDivision___vue_module_identifier__
)

/* harmony default export */ var components_division_NewDivision = (NewDivision_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/division/ChangeDivision.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangeDivision = ({
  name: 'change-division',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      division: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changeDivision', 'setActiveDivision']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.changeDivision(_this.division).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    getResponse: 'getResponse',
    getActiveDivision: 'getActiveDivision',
    isLoading: 'getLoading'
  })),
  mounted: function mounted() {
    var _this2 = this;

    this.setActiveDivision(this.id).then(function () {
      _this2.division = assign_default()({}, _this2.getActiveDivision);
    }).catch(function (error) {
      console.log(error);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fb6f1f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/division/ChangeDivision.vue
var ChangeDivision_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Change")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:3'),expression:"'required|max:3'"}],attrs:{"label":"Initial","error-messages":_vm.errors.collect('initial'),"counter":3,"data-vv-name":"initial","required":""},model:{value:(_vm.division.initial),callback:function ($$v) {_vm.$set(_vm.division, "initial", $$v)},expression:"division.initial"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.division.description),callback:function ($$v) {_vm.$set(_vm.division, "description", $$v)},expression:"division.description"}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("update")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/division"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeDivision_staticRenderFns = []
var ChangeDivision_esExports = { render: ChangeDivision_render, staticRenderFns: ChangeDivision_staticRenderFns }
/* harmony default export */ var division_ChangeDivision = (ChangeDivision_esExports);
// CONCATENATED MODULE: ./src/components/division/ChangeDivision.vue
function ChangeDivision_injectStyle (ssrContext) {
  __webpack_require__("m0LY")
}
var ChangeDivision_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeDivision___vue_template_functional__ = false
/* styles */
var ChangeDivision___vue_styles__ = ChangeDivision_injectStyle
/* scopeId */
var ChangeDivision___vue_scopeId__ = "data-v-8fb6f1f8"
/* moduleIdentifier (server only) */
var ChangeDivision___vue_module_identifier__ = null
var ChangeDivision_Component = ChangeDivision_normalizeComponent(
  ChangeDivision,
  division_ChangeDivision,
  ChangeDivision___vue_template_functional__,
  ChangeDivision___vue_styles__,
  ChangeDivision___vue_scopeId__,
  ChangeDivision___vue_module_identifier__
)

/* harmony default export */ var components_division_ChangeDivision = (ChangeDivision_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/department/Department.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Department = ({
  name: 'department'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a3406b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/department/Department.vue
var Department_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Departments")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)}
var Department_staticRenderFns = []
var Department_esExports = { render: Department_render, staticRenderFns: Department_staticRenderFns }
/* harmony default export */ var department_Department = (Department_esExports);
// CONCATENATED MODULE: ./src/components/department/Department.vue
function Department_injectStyle (ssrContext) {
  __webpack_require__("X1fd")
}
var Department_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Department___vue_template_functional__ = false
/* styles */
var Department___vue_styles__ = Department_injectStyle
/* scopeId */
var Department___vue_scopeId__ = "data-v-03a3406b"
/* moduleIdentifier (server only) */
var Department___vue_module_identifier__ = null
var Department_Component = Department_normalizeComponent(
  Department,
  department_Department,
  Department___vue_template_functional__,
  Department___vue_styles__,
  Department___vue_scopeId__,
  Department___vue_module_identifier__
)

/* harmony default export */ var components_department_Department = (Department_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/department/DepartmentDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DepartmentDetail = ({
  name: 'department-detail',
  data: function data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'ID',
        align: 'left',
        value: 'id'
      }, {
        text: 'Initial',
        align: 'left',
        value: 'initial'
      }, {
        text: 'Description',
        align: 'left',
        value: 'description'
      }],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllDepartments', 'deleteDepartment']), {
    /**
     *
     * @param id
     */
    editDepartmentById: function editDepartmentById(id) {
      this.$router.push({ name: 'changeDepartment', params: { id: id } });
    },
    /**
     *
     * @param id
     */
    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },
    /**
     *
     */
    deleteDepartmentById: function deleteDepartmentById() {
      var _this = this;

      this.deleteDepartment(this.selectedId).then(function () {
        _this.dialog = false;
        var response = _this.getResponse;
        _this.snackbar = true;
        _this.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this.color = response.status === 200 ? 'success' : 'error';
      });
    },
    /**
     *
     */
    loadDepartments: function loadDepartments() {
      this.fetchAllDepartments().then(function () {
        //  do nothing
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  mounted: function mounted() {
    this.loadDepartments();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    items: 'getAllDepartments',
    selectedDivision: 'getDepartmentsById',
    isLoading: 'getLoading',
    getResponse: 'getResponse'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68326c96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/department/DepartmentDetail.vue
var DepartmentDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected department?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected department.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.deleteDepartmentById}},[_vm._v("delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent","to":"/department/new"}},[_vm._v("new department")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(!_vm.isLoading)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n            "+_vm._s(props.header.text)+"\n          ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editDepartmentById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.initial))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.description))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)}
var DepartmentDetail_staticRenderFns = []
var DepartmentDetail_esExports = { render: DepartmentDetail_render, staticRenderFns: DepartmentDetail_staticRenderFns }
/* harmony default export */ var department_DepartmentDetail = (DepartmentDetail_esExports);
// CONCATENATED MODULE: ./src/components/department/DepartmentDetail.vue
function DepartmentDetail_injectStyle (ssrContext) {
  __webpack_require__("i4Wl")
  __webpack_require__("xL8a")
}
var DepartmentDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DepartmentDetail___vue_template_functional__ = false
/* styles */
var DepartmentDetail___vue_styles__ = DepartmentDetail_injectStyle
/* scopeId */
var DepartmentDetail___vue_scopeId__ = "data-v-68326c96"
/* moduleIdentifier (server only) */
var DepartmentDetail___vue_module_identifier__ = null
var DepartmentDetail_Component = DepartmentDetail_normalizeComponent(
  DepartmentDetail,
  department_DepartmentDetail,
  DepartmentDetail___vue_template_functional__,
  DepartmentDetail___vue_styles__,
  DepartmentDetail___vue_scopeId__,
  DepartmentDetail___vue_module_identifier__
)

/* harmony default export */ var components_department_DepartmentDetail = (DepartmentDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/department/NewDepartment.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewDepartment = ({
  name: 'new-department',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      department: {
        initial: '',
        description: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    isLoading: 'getLoading',
    getResponse: 'getResponse'
  })),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addNewDepartment']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.loader = 'loading';

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.addNewDepartment(_this.department).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },
    /**
     *
     */
    clear: function clear() {
      this.department.description = '';
      this.department.initial = '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6e58466","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/department/NewDepartment.vue
var NewDepartment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("New")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5'),expression:"'required|max:5'"}],attrs:{"label":"Inintial","error-messages":_vm.errors.collect('initial'),"data-vv-name":"initial","required":"","counter":5},model:{value:(_vm.department.initial),callback:function ($$v) {_vm.$set(_vm.department, "initial", $$v)},expression:"department.initial"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.department.description),callback:function ($$v) {_vm.$set(_vm.department, "description", $$v)},expression:"department.description"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/department"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var NewDepartment_staticRenderFns = []
var NewDepartment_esExports = { render: NewDepartment_render, staticRenderFns: NewDepartment_staticRenderFns }
/* harmony default export */ var department_NewDepartment = (NewDepartment_esExports);
// CONCATENATED MODULE: ./src/components/department/NewDepartment.vue
function NewDepartment_injectStyle (ssrContext) {
  __webpack_require__("ku0l")
}
var NewDepartment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewDepartment___vue_template_functional__ = false
/* styles */
var NewDepartment___vue_styles__ = NewDepartment_injectStyle
/* scopeId */
var NewDepartment___vue_scopeId__ = "data-v-a6e58466"
/* moduleIdentifier (server only) */
var NewDepartment___vue_module_identifier__ = null
var NewDepartment_Component = NewDepartment_normalizeComponent(
  NewDepartment,
  department_NewDepartment,
  NewDepartment___vue_template_functional__,
  NewDepartment___vue_styles__,
  NewDepartment___vue_scopeId__,
  NewDepartment___vue_module_identifier__
)

/* harmony default export */ var components_department_NewDepartment = (NewDepartment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/department/ChangeDepartment.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangeDepartment = ({
  name: 'change-department',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      department: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changeDepartment', 'setActiveDepartment']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.changeDepartment(_this.department).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    getResponse: 'getResponse',
    getActiveDepartment: 'getActiveDepartment',
    isLoading: 'getLoading'
  })),
  mounted: function mounted() {
    var _this2 = this;

    this.setActiveDepartment(this.id).then(function () {
      _this2.department = assign_default()({}, _this2.getActiveDepartment);
    }).catch(function (error) {
      console.log(error);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7adae79c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/department/ChangeDepartment.vue
var ChangeDepartment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Change")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5'),expression:"'required|max:5'"}],attrs:{"label":"Inintial","error-messages":_vm.errors.collect('initial'),"data-vv-name":"initial","required":"","counter":5},model:{value:(_vm.department.initial),callback:function ($$v) {_vm.$set(_vm.department, "initial", $$v)},expression:"department.initial"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.department.description),callback:function ($$v) {_vm.$set(_vm.department, "description", $$v)},expression:"department.description"}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("update")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/department"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeDepartment_staticRenderFns = []
var ChangeDepartment_esExports = { render: ChangeDepartment_render, staticRenderFns: ChangeDepartment_staticRenderFns }
/* harmony default export */ var department_ChangeDepartment = (ChangeDepartment_esExports);
// CONCATENATED MODULE: ./src/components/department/ChangeDepartment.vue
function ChangeDepartment_injectStyle (ssrContext) {
  __webpack_require__("EmNs")
}
var ChangeDepartment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeDepartment___vue_template_functional__ = false
/* styles */
var ChangeDepartment___vue_styles__ = ChangeDepartment_injectStyle
/* scopeId */
var ChangeDepartment___vue_scopeId__ = "data-v-7adae79c"
/* moduleIdentifier (server only) */
var ChangeDepartment___vue_module_identifier__ = null
var ChangeDepartment_Component = ChangeDepartment_normalizeComponent(
  ChangeDepartment,
  department_ChangeDepartment,
  ChangeDepartment___vue_template_functional__,
  ChangeDepartment___vue_styles__,
  ChangeDepartment___vue_scopeId__,
  ChangeDepartment___vue_module_identifier__
)

/* harmony default export */ var components_department_ChangeDepartment = (ChangeDepartment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/rank/Rank.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Rank = ({
  name: 'rank'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3ca165","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rank/Rank.vue
var Rank_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Release codes")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)}
var Rank_staticRenderFns = []
var Rank_esExports = { render: Rank_render, staticRenderFns: Rank_staticRenderFns }
/* harmony default export */ var rank_Rank = (Rank_esExports);
// CONCATENATED MODULE: ./src/components/rank/Rank.vue
function Rank_injectStyle (ssrContext) {
  __webpack_require__("iTkg")
}
var Rank_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Rank___vue_template_functional__ = false
/* styles */
var Rank___vue_styles__ = Rank_injectStyle
/* scopeId */
var Rank___vue_scopeId__ = "data-v-5b3ca165"
/* moduleIdentifier (server only) */
var Rank___vue_module_identifier__ = null
var Rank_Component = Rank_normalizeComponent(
  Rank,
  rank_Rank,
  Rank___vue_template_functional__,
  Rank___vue_styles__,
  Rank___vue_scopeId__,
  Rank___vue_module_identifier__
)

/* harmony default export */ var components_rank_Rank = (Rank_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/rank/RankDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var RankDetail = ({
  name: 'rank-detail',
  data: function data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      rowsPerPageItems: [10, 15, 25, { text: 'All', value: -1 }],
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'ID',
        align: 'left',
        value: 'id'
      }, {
        text: 'Release code',
        align: 'left',
        value: 'release_code'
      }, {
        text: 'Description',
        align: 'left',
        value: 'description'
      }],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllRanks', 'deleteRank']), {

    editRankById: function editRankById(id) {
      this.$router.push({ name: 'changeReleaseCode', params: { id: id } });
    },

    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },

    deleteRankById: function deleteRankById() {
      var _this = this;

      this.deleteRank(this.selectedId).then(function () {
        _this.dialog = false;
        var response = _this.getResponse;
        _this.snackbar = true;
        _this.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this.color = response.status === 200 ? 'success' : 'error';
      });
    },

    loadRanks: function loadRanks() {
      this.fetchAllRanks().then(function () {
        //  do nothing
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  mounted: function mounted() {
    this.loadRanks();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    items: 'getAllRanks',
    isLoading: 'getLoading',
    getResponse: 'getResponse'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88831f86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rank/RankDetail.vue
var RankDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected release code?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected release code.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.deleteRankById}},[_vm._v("delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent","to":"/release-code/new"}},[_vm._v("new release code")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-card-text',[(!_vm.isLoading)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-key":"id","rows-per-page-items":_vm.rowsPerPageItems},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n                "+_vm._s(props.header.text)+"\n              ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editRankById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.rank_initial))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.description))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1),_vm._v(" "),(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)}
var RankDetail_staticRenderFns = []
var RankDetail_esExports = { render: RankDetail_render, staticRenderFns: RankDetail_staticRenderFns }
/* harmony default export */ var rank_RankDetail = (RankDetail_esExports);
// CONCATENATED MODULE: ./src/components/rank/RankDetail.vue
function RankDetail_injectStyle (ssrContext) {
  __webpack_require__("zfNP")
  __webpack_require__("t5l6")
}
var RankDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RankDetail___vue_template_functional__ = false
/* styles */
var RankDetail___vue_styles__ = RankDetail_injectStyle
/* scopeId */
var RankDetail___vue_scopeId__ = "data-v-88831f86"
/* moduleIdentifier (server only) */
var RankDetail___vue_module_identifier__ = null
var RankDetail_Component = RankDetail_normalizeComponent(
  RankDetail,
  rank_RankDetail,
  RankDetail___vue_template_functional__,
  RankDetail___vue_styles__,
  RankDetail___vue_scopeId__,
  RankDetail___vue_module_identifier__
)

/* harmony default export */ var components_rank_RankDetail = (RankDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/rank/NewRank.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewRank = ({
  name: 'new-rank',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      rank: {
        description: '',
        rank_initial: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    isLoading: 'getLoading',
    getResponse: 'getResponse'
  })),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addNewRank']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.loader = 'loading';

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.addNewRank(_this.rank).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },
    /**
     *
     */
    clear: function clear() {
      this.rank.description = '';
      this.rank.rank_initial = '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb08c18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rank/NewRank.vue
var NewRank_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("New")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Release code","error-messages":_vm.errors.collect('release code'),"data-vv-name":"release code","required":""},model:{value:(_vm.rank.rank_initial),callback:function ($$v) {_vm.$set(_vm.rank, "rank_initial", $$v)},expression:"rank.rank_initial"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.rank.description),callback:function ($$v) {_vm.$set(_vm.rank, "description", $$v)},expression:"rank.description"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/release-code"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var NewRank_staticRenderFns = []
var NewRank_esExports = { render: NewRank_render, staticRenderFns: NewRank_staticRenderFns }
/* harmony default export */ var rank_NewRank = (NewRank_esExports);
// CONCATENATED MODULE: ./src/components/rank/NewRank.vue
function NewRank_injectStyle (ssrContext) {
  __webpack_require__("Qfis")
}
var NewRank_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewRank___vue_template_functional__ = false
/* styles */
var NewRank___vue_styles__ = NewRank_injectStyle
/* scopeId */
var NewRank___vue_scopeId__ = "data-v-4eb08c18"
/* moduleIdentifier (server only) */
var NewRank___vue_module_identifier__ = null
var NewRank_Component = NewRank_normalizeComponent(
  NewRank,
  rank_NewRank,
  NewRank___vue_template_functional__,
  NewRank___vue_styles__,
  NewRank___vue_scopeId__,
  NewRank___vue_module_identifier__
)

/* harmony default export */ var components_rank_NewRank = (NewRank_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/rank/ChangeRank.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangeRank = ({
  name: 'change-rank',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      rank: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changeRank', 'setActiveRank']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.changeRank(_this.rank).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    getResponse: 'getResponse',
    getActiveRank: 'getActiveRank',
    isLoading: 'getLoading'
  })),
  mounted: function mounted() {
    var _this2 = this;

    this.setActiveRank(this.id).then(function () {
      _this2.rank = assign_default()({}, _this2.getActiveRank);
    }).catch(function (error) {
      console.log(error);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29164ffb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rank/ChangeRank.vue
var ChangeRank_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Change")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.rank.description),callback:function ($$v) {_vm.$set(_vm.rank, "description", $$v)},expression:"rank.description"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Initial","error-messages":_vm.errors.collect('initial'),"data-vv-name":"initial","required":""},model:{value:(_vm.rank.rank_initial),callback:function ($$v) {_vm.$set(_vm.rank, "rank_initial", $$v)},expression:"rank.rank_initial"}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("update")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/release-code"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeRank_staticRenderFns = []
var ChangeRank_esExports = { render: ChangeRank_render, staticRenderFns: ChangeRank_staticRenderFns }
/* harmony default export */ var rank_ChangeRank = (ChangeRank_esExports);
// CONCATENATED MODULE: ./src/components/rank/ChangeRank.vue
function ChangeRank_injectStyle (ssrContext) {
  __webpack_require__("U+vW")
}
var ChangeRank_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeRank___vue_template_functional__ = false
/* styles */
var ChangeRank___vue_styles__ = ChangeRank_injectStyle
/* scopeId */
var ChangeRank___vue_scopeId__ = "data-v-29164ffb"
/* moduleIdentifier (server only) */
var ChangeRank___vue_module_identifier__ = null
var ChangeRank_Component = ChangeRank_normalizeComponent(
  ChangeRank,
  rank_ChangeRank,
  ChangeRank___vue_template_functional__,
  ChangeRank___vue_styles__,
  ChangeRank___vue_scopeId__,
  ChangeRank___vue_module_identifier__
)

/* harmony default export */ var components_rank_ChangeRank = (ChangeRank_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/plant/Plant.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Plant = ({
  name: 'plant'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7ddbc96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plant/Plant.vue
var Plant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Plants")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)}
var Plant_staticRenderFns = []
var Plant_esExports = { render: Plant_render, staticRenderFns: Plant_staticRenderFns }
/* harmony default export */ var plant_Plant = (Plant_esExports);
// CONCATENATED MODULE: ./src/components/plant/Plant.vue
function Plant_injectStyle (ssrContext) {
  __webpack_require__("FtE1")
}
var Plant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Plant___vue_template_functional__ = false
/* styles */
var Plant___vue_styles__ = Plant_injectStyle
/* scopeId */
var Plant___vue_scopeId__ = "data-v-b7ddbc96"
/* moduleIdentifier (server only) */
var Plant___vue_module_identifier__ = null
var Plant_Component = Plant_normalizeComponent(
  Plant,
  plant_Plant,
  Plant___vue_template_functional__,
  Plant___vue_styles__,
  Plant___vue_scopeId__,
  Plant___vue_module_identifier__
)

/* harmony default export */ var components_plant_Plant = (Plant_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/plant/PlantDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PlantDetail = ({
  name: 'plant-detail',
  data: function data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'ID',
        align: 'left',
        value: 'id'
      }, {
        text: 'Plant',
        align: 'left',
        value: 'plant'
      }, {
        text: 'Description',
        align: 'left',
        value: 'description'
      }, {
        text: 'Company Code',
        align: 'left',
        value: 'company_code'
      }],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllPlants', 'deletePlant']), {
    /**
     *
     * @param id
     */
    editPlantById: function editPlantById(id) {
      this.$router.push({ name: 'changePlant', params: { id: id } });
    },
    /**
     *
     * @param id
     */
    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },
    /**
     *
     */
    deletePlantById: function deletePlantById() {
      var _this = this;

      this.deletePlant(this.selectedId).then(function () {
        _this.dialog = false;
        var response = _this.getResponse;
        _this.snackbar = true;
        _this.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this.color = response.status === 200 ? 'success' : 'error';
      });
    },
    /**
     *
     */
    loadPlants: function loadPlants() {
      this.fetchAllPlants().then(function () {
        //  do nothing
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  mounted: function mounted() {
    this.loadPlants();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    items: 'getAllPlants',
    isLoading: 'getLoading',
    getResponse: 'getResponse'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf343c1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plant/PlantDetail.vue
var PlantDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected plant?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected plant.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.deletePlantById}},[_vm._v("delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent","to":"/plant/new"}},[_vm._v("new plant")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-card-text',[(!_vm.isLoading)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n                "+_vm._s(props.header.text)+"\n              ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editPlantById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.plant))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.company_code))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1),_vm._v(" "),(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)}
var PlantDetail_staticRenderFns = []
var PlantDetail_esExports = { render: PlantDetail_render, staticRenderFns: PlantDetail_staticRenderFns }
/* harmony default export */ var plant_PlantDetail = (PlantDetail_esExports);
// CONCATENATED MODULE: ./src/components/plant/PlantDetail.vue
function PlantDetail_injectStyle (ssrContext) {
  __webpack_require__("N0om")
  __webpack_require__("yS44")
}
var PlantDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PlantDetail___vue_template_functional__ = false
/* styles */
var PlantDetail___vue_styles__ = PlantDetail_injectStyle
/* scopeId */
var PlantDetail___vue_scopeId__ = "data-v-cf343c1e"
/* moduleIdentifier (server only) */
var PlantDetail___vue_module_identifier__ = null
var PlantDetail_Component = PlantDetail_normalizeComponent(
  PlantDetail,
  plant_PlantDetail,
  PlantDetail___vue_template_functional__,
  PlantDetail___vue_styles__,
  PlantDetail___vue_scopeId__,
  PlantDetail___vue_module_identifier__
)

/* harmony default export */ var components_plant_PlantDetail = (PlantDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/plant/NewPlant.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewPlant = ({
  name: 'new-plant',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      plant: {
        id: '',
        plant: '',
        description: '',
        company_code: '',
        is_active: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    isLoading: 'getLoading',
    getResponse: 'getResponse',
    companies: 'getAllCompanies'
  })),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addNewPlant', 'fetchAllCompanies']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.loader = 'loading';

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.addNewPlant(_this.plant).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },
    /**
     *
     */
    clear: function clear() {
      this.plant.description = '';
      this.plant.plant = '';
    }
  }),
  mounted: function mounted() {
    this.fetchAllCompanies();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7b5a81","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plant/NewPlant.vue
var NewPlant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("New")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:4'),expression:"'required|max:4'"}],attrs:{"label":"Plant","error-messages":_vm.errors.collect('plant'),"counter":4,"data-vv-name":"plant","required":""},model:{value:(_vm.plant.plant),callback:function ($$v) {_vm.$set(_vm.plant, "plant", $$v)},expression:"plant.plant"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.plant.description),callback:function ($$v) {_vm.$set(_vm.plant, "description", $$v)},expression:"plant.description"}}),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.companies,"label":"Company code","item-value":"company_code","chips":"","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n        ")]}},{key:"item",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n        ")]}}]),model:{value:(_vm.plant.company_code),callback:function ($$v) {_vm.$set(_vm.plant, "company_code", $$v)},expression:"plant.company_code"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/plant"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var NewPlant_staticRenderFns = []
var NewPlant_esExports = { render: NewPlant_render, staticRenderFns: NewPlant_staticRenderFns }
/* harmony default export */ var plant_NewPlant = (NewPlant_esExports);
// CONCATENATED MODULE: ./src/components/plant/NewPlant.vue
function NewPlant_injectStyle (ssrContext) {
  __webpack_require__("pfEV")
}
var NewPlant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewPlant___vue_template_functional__ = false
/* styles */
var NewPlant___vue_styles__ = NewPlant_injectStyle
/* scopeId */
var NewPlant___vue_scopeId__ = "data-v-3a7b5a81"
/* moduleIdentifier (server only) */
var NewPlant___vue_module_identifier__ = null
var NewPlant_Component = NewPlant_normalizeComponent(
  NewPlant,
  plant_NewPlant,
  NewPlant___vue_template_functional__,
  NewPlant___vue_styles__,
  NewPlant___vue_scopeId__,
  NewPlant___vue_module_identifier__
)

/* harmony default export */ var components_plant_NewPlant = (NewPlant_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/plant/ChangePlant.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangePlant = ({
  name: 'change-plant',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      plant: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changePlant', 'setActivePlant', 'fetchAllCompanies']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.changePlant(_this.plant).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    getResponse: 'getResponse',
    getActivePlant: 'getActivePlant',
    isLoading: 'getLoading',
    companies: 'getAllCompanies'
  })),
  mounted: function mounted() {
    var _this2 = this;

    this.setActivePlant(this.id).then(function () {
      _this2.plant = assign_default()({}, _this2.getActivePlant);
    }).catch(function (error) {
      console.log(error);
    });
    this.fetchAllCompanies().then(function () {
      //  do nothing
    }).catch(function (error) {
      console.log(error);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d8029a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plant/ChangePlant.vue
var ChangePlant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Change")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:4'),expression:"'required|max:4'"}],attrs:{"label":"Plant","error-messages":_vm.errors.collect('plant'),"counter":4,"data-vv-name":"plant","required":""},model:{value:(_vm.plant.plant),callback:function ($$v) {_vm.$set(_vm.plant, "plant", $$v)},expression:"plant.plant"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.plant.description),callback:function ($$v) {_vm.$set(_vm.plant, "description", $$v)},expression:"plant.description"}}),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.companies,"label":"Company code","item-value":"company_code","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n        ")]}},{key:"item",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n        ")]}}]),model:{value:(_vm.plant.company_code),callback:function ($$v) {_vm.$set(_vm.plant, "company_code", $$v)},expression:"plant.company_code"}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("update")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/plant"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangePlant_staticRenderFns = []
var ChangePlant_esExports = { render: ChangePlant_render, staticRenderFns: ChangePlant_staticRenderFns }
/* harmony default export */ var plant_ChangePlant = (ChangePlant_esExports);
// CONCATENATED MODULE: ./src/components/plant/ChangePlant.vue
function ChangePlant_injectStyle (ssrContext) {
  __webpack_require__("rXGo")
}
var ChangePlant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangePlant___vue_template_functional__ = false
/* styles */
var ChangePlant___vue_styles__ = ChangePlant_injectStyle
/* scopeId */
var ChangePlant___vue_scopeId__ = "data-v-59d8029a"
/* moduleIdentifier (server only) */
var ChangePlant___vue_module_identifier__ = null
var ChangePlant_Component = ChangePlant_normalizeComponent(
  ChangePlant,
  plant_ChangePlant,
  ChangePlant___vue_template_functional__,
  ChangePlant___vue_styles__,
  ChangePlant___vue_scopeId__,
  ChangePlant___vue_module_identifier__
)

/* harmony default export */ var components_plant_ChangePlant = (ChangePlant_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/Profile.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Profile = ({
  name: 'profile'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b017fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("My profile")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('router-view')],1)],1)}
var Profile_staticRenderFns = []
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var user_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/components/user/Profile.vue
function Profile_injectStyle (ssrContext) {
  __webpack_require__("fTaf")
}
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = Profile_injectStyle
/* scopeId */
var Profile___vue_scopeId__ = "data-v-11b017fa"
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  user_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var components_user_Profile = (Profile_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/max-safe-integer.js
var max_safe_integer = __webpack_require__("hiCB");
var max_safe_integer_default = /*#__PURE__*/__webpack_require__.n(max_safe_integer);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-picture-input/PictureInput.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PictureInput = ({
  name: 'picture-input',
  props: {
    width: {
      type: [String, Number],
      default: max_safe_integer_default.a
    },
    height: {
      type: [String, Number],
      default: max_safe_integer_default.a
    },
    margin: {
      type: [String, Number],
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    size: {
      type: [String, Number],
      default: max_safe_integer_default.a
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary button'
    },
    removeButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    aspectButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    prefill: {
      type: [String, File],
      default: ''
    },
    prefillOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    crop: {
      type: Boolean,
      default: true
    },
    radius: {
      type: [String, Number],
      default: 0
    },
    removable: {
      type: Boolean,
      default: false
    },
    hideChangeButton: {
      type: Boolean,
      default: false
    },
    autoToggleAspectRatio: {
      type: Boolean,
      default: false
    },
    toggleAspectRatio: {
      type: Boolean,
      default: false
    },
    changeOnClick: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    alertOnError: {
      type: Boolean,
      default: true
    },
    customStrings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    prefill: function prefill() {
      if (this.prefill) {
        this.preloadImage(this.prefill, this.prefillOptions);
      } else {
        this.removeImage();
      }
    }
  },
  data: function data() {
    return {
      imageSelected: false,
      previewHeight: 0,
      previewWidth: 0,
      draggingOver: false,
      canvasWidth: 0,
      canvasHeight: 0,
      strings: {
        upload: '<p>Your device does not support file uploading.</p>',
        drag: 'Drag an image or <br>click here to select a file',
        tap: 'Tap here to select a photo <br>from your gallery',
        change: 'Change Photo',
        aspect: 'Landscape/Portrait',
        remove: 'Remove Photo',
        select: 'Select a Photo',
        selected: '<p>Photo successfully selected!</p>',
        fileSize: 'The file size exceeds the limit',
        fileType: 'This file type is not supported.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateStrings();
    if (this.prefill) {
      this.preloadImage(this.prefill, this.prefillOptions);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    if (this.supportsPreview) {
      this.pixelRatio = Math.round(window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI);
      var canvas = this.$refs.previewCanvas;
      if (canvas.getContext) {
        this.context = canvas.getContext('2d');
        this.context.scale(this.pixelRatio, this.pixelRatio);
      }
    }
    if (this.accept !== 'image/*') {
      this.fileTypes = this.accept.split(',');
      this.fileTypes = this.fileTypes.map(function (s) {
        return s.trim();
      });
    }

    this.canvasWidth = this.width;
    this.canvasHeight = this.height;

    this.$on('error', this.onError);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.$off('error', this.onError);
  },

  methods: {
    updateStrings: function updateStrings() {
      for (var s in this.customStrings) {
        if (s in this.strings && typeof this.customStrings[s] === 'string') {
          this.strings[s] = this.customStrings[s];
        }
      }
    },
    onClick: function onClick() {
      if (!this.imageSelected) {
        this.selectImage();
        return;
      }

      if (this.changeOnClick) {
        this.selectImage();
      }

      this.$emit('click');
    },
    onResize: function onResize() {
      this.resizeCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }
    },
    onDragStart: function onDragStart() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = true;
    },
    onDragStop: function onDragStop() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = false;
    },
    onFileDrop: function onFileDrop(e) {
      this.onDragStop();
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size <= 0 || files[0].size > this.size * 1024 * 1024) {
        this.$emit('error', {
          type: 'fileSize',
          fileSize: files[0].size,
          fileType: files[0].type,
          fileName: files[0].name,
          message: this.strings.fileSize + ' (' + this.size + 'MB)'
        });
        return;
      }
      if (files[0].name === this.fileName && files[0].size === this.fileSize && this.fileModified === files[0].lastModified) {
        return;
      }

      this.file = files[0];
      this.fileName = files[0].name;
      this.fileSize = files[0].size;
      this.fileModified = files[0].lastModified;
      this.fileType = files[0].type;

      if (this.accept === 'image/*') {
        if (files[0].type.substr(0, 6) !== 'image/') {
          return;
        }
      } else {
        if (this.fileTypes.indexOf(files[0].type) === -1) {
          this.$emit('error', {
            type: 'fileType',
            fileSize: files[0].size,
            fileType: files[0].type,
            fileName: files[0].name,
            message: this.strings.fileType
          });
          return;
        }
      }
      this.imageSelected = true;
      this.image = '';
      if (this.supportsPreview) {
        this.loadImage(files[0], prefill || false);
      } else {
        if (prefill) {
          this.$emit('prefill');
        } else {
          this.$emit('change', this.image);
        }
      }
    },
    onError: function onError(error) {
      if (this.alertOnError) {
        alert(error.message);
      }
    },
    loadImage: function loadImage(file, prefill) {
      var _this2 = this;

      this.getEXIFOrientation(file, function (orientation) {
        _this2.setOrientation(orientation);
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.image = e.target.result;
          if (prefill) {
            _this2.$emit('prefill');
          } else {
            _this2.$emit('change', _this2.image);
          }
          _this2.imageObject = new Image();
          _this2.imageObject.onload = function () {
            if (_this2.autoToggleAspectRatio) {
              var canvasOrientation = _this2.getOrientation(_this2.canvasWidth, _this2.canvasHeight);
              var imageOrientation = _this2.getOrientation(_this2.imageObject.width, _this2.imageObject.height);
              if (canvasOrientation !== imageOrientation) {
                _this2.rotateCanvas();
              }
            }
            _this2.drawImage(_this2.imageObject);
          };
          _this2.imageObject.src = _this2.image;
        };
        reader.readAsDataURL(file);
      });
    },
    drawImage: function drawImage(image) {
      this.imageWidth = image.width;
      this.imageHeight = image.height;
      this.imageRatio = image.width / image.height;
      var offsetX = 0;
      var offsetY = 0;
      var scaledWidth = this.previewWidth;
      var scaledHeight = this.previewHeight;
      var previewRatio = this.previewWidth / this.previewHeight;
      if (this.crop) {
        if (this.imageRatio >= previewRatio) {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        } else {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        }
      } else {
        if (this.imageRatio >= previewRatio) {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        } else {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        }
      }
      var canvas = this.$refs.previewCanvas;
      canvas.style.background = 'none';
      canvas.width = this.previewWidth * this.pixelRatio;
      canvas.height = this.previewHeight * this.pixelRatio;
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      if (this.rotate) {
        this.context.translate(offsetX * this.pixelRatio, offsetY * this.pixelRatio);
        this.context.translate(scaledWidth / 2 * this.pixelRatio, scaledHeight / 2 * this.pixelRatio);
        this.context.rotate(this.rotate);
        offsetX = -scaledWidth / 2;
        offsetY = -scaledHeight / 2;
      }
      this.context.drawImage(image, offsetX * this.pixelRatio, offsetY * this.pixelRatio, scaledWidth * this.pixelRatio, scaledHeight * this.pixelRatio);
    },
    selectImage: function selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage: function removeImage() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.type = '';
      this.$refs.fileInput.type = 'file';
      this.fileName = '';
      this.fileType = '';
      this.fileSize = 0;
      this.fileModified = 0;
      this.imageSelected = false;
      this.image = '';
      this.file = null;
      this.imageObject = null;
      this.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)';
      this.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio;
      this.$emit('remove');
    },
    rotateImage: function rotateImage() {
      this.rotateCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }

      var newOrientation = this.getOrientation(this.canvasWidth, this.canvasHeight);
      this.$emit('aspectratiochange', newOrientation);
    },
    resizeCanvas: function resizeCanvas() {
      var previewRatio = this.canvasWidth / this.canvasHeight;
      var newWidth = this.$refs.container.clientWidth;
      if (!this.toggleAspectRatio && newWidth === this.containerWidth) {
        return;
      }
      this.containerWidth = newWidth;
      this.previewWidth = Math.min(this.containerWidth - this.margin * 2, this.canvasWidth);
      this.previewHeight = this.previewWidth / previewRatio;
    },
    getOrientation: function getOrientation(width, height) {
      var orientation = 'square';

      if (width > height) {
        orientation = 'landscape';
      } else if (width < height) {
        orientation = 'portrait';
      }

      return orientation;
    },
    switchCanvasOrientation: function switchCanvasOrientation() {
      var canvasWidth = this.canvasWidth;
      var canvasHeight = this.canvasHeight;

      this.canvasWidth = canvasHeight;
      this.canvasHeight = canvasWidth;
    },
    rotateCanvas: function rotateCanvas() {
      this.switchCanvasOrientation();
      this.resizeCanvas();
    },
    setOrientation: function setOrientation(orientation) {
      this.rotate = false;
      if (orientation === 8) {
        this.rotate = -Math.PI / 2;
      } else if (orientation === 6) {
        this.rotate = Math.PI / 2;
      } else if (orientation === 3) {
        this.rotate = -Math.PI;
      }
    },
    getEXIFOrientation: function getEXIFOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2);
        }
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file.slice(0, 65536));
    },
    preloadImage: function preloadImage(source, options) {
      var _this4 = this;

      // ie 11 support
      var File = window.File;
      try {
        new File([], ''); // eslint-disable-line
      } catch (e) {
        File = function (_Blob) {
          inherits_default()(File, _Blob);

          function File(chunks, filename) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            classCallCheck_default()(this, File);

            var _this3 = possibleConstructorReturn_default()(this, (File.__proto__ || get_prototype_of_default()(File)).call(this, chunks, opts));

            _this3.lastModifiedDate = new Date();
            _this3.lastModified = +_this3.lastModifiedDate;
            _this3.name = filename;
            return _this3;
          }

          return File;
        }(Blob);
      }
      options = assign_default()({}, options);
      if ((typeof source === 'undefined' ? 'undefined' : typeof_default()(source)) === 'object') {
        this.imageSelected = true;
        this.image = '';
        if (this.supportsPreview) {
          this.loadImage(source, true);
        } else {
          this.$emit('prefill');
        }
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'image/*');
      fetch(source, {
        method: 'GET',
        mode: 'cors',
        headers: headers
      }).then(function (response) {
        return response.blob();
      }).then(function (imageBlob) {
        var e = { target: { files: [] } };
        var fileName = options.fileName || source.split('/').slice(-1)[0];
        var mediaType = options.mediaType || 'image/' + (options.fileType || fileName.split('.').slice(-1)[0]);
        mediaType = mediaType.replace('jpg', 'jpeg');
        e.target.files[0] = new File([imageBlob], fileName, { type: mediaType });
        _this4.onFileChange(e, true);
      }).catch(function (err) {
        _this4.$emit('error', {
          type: 'failedPrefill',
          message: 'Failed loading prefill image: ' + err
        });
      });
    }
  },
  computed: {
    supportsUpload: function supportsUpload() {
      if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
        return false;
      }
      var el = document.createElement('input');
      el.type = 'file';
      return !el.disabled;
    },
    supportsPreview: function supportsPreview() {
      return window.FileReader && !!window.CanvasRenderingContext2D;
    },
    supportsDragAndDrop: function supportsDragAndDrop() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && !('ontouchstart' in window || navigator.msMaxTouchPoints);
    },
    computedClasses: function computedClasses() {
      var classObject = {};
      classObject['dragging-over'] = this.draggingOver;
      return classObject;
    },
    fontSize: function fontSize() {
      return Math.min(0.04 * this.previewWidth, 21) + 'px';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f4c1abe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-picture-input/PictureInput.vue
var PictureInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"picture-input",attrs:{"id":"picture-input"}},[(!_vm.supportsUpload)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.upload)}}):(_vm.supportsPreview)?_c('div',[_c('div',{staticClass:"preview-container",style:({maxWidth: _vm.previewWidth + 'px', height: _vm.previewHeight + 'px', borderRadius: _vm.radius + '%'})},[_c('canvas',{ref:"previewCanvas",staticClass:"picture-preview",class:_vm.computedClasses,style:({height: _vm.previewHeight + 'px', zIndex: _vm.zIndex + 1 }),on:{"drag":function($event){$event.stopPropagation();$event.preventDefault();},"dragover":function($event){$event.stopPropagation();$event.preventDefault();},"dragstart":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStart($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStart($event)},"dragend":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStop($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStop($event)},"drop":function($event){$event.stopPropagation();$event.preventDefault();_vm.onFileDrop($event)},"click":function($event){$event.preventDefault();_vm.onClick($event)}}}),_vm._v(" "),(!_vm.imageSelected && !_vm.plain)?_c('div',{staticClass:"picture-inner",style:({top: -_vm.previewHeight + 'px', marginBottom: -_vm.previewHeight + 'px', fontSize: _vm.fontSize, borderRadius: _vm.radius + '%', zIndex: _vm.zIndex + 2})},[(_vm.supportsDragAndDrop)?_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.drag)}}):_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.tap)}})]):_vm._e()]),_vm._v(" "),(_vm.imageSelected && !_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();_vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.toggleAspectRatio && _vm.width !== _vm.height)?_c('button',{class:_vm.aspectButtonClass,on:{"click":function($event){$event.preventDefault();_vm.rotateImage($event)}}},[_vm._v(_vm._s(_vm.strings.aspect))]):_vm._e()]):_c('div',[(!_vm.imageSelected)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.select))]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.selected)}}),_vm._v(" "),(!_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();_vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e()])]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","name":_vm.name,"id":_vm.id,"accept":_vm.accept},on:{"change":_vm.onFileChange}})])}
var PictureInput_staticRenderFns = []
var PictureInput_esExports = { render: PictureInput_render, staticRenderFns: PictureInput_staticRenderFns }
/* harmony default export */ var vue_picture_input_PictureInput = (PictureInput_esExports);
// CONCATENATED MODULE: ./node_modules/vue-picture-input/PictureInput.vue
function PictureInput_injectStyle (ssrContext) {
  __webpack_require__("t1Ci")
}
var PictureInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PictureInput___vue_template_functional__ = false
/* styles */
var PictureInput___vue_styles__ = PictureInput_injectStyle
/* scopeId */
var PictureInput___vue_scopeId__ = "data-v-2f4c1abe"
/* moduleIdentifier (server only) */
var PictureInput___vue_module_identifier__ = null
var PictureInput_Component = PictureInput_normalizeComponent(
  PictureInput,
  vue_picture_input_PictureInput,
  PictureInput___vue_template_functional__,
  PictureInput___vue_styles__,
  PictureInput___vue_scopeId__,
  PictureInput___vue_module_identifier__
)

/* harmony default export */ var node_modules_vue_picture_input_PictureInput = (PictureInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/ProfileDetail.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ProfileDetail = ({
  name: 'profile-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      user: assign_default()({}, this.$store.state.users.activeUser),
      imagePath: '' + httpInstance.defaults.baseURL + this.$store.state.users.activeUser.normal_photo,
      showImageUploader: false,
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      image: ''
    };
  },

  components: {
    PictureInput: node_modules_vue_picture_input_PictureInput
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getActiveUser', 'getResponse', 'getLoading'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changeUserProfile', 'uploadPicture']), {
    changeProfile: function changeProfile() {
      var _this = this;

      this.changeUserProfile(this.user).then(function () {
        var response = _this.getResponse;
        _this.snackbar = true;
        _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
        _this.color = response.status === 200 ? 'success' : 'error';
      }).catch(function (error) {
        console.log(error);
      });
    },

    onChanged: function onChanged(image) {
      if (image) {
        this.image = image;
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!');
      }
    },
    onCancel: function onCancel() {
      this.image = '';
      this.showImageUploader = false;
    },
    attemptUpload: function attemptUpload() {
      var _this2 = this;

      if (this.image) {
        this.dialog = false;
        this.uploadPicture({ name: 'file', file: this.image }).then(function () {
          _this2.imagePath = '' + httpInstance.defaults.baseURL + _this2.$store.state.users.activeUser.normal_photo;
          var response = _this2.getResponse;
          _this2.showImageUploader = response.status !== 200;
          _this2.snackbar = true;
          _this2.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
          _this2.color = response.status === 200 ? 'success' : 'error';
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a393c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ProfileDetail.vue
var ProfileDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Personal information")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-card-text',[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.showImageUploader)?_c('picture-input',{ref:"pictureInput",attrs:{"width":"192","height":"192","accept":"image/jpeg,image/png, image/gif","size":"10","name":"file","zIndex":0,"hideChangeButton":true},on:{"change":_vm.onChanged}}):_c('v-avatar',{attrs:{"size":"192px","tile":""}},[_c('img',{attrs:{"src":_vm.imagePath}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(!_vm.showImageUploader)?_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showImageUploader = true}}},[_vm._v("\n                        change image\n                      ")]):_vm._e(),_vm._v(" "),(_vm.showImageUploader)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent","disabled":_vm.image === '' ? true : false},nativeOn:{"click":function($event){_vm.attemptUpload($event)}},slot:"activator"},[_c('v-icon',[_vm._v("backup")])],1),_vm._v(" "),_c('span',[_vm._v("Upload")])],1):_vm._e(),_vm._v(" "),(_vm.showImageUploader)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.onCancel()}},slot:"activator"},[_c('v-icon',[_vm._v("clear")])],1),_vm._v(" "),_c('span',[_vm._v("Cancel")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","label":"First name","error-messages":_vm.errors.collect('first name'),"data-vv-name":"first name"},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","label":"Last name","error-messages":_vm.errors.collect('last name'),"data-vv-name":"last name"},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","label":"Employee ID","error-messages":_vm.errors.collect('employee id'),"data-vv-name":"employee id"},model:{value:(_vm.user.employee_id),callback:function ($$v) {_vm.$set(_vm.user, "employee_id", $$v)},expression:"user.employee_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"required":"","label":"E-mail","error-messages":_vm.errors.collect('email'),"data-vv-name":"email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"required":"","label":"Phone","error-messages":_vm.errors.collect('phone'),"data-vv-name":"phone"},model:{value:(_vm.user.phone),callback:function ($$v) {_vm.$set(_vm.user, "phone", $$v)},expression:"user.phone"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"default","to":"/profile/changepassword"}},[_vm._v("change password")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.changeProfile}},[_vm._v("\n              update profile\n            ")])],1)],1)])],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ProfileDetail_staticRenderFns = []
var ProfileDetail_esExports = { render: ProfileDetail_render, staticRenderFns: ProfileDetail_staticRenderFns }
/* harmony default export */ var user_ProfileDetail = (ProfileDetail_esExports);
// CONCATENATED MODULE: ./src/components/user/ProfileDetail.vue
function ProfileDetail_injectStyle (ssrContext) {
  __webpack_require__("DKTr")
}
var ProfileDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ProfileDetail___vue_template_functional__ = false
/* styles */
var ProfileDetail___vue_styles__ = ProfileDetail_injectStyle
/* scopeId */
var ProfileDetail___vue_scopeId__ = "data-v-79a393c4"
/* moduleIdentifier (server only) */
var ProfileDetail___vue_module_identifier__ = null
var ProfileDetail_Component = ProfileDetail_normalizeComponent(
  ProfileDetail,
  user_ProfileDetail,
  ProfileDetail___vue_template_functional__,
  ProfileDetail___vue_styles__,
  ProfileDetail___vue_scopeId__,
  ProfileDetail___vue_module_identifier__
)

/* harmony default export */ var components_user_ProfileDetail = (ProfileDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/ChangePassword.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangePassword = ({
  name: 'change-password',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      e1: true,
      e2: true,
      e3: true,
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      user: {
        old_password: '',
        new_password: '',
        retype_password: ''
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changePassword', 'signOut']), {

    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.changePassword(_this.user).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully. You will be redirected to sign in page in a few seconds...' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
            if (response.status === 200) {
              setTimeout(function () {
                _this.signOut();
              }, 2000);
            }
          });
        }
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7813562","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ChangePassword.vue
var ChangePassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('div',[_c('h1',{staticClass:"title"},[_vm._v("Password")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","hint":"You must provide your current password in order to change it.","persistent-hint":"","label":"Current password","error-messages":_vm.errors.collect('current password'),"data-vv-name":"current password","append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text'},model:{value:(_vm.user.old_password),callback:function ($$v) {_vm.$set(_vm.user, "old_password", $$v)},expression:"user.old_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"required":"","name":"newPassword","label":"New password","error-messages":_vm.errors.collect('new password'),"data-vv-name":"new password","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text'},model:{value:(_vm.user.new_password),callback:function ($$v) {_vm.$set(_vm.user, "new_password", $$v)},expression:"user.new_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:newPassword|min:6'),expression:"'required|confirmed:newPassword|min:6'"}],attrs:{"required":"","label":"Password confirmation","error-messages":_vm.errors.collect('password confirmation'),"data-vv-name":"password confirmation","append-icon":_vm.e3 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e3 = !_vm.e3); },"type":_vm.e3 ? 'password' : 'text'},model:{value:(_vm.user.retype_password),callback:function ($$v) {_vm.$set(_vm.user, "retype_password", $$v)},expression:"user.retype_password"}})],1)],1),_vm._v(" "),_c('div',[_c('span',{staticClass:"caption"},[_vm._v("*After a successful password update, you will be redirected to the login page where you can log in with your new password")])])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"to":"/profile"}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.formSubmit}},[_vm._v("change password\n            ")])],1)],1)])],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangePassword_staticRenderFns = []
var ChangePassword_esExports = { render: ChangePassword_render, staticRenderFns: ChangePassword_staticRenderFns }
/* harmony default export */ var user_ChangePassword = (ChangePassword_esExports);
// CONCATENATED MODULE: ./src/components/user/ChangePassword.vue
function ChangePassword_injectStyle (ssrContext) {
  __webpack_require__("0RwB")
}
var ChangePassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangePassword___vue_template_functional__ = false
/* styles */
var ChangePassword___vue_styles__ = ChangePassword_injectStyle
/* scopeId */
var ChangePassword___vue_scopeId__ = "data-v-a7813562"
/* moduleIdentifier (server only) */
var ChangePassword___vue_module_identifier__ = null
var ChangePassword_Component = ChangePassword_normalizeComponent(
  ChangePassword,
  user_ChangePassword,
  ChangePassword___vue_template_functional__,
  ChangePassword___vue_styles__,
  ChangePassword___vue_scopeId__,
  ChangePassword___vue_module_identifier__
)

/* harmony default export */ var components_user_ChangePassword = (ChangePassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/approval-limit/Limit.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Limit = ({
  name: 'limit'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16c83094","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval-limit/Limit.vue
var Limit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Approval limits")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)}
var Limit_staticRenderFns = []
var Limit_esExports = { render: Limit_render, staticRenderFns: Limit_staticRenderFns }
/* harmony default export */ var approval_limit_Limit = (Limit_esExports);
// CONCATENATED MODULE: ./src/components/approval-limit/Limit.vue
function Limit_injectStyle (ssrContext) {
  __webpack_require__("HWbf")
}
var Limit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Limit___vue_template_functional__ = false
/* styles */
var Limit___vue_styles__ = Limit_injectStyle
/* scopeId */
var Limit___vue_scopeId__ = "data-v-16c83094"
/* moduleIdentifier (server only) */
var Limit___vue_module_identifier__ = null
var Limit_Component = Limit_normalizeComponent(
  Limit,
  approval_limit_Limit,
  Limit___vue_template_functional__,
  Limit___vue_styles__,
  Limit___vue_scopeId__,
  Limit___vue_module_identifier__
)

/* harmony default export */ var components_approval_limit_Limit = (Limit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/approval-limit/LimitDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LimitDetail = ({
  name: 'limit-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      dialogForm: false,
      profile: {
        description: '',
        company_code: ''
      },
      types: [{ type: 'PR', description: 'Purchase requisition' }, { type: 'PO', description: 'Purchase order' }],
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'ID',
        align: 'left',
        value: 'id'
      }, {
        text: 'Description',
        align: 'left',
        value: 'description'
      }, {
        text: 'Company Code',
        align: 'left',
        value: 'company_code'
      }, {
        text: 'Document Type',
        align: 'left',
        value: 'type'
      }],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllApprovalProfiles', 'addApprovalProfile', 'deleteApprovalProfile']), {

    addProfile: function addProfile() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.addApprovalProfile(_this.profile).then(function () {
            _this.dialogForm = false;
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    },

    editPlantById: function editPlantById(id) {
      this.$router.push({ name: 'changeLimit', params: { id: id } });
    },

    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },

    deleteApprovalProfileById: function deleteApprovalProfileById() {
      var _this2 = this;

      this.deleteApprovalProfile(this.selectedId).then(function () {
        _this2.dialog = false;
        var response = _this2.getResponse;
        _this2.snackbar = true;
        _this2.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this2.color = response.status === 200 ? 'success' : 'error';
      });
    },

    loadApprovalProfiles: function loadApprovalProfiles() {
      this.fetchAllApprovalProfiles().then(function () {
        //  do nothing
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  mounted: function mounted() {
    this.loadApprovalProfiles();
    this.fetchAllCompanies();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    items: 'getApprovalProfiles',
    isLoading: 'getLoading',
    getResponse: 'getResponse',
    getAllCompanies: 'getAllCompanies'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dafef70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval-limit/LimitDetail.vue
var LimitDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected profile?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected profile.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.deleteApprovalProfileById}},[_vm._v("delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogForm),callback:function ($$v) {_vm.dialogForm=$$v},expression:"dialogForm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("New Approval Profile")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Profile description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.profile.description),callback:function ($$v) {_vm.$set(_vm.profile, "description", $$v)},expression:"profile.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"label":"Company code","item-value":"company_code","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                      "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                    ")]}},{key:"item",fn:function(data){return [_vm._v("\n                      "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                    ")]}}]),model:{value:(_vm.profile.company_code),callback:function ($$v) {_vm.$set(_vm.profile, "company_code", $$v)},expression:"profile.company_code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.types,"label":"Document type","item-value":"type","error-messages":_vm.errors.collect('document_type'),"data-vv-name":"document_type","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                      "+_vm._s(data.item.type)+" - "+_vm._s(data.item.description)+"\n                    ")]}},{key:"item",fn:function(data){return [_vm._v("\n                      "+_vm._s(data.item.type)+" - "+_vm._s(data.item.description)+"\n                    ")]}}]),model:{value:(_vm.profile.type),callback:function ($$v) {_vm.$set(_vm.profile, "type", $$v)},expression:"profile.type"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialogForm = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.addProfile}},[_vm._v("\n              save\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent"},on:{"click":function($event){_vm.dialogForm = true}}},[_vm._v("new approval limit")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(!_vm.isLoading)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n            "+_vm._s(props.header.text)+"\n          ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editPlantById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.company_code))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.type))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)}
var LimitDetail_staticRenderFns = []
var LimitDetail_esExports = { render: LimitDetail_render, staticRenderFns: LimitDetail_staticRenderFns }
/* harmony default export */ var approval_limit_LimitDetail = (LimitDetail_esExports);
// CONCATENATED MODULE: ./src/components/approval-limit/LimitDetail.vue
function LimitDetail_injectStyle (ssrContext) {
  __webpack_require__("XcLm")
  __webpack_require__("H5Gy")
}
var LimitDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LimitDetail___vue_template_functional__ = false
/* styles */
var LimitDetail___vue_styles__ = LimitDetail_injectStyle
/* scopeId */
var LimitDetail___vue_scopeId__ = "data-v-2dafef70"
/* moduleIdentifier (server only) */
var LimitDetail___vue_module_identifier__ = null
var LimitDetail_Component = LimitDetail_normalizeComponent(
  LimitDetail,
  approval_limit_LimitDetail,
  LimitDetail___vue_template_functional__,
  LimitDetail___vue_styles__,
  LimitDetail___vue_scopeId__,
  LimitDetail___vue_module_identifier__
)

/* harmony default export */ var components_approval_limit_LimitDetail = (LimitDetail_Component.exports);

// CONCATENATED MODULE: ./src/components/approval-limit/NewLimit.vue
var NewLimit_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var NewLimit___vue_template_functional__ = false
/* styles */
var NewLimit___vue_styles__ = null
/* scopeId */
var NewLimit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NewLimit___vue_module_identifier__ = null
var NewLimit_Component = NewLimit_normalizeComponent(
  __vue_script__,
  __vue_template__,
  NewLimit___vue_template_functional__,
  NewLimit___vue_styles__,
  NewLimit___vue_scopeId__,
  NewLimit___vue_module_identifier__
)

/* harmony default export */ var NewLimit = (NewLimit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/approval-limit/ChangeLimit.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangeLimit = ({
  name: 'change-limit',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      selectedId: '',
      profile: {},
      limits: [],
      selected: [],
      types: [{
        type: 'PR',
        description: 'Purchase requisition'
      }, {
        type: 'PO',
        description: 'Purchase order'
      }],
      activeLimit: {
        approval_profile_id: '',
        id: '',
        total_value_from: 0,
        total_value_to: 0,
        is_unlimited: '0'
      },
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'Min. limit',
        align: 'right',
        value: 'total_value_from'
      }, {
        text: 'Max. limit',
        align: 'right',
        value: 'total_value_to'
      }],
      dialog: false,
      dialogForm: false,
      dialogTitle: '',
      isUnlimited: '',
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getActiveApprovalProfile', 'getLoading', 'getApprovalLimits', 'getAllCompanies', 'getResponse', 'getNextMinLimit'])),
  watch: {
    getApprovalLimits: function getApprovalLimits() {
      this.limits = this.getApprovalLimits.slice();
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setActiveApprovalProfile', 'fetchAllCompanies', 'fetchApprovalLimits', 'fetchActiveApprovalProfile', 'deleteApprovalLimit', 'addApprovalLimit', 'changeApprovalLimit', 'changeApprovalProfile']), {

    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },

    toggleDialogForm: function toggleDialogForm(id) {
      if (id) {
        this.dialogTitle = 'Change';
        this.selectedId = id;
        var temp = this.limits.find(function (limit) {
          return limit.id === id;
        });
        this.activeLimit.approval_profile_id = temp.approval_profile_id;
        this.activeLimit.total_value_from = temp.total_value_from;
        this.activeLimit.total_value_to = temp.total_value_to;
        this.activeLimit.is_unlimited = temp.total_value_to === 0 ? '1' : '0';
      } else {
        this.dialogTitle = 'New';
        this.activeLimit.approval_profile_id = this.id;
        this.activeLimit.total_value_from = this.getNextMinLimit;
        this.activeLimit.total_value_to = 0;
        this.activeLimit.is_unlimited = '0';
      }
      this.dialogForm = true;
    },

    onFormProfileSubmit: function onFormProfileSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.changeApprovalProfile(_this.profile).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    },

    newLimit: function newLimit() {
      var _this2 = this;

      this.addApprovalLimit(this.activeLimit).then(function () {
        _this2.dialogForm = false;
        var response = _this2.getResponse;
        _this2.snackbar = true;
        _this2.text = response.status === 200 ? 'Added successfully.' : response.data.message;
        _this2.color = response.status === 200 ? 'success' : 'error';
      });
    },

    changeLimit: function changeLimit() {
      var _this3 = this;

      this.changeApprovalLimit(this.activeLimit).then(function () {
        _this3.dialogForm = false;
        var response = _this3.getResponse;
        _this3.snackbar = true;
        _this3.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
        _this3.color = response.status === 200 ? 'success' : 'error';
      });
    },

    dialogFormSubmit: function dialogFormSubmit() {
      var _this4 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (_this4.dialogTitle === 'Change') {
            _this4.changeLimit();
          } else {
            _this4.newLimit();
          }
        }
      });
    },

    deleteLimitById: function deleteLimitById() {
      var _this5 = this;

      this.deleteApprovalLimit(this.selectedId).then(function () {
        _this5.dialog = false;
        var response = _this5.getResponse;
        _this5.snackbar = true;
        _this5.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this5.color = response.status === 200 ? 'success' : 'error';
      });
    }
  }),
  mounted: function mounted() {
    var _this6 = this;

    if (this.getAllCompanies.length === 0) {
      this.fetchAllCompanies();
    }

    this.fetchActiveApprovalProfile(this.id).then(function () {
      _this6.profile = assign_default()({}, _this6.getActiveApprovalProfile);
      _this6.limits = _this6.getApprovalLimits.slice();
    }).catch(function (error) {
      console.log(error);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a8b3334","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval-limit/ChangeLimit.vue
var ChangeLimit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected approval limit?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected approval limit.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.deleteLimitById}},[_vm._v("delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogForm),callback:function ($$v) {_vm.dialogForm=$$v},expression:"dialogForm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.dialogTitle)+" Approval Limit")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"type":"number","label":"Min. Limit","error-messages":_vm.errors.collect('min limit'),"data-vv-name":"min limit","required":""},model:{value:(_vm.activeLimit.total_value_from),callback:function ($$v) {_vm.$set(_vm.activeLimit, "total_value_from", _vm._n($$v))},expression:"activeLimit.total_value_from"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"type":"number","label":"Max. Limit","error-messages":_vm.errors.collect('max limit'),"data-vv-name":"max limit","required":""},model:{value:(_vm.activeLimit.total_value_to),callback:function ($$v) {_vm.$set(_vm.activeLimit, "total_value_to", _vm._n($$v))},expression:"activeLimit.total_value_to"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Unlimited","light":"","true-value":"1","false-value":"0"},model:{value:(_vm.activeLimit.is_unlimited),callback:function ($$v) {_vm.$set(_vm.activeLimit, "is_unlimited", $$v)},expression:"activeLimit.is_unlimited"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialogForm = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.dialogFormSubmit}},[_vm._v("\n              save\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Approval limits profile")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Profile description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.profile.description),callback:function ($$v) {_vm.$set(_vm.profile, "description", $$v)},expression:"profile.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"label":"Company code","item-value":"company_code","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.profile.company_code),callback:function ($$v) {_vm.$set(_vm.profile, "company_code", $$v)},expression:"profile.company_code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.types,"label":"Document type","item-value":"type","error-messages":_vm.errors.collect('document_type'),"data-vv-name":"document_type","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.type)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.type)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.profile.type),callback:function ($$v) {_vm.$set(_vm.profile, "type", $$v)},expression:"profile.type"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.onFormProfileSubmit}},[_vm._v("update\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/limit"}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Approval limits")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.toggleDialogForm(null)}}},[_vm._v("new limit")])],1),_vm._v(" "),(!_vm.getLoading)?_c('v-data-table',{staticClass:"elevation-0 pb-5",attrs:{"hide-actions":"","loading":"true","headers":_vm.headers,"items":_vm.limits,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n              "+_vm._s(props.header.text)+"\n            ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.toggleDialogForm(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n              "+_vm._s(_vm._f("currency")(props.item.total_value_from))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n              "+_vm._s(props.item.total_value_to === 0 ? 'Unlimited' : (props.item.total_value_to | _vm.currency))+"\n            ")])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeLimit_staticRenderFns = []
var ChangeLimit_esExports = { render: ChangeLimit_render, staticRenderFns: ChangeLimit_staticRenderFns }
/* harmony default export */ var approval_limit_ChangeLimit = (ChangeLimit_esExports);
// CONCATENATED MODULE: ./src/components/approval-limit/ChangeLimit.vue
function ChangeLimit_injectStyle (ssrContext) {
  __webpack_require__("g4Dl")
}
var ChangeLimit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeLimit___vue_template_functional__ = false
/* styles */
var ChangeLimit___vue_styles__ = ChangeLimit_injectStyle
/* scopeId */
var ChangeLimit___vue_scopeId__ = "data-v-1a8b3334"
/* moduleIdentifier (server only) */
var ChangeLimit___vue_module_identifier__ = null
var ChangeLimit_Component = ChangeLimit_normalizeComponent(
  ChangeLimit,
  approval_limit_ChangeLimit,
  ChangeLimit___vue_template_functional__,
  ChangeLimit___vue_styles__,
  ChangeLimit___vue_scopeId__,
  ChangeLimit___vue_module_identifier__
)

/* harmony default export */ var components_approval_limit_ChangeLimit = (ChangeLimit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/company/Company.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Company = ({
  name: 'company'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ba148c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/Company.vue
var Company_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Companies")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)}
var Company_staticRenderFns = []
var Company_esExports = { render: Company_render, staticRenderFns: Company_staticRenderFns }
/* harmony default export */ var company_Company = (Company_esExports);
// CONCATENATED MODULE: ./src/components/company/Company.vue
function Company_injectStyle (ssrContext) {
  __webpack_require__("MSGY")
}
var Company_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Company___vue_template_functional__ = false
/* styles */
var Company___vue_styles__ = Company_injectStyle
/* scopeId */
var Company___vue_scopeId__ = "data-v-d1ba148c"
/* moduleIdentifier (server only) */
var Company___vue_module_identifier__ = null
var Company_Component = Company_normalizeComponent(
  Company,
  company_Company,
  Company___vue_template_functional__,
  Company___vue_styles__,
  Company___vue_scopeId__,
  Company___vue_module_identifier__
)

/* harmony default export */ var components_company_Company = (Company_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/company/CompanyDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CompanyDetail = ({
  name: 'company-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      dialogForm: false,
      headers: [{
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }, {
        text: 'Company Code',
        align: 'left',
        value: 'company_code'
      }, {
        text: 'Description',
        align: 'left',
        value: 'description'
      }],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllCompanies']), {

    editCompanyById: function editCompanyById(id) {
      this.$router.push({ name: 'changeCompany', params: { id: id } });
    },

    toggleDialog: function toggleDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },

    deleteCompanyById: function deleteCompanyById() {
      // this.deleteApprovalProfile(this.selectedId).then(() => {
      //   this.dialog = false
      //   let response = this.getResponse
      //   this.snackbar = true
      //   this.text = (response.status === 200) ? 'Deleted successfully.' : response.data.message
      //   this.color = (response.status === 200) ? 'success' : 'error'
      // })
    },

    loadCompanies: function loadCompanies() {
      this.fetchAllCompanies().then(function () {
        //  do nothing
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  mounted: function mounted() {
    this.loadCompanies();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllCompanies']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-518efd9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/CompanyDetail.vue
var CompanyDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete selected company code?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected company code.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":function($event){_vm.deleteCompanyById()}}},[_vm._v("\n              delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent","to":"/company/new"}},[_vm._v("new company")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(!_vm.getLoading)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.getAllCompanies,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n            "+_vm._s(props.header.text)+"\n          ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editCompanyById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.company_code))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.description))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e(),_vm._v(" "),(_vm.getLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)}
var CompanyDetail_staticRenderFns = []
var CompanyDetail_esExports = { render: CompanyDetail_render, staticRenderFns: CompanyDetail_staticRenderFns }
/* harmony default export */ var company_CompanyDetail = (CompanyDetail_esExports);
// CONCATENATED MODULE: ./src/components/company/CompanyDetail.vue
function CompanyDetail_injectStyle (ssrContext) {
  __webpack_require__("Nh5J")
  __webpack_require__("+nrV")
}
var CompanyDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CompanyDetail___vue_template_functional__ = false
/* styles */
var CompanyDetail___vue_styles__ = CompanyDetail_injectStyle
/* scopeId */
var CompanyDetail___vue_scopeId__ = "data-v-518efd9e"
/* moduleIdentifier (server only) */
var CompanyDetail___vue_module_identifier__ = null
var CompanyDetail_Component = CompanyDetail_normalizeComponent(
  CompanyDetail,
  company_CompanyDetail,
  CompanyDetail___vue_template_functional__,
  CompanyDetail___vue_styles__,
  CompanyDetail___vue_scopeId__,
  CompanyDetail___vue_module_identifier__
)

/* harmony default export */ var components_company_CompanyDetail = (CompanyDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/company/NewCompany.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewCompany = ({
  name: 'new-company',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      company: {
        company_code: '',
        description: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addCompany']), {

    formSubmit: function formSubmit() {
      var _this = this;

      this.loader = 'loading';

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.addCompany(_this.company).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },

    clear: function clear() {
      this.company.description = '';
      this.company.company_code = '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6bec986","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/NewCompany.vue
var NewCompany_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("New")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:4'),expression:"'required|max:4'"}],attrs:{"label":"Company code","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":"","counter":4},model:{value:(_vm.company.company_code),callback:function ($$v) {_vm.$set(_vm.company, "company_code", $$v)},expression:"company.company_code"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.company.description),callback:function ($$v) {_vm.$set(_vm.company, "description", $$v)},expression:"company.description"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":"","loading":_vm.isLoading,"disable":_vm.isLoading},on:{"click":_vm.formSubmit}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/company"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var NewCompany_staticRenderFns = []
var NewCompany_esExports = { render: NewCompany_render, staticRenderFns: NewCompany_staticRenderFns }
/* harmony default export */ var company_NewCompany = (NewCompany_esExports);
// CONCATENATED MODULE: ./src/components/company/NewCompany.vue
function NewCompany_injectStyle (ssrContext) {
  __webpack_require__("y2aF")
}
var NewCompany_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewCompany___vue_template_functional__ = false
/* styles */
var NewCompany___vue_styles__ = NewCompany_injectStyle
/* scopeId */
var NewCompany___vue_scopeId__ = "data-v-d6bec986"
/* moduleIdentifier (server only) */
var NewCompany___vue_module_identifier__ = null
var NewCompany_Component = NewCompany_normalizeComponent(
  NewCompany,
  company_NewCompany,
  NewCompany___vue_template_functional__,
  NewCompany___vue_styles__,
  NewCompany___vue_scopeId__,
  NewCompany___vue_module_identifier__
)

/* harmony default export */ var components_company_NewCompany = (NewCompany_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/company/ChangeCompany.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangeCompany = ({
  name: 'change-company',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      company: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changeCompany', 'setActiveCompany']), {
    /**
     *
     */
    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.changeCompany(_this.company).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getResponse', 'getActiveCompany', 'getLoading'])),
  mounted: function mounted() {
    var _this2 = this;

    this.setActiveCompany(this.id).then(function () {
      _this2.company = assign_default()({}, _this2.getActiveCompany);
    }).catch(function (error) {
      console.log(error);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-012aac68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/ChangeCompany.vue
var ChangeCompany_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Change")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:4'),expression:"'required|max:4'"}],attrs:{"label":"Company code","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":"","counter":4},model:{value:(_vm.company.company_code),callback:function ($$v) {_vm.$set(_vm.company, "company_code", $$v)},expression:"company.company_code"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","error-messages":_vm.errors.collect('description'),"data-vv-name":"description","required":""},model:{value:(_vm.company.description),callback:function ($$v) {_vm.$set(_vm.company, "description", $$v)},expression:"company.description"}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.formSubmit}},[_vm._v("update")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/company"}},[_vm._v("cancel")])],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeCompany_staticRenderFns = []
var ChangeCompany_esExports = { render: ChangeCompany_render, staticRenderFns: ChangeCompany_staticRenderFns }
/* harmony default export */ var company_ChangeCompany = (ChangeCompany_esExports);
// CONCATENATED MODULE: ./src/components/company/ChangeCompany.vue
function ChangeCompany_injectStyle (ssrContext) {
  __webpack_require__("zvnK")
}
var ChangeCompany_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeCompany___vue_template_functional__ = false
/* styles */
var ChangeCompany___vue_styles__ = ChangeCompany_injectStyle
/* scopeId */
var ChangeCompany___vue_scopeId__ = "data-v-012aac68"
/* moduleIdentifier (server only) */
var ChangeCompany___vue_module_identifier__ = null
var ChangeCompany_Component = ChangeCompany_normalizeComponent(
  ChangeCompany,
  company_ChangeCompany,
  ChangeCompany___vue_template_functional__,
  ChangeCompany___vue_styles__,
  ChangeCompany___vue_scopeId__,
  ChangeCompany___vue_module_identifier__
)

/* harmony default export */ var components_company_ChangeCompany = (ChangeCompany_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/report/PrReport.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PrReport = ({
  name: 'pr-report',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      pagination: {},
      totalItems: 0,
      selection: {
        company: null,
        plant: null,
        division: null,
        department: null,
        from_date: null,
        to_date: null,
        page: null
      },
      headers: [{
        text: 'Document No.',
        align: 'left',
        value: 'document_no'
      }, {
        text: 'Line Item',
        align: 'left',
        value: 'item'
      }, {
        text: 'Total Value',
        align: 'left',
        value: 'toval_value'
      }, {
        text: 'Created Date',
        align: 'left',
        value: 'created_at'
      }, {
        text: 'Updated Date',
        align: 'left',
        value: 'updated_at'
      }, {
        text: 'Status',
        align: 'left',
        value: 'status'
      }, {
        text: 'Approver',
        align: 'left',
        value: 'approver'
      }],
      items: [],
      menuFrom: false,
      menuTo: false,
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      loader: null,
      loading3: false,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllCompanies', 'getAllDivisions', 'getAllDepartments', 'getAllPlants', 'getApprovalUsers', 'getPrReport'])),
  watch: {
    pagination: {
      handler: function handler() {
        var _this = this;

        if (this.selection.company) {
          this.selection.page = this.pagination.page;
          this.searchPR(this.selection).then(function () {
            _this.items = assign_default()([], _this.getPrReport.items);
            _this.totalItems = _this.getPrReport.total;
          });
        }
      },

      deep: true
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllCompanies', 'fetchAllDivisions', 'fetchAllDepartments', 'fetchAllPlants', 'fetchApprovalUsers', 'searchPR']), {

    frmSearch: function frmSearch() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.selection.page = _this2.pagination.page;
          _this2.searchPR(_this2.selection).then(function () {
            _this2.items = assign_default()([], _this2.getPrReport.items);
            _this2.totalItems = _this2.getPrReport.total;
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    this.fetchAllCompanies();
    this.fetchAllDivisions();
    this.fetchAllDepartments();
    this.fetchAllPlants();
    this.fetchApprovalUsers();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70075fa3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/PrReport.vue
var PrReport_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("PR summary reports")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{on:{"submit":function($event){$event.preventDefault();_vm.frmSearch($event)}}},[_c('v-container',{staticClass:"pa-0 ma-0",attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"label":"Company code","item-value":"company_code","clearable":"","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.selection.company),callback:function ($$v) {_vm.$set(_vm.selection, "company", $$v)},expression:"selection.company"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getAllDivisions,"label":"Division","item-value":"initial","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.selection.division),callback:function ($$v) {_vm.$set(_vm.selection, "division", $$v)},expression:"selection.division"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getAllPlants,"label":"Plant","item-value":"plant","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.selection.plant),callback:function ($$v) {_vm.$set(_vm.selection, "plant", $$v)},expression:"selection.plant"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getAllDepartments,"label":"Department","item-value":"initial","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.selection.department),callback:function ($$v) {_vm.$set(_vm.selection, "department", $$v)},expression:"selection.department"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{ref:"menuFrom",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.selection.from_date},on:{"update:returnValue":function($event){_vm.$set(_vm.selection, "from_date", $event)}},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"slot":"activator","label":"From date","append-icon":"event","readonly":"","error-messages":_vm.errors.collect('from date'),"data-vv-name":"from date","required":""},slot:"activator",model:{value:(_vm.selection.from_date),callback:function ($$v) {_vm.$set(_vm.selection, "from_date", $$v)},expression:"selection.from_date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"no-title":"","scrollable":"","max":_vm.selection.to_date},model:{value:(_vm.selection.from_date),callback:function ($$v) {_vm.$set(_vm.selection, "from_date", $$v)},expression:"selection.from_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menuFrom = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menuFrom.save(_vm.selection.from_date)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{ref:"menuTo",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.selection.to_date},on:{"update:returnValue":function($event){_vm.$set(_vm.selection, "to_date", $event)}},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"slot":"activator","label":"To date","append-icon":"event","readonly":"","error-messages":_vm.errors.collect('to date'),"data-vv-name":"to date","required":""},slot:"activator",model:{value:(_vm.selection.to_date),callback:function ($$v) {_vm.$set(_vm.selection, "to_date", $$v)},expression:"selection.to_date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"no-title":"","scrollable":"","min":_vm.selection.from_date},model:{value:(_vm.selection.to_date),callback:function ($$v) {_vm.$set(_vm.selection, "to_date", $$v)},expression:"selection.to_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menuTo = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menuTo.save(_vm.selection.to_date)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-btn',{attrs:{"color":"secondary"},on:{"click":function($event){_vm.frmSearch()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("search")]),_vm._v("\n                  search\n                ")],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-key":"id","loading":_vm.getLoading,"rows-per-page-items":[20],"pagination":_vm.pagination,"total-items":_vm.totalItems},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n              "+_vm._s(props.header.text)+"\n            ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.pr_number))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.pr_item_no))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("currency")(props.item.total_value)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_date)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("formatDate")(props.item.updated_date)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.approver))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)],1)}
var PrReport_staticRenderFns = []
var PrReport_esExports = { render: PrReport_render, staticRenderFns: PrReport_staticRenderFns }
/* harmony default export */ var report_PrReport = (PrReport_esExports);
// CONCATENATED MODULE: ./src/components/report/PrReport.vue
function PrReport_injectStyle (ssrContext) {
  __webpack_require__("JUtw")
}
var PrReport_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrReport___vue_template_functional__ = false
/* styles */
var PrReport___vue_styles__ = PrReport_injectStyle
/* scopeId */
var PrReport___vue_scopeId__ = "data-v-70075fa3"
/* moduleIdentifier (server only) */
var PrReport___vue_module_identifier__ = null
var PrReport_Component = PrReport_normalizeComponent(
  PrReport,
  report_PrReport,
  PrReport___vue_template_functional__,
  PrReport___vue_styles__,
  PrReport___vue_scopeId__,
  PrReport___vue_module_identifier__
)

/* harmony default export */ var components_report_PrReport = (PrReport_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/report/PoReport.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PoReport = ({
  name: 'po-report',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      pagination: {},
      totalItems: 0,
      selection: {
        company: null,
        plant: null,
        division: null,
        department: null,
        from_date: null,
        to_date: null,
        page: null
      },
      headers: [{
        text: 'Document No.',
        align: 'left',
        value: 'document_no'
      }, {
        text: 'Total Value',
        align: 'left',
        value: 'toval_value'
      }, {
        text: 'Created Date',
        align: 'left',
        value: 'created_at'
      }, {
        text: 'Updated Date',
        align: 'left',
        value: 'updated_at'
      }, {
        text: 'Status',
        align: 'left',
        value: 'status'
      }, {
        text: 'Approver',
        align: 'left',
        value: 'approver'
      }],
      items: [],
      menuFrom: false,
      menuTo: false,
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      loader: null,
      loading3: false,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllCompanies', 'getAllDivisions', 'getAllDepartments', 'getAllPlants', 'getApprovalUsers', 'getPoReport'])),
  watch: {
    pagination: {
      handler: function handler() {
        var _this = this;

        if (this.selection.company) {
          this.selection.page = this.pagination.page;
          this.searchPO(this.selection).then(function () {
            _this.items = assign_default()([], _this.getPoReport.items);
            _this.totalItems = _this.getPoReport.total;
          });
        }
      },

      deep: true
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllCompanies', 'fetchAllDivisions', 'fetchAllDepartments', 'fetchAllPlants', 'fetchApprovalUsers', 'searchPO']), {

    frmSearch: function frmSearch() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.selection.page = _this2.pagination.page;
          _this2.searchPO(_this2.selection).then(function () {
            _this2.items = assign_default()([], _this2.getPoReport).items;
            _this2.totalItems = _this2.getPoReport.total;
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    this.fetchAllCompanies();
    this.fetchAllDivisions();
    this.fetchAllDepartments();
    this.fetchAllPlants();
    this.fetchApprovalUsers();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9a5efd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/PoReport.vue
var PoReport_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("PO summary reports")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{on:{"submit":function($event){$event.preventDefault();_vm.frmSearch($event)}}},[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"label":"Company code","item-value":"company_code","clearable":"","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.company_code)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.selection.company),callback:function ($$v) {_vm.$set(_vm.selection, "company", $$v)},expression:"selection.company"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getAllDivisions,"label":"Division","item-value":"initial","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.selection.division),callback:function ($$v) {_vm.$set(_vm.selection, "division", $$v)},expression:"selection.division"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getAllPlants,"label":"Plant","item-value":"plant","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.plant)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.selection.plant),callback:function ($$v) {_vm.$set(_vm.selection, "plant", $$v)},expression:"selection.plant"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.getAllDepartments,"label":"Department","item-value":"initial","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}},{key:"item",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.item.initial)+" - "+_vm._s(data.item.description)+"\n                  ")]}}]),model:{value:(_vm.selection.department),callback:function ($$v) {_vm.$set(_vm.selection, "department", $$v)},expression:"selection.department"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{ref:"menuFrom",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.selection.from_date},on:{"update:returnValue":function($event){_vm.$set(_vm.selection, "from_date", $event)}},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"slot":"activator","label":"From date","append-icon":"event","readonly":"","error-messages":_vm.errors.collect('from date'),"data-vv-name":"from date","required":""},slot:"activator",model:{value:(_vm.selection.from_date),callback:function ($$v) {_vm.$set(_vm.selection, "from_date", $$v)},expression:"selection.from_date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"no-title":"","scrollable":"","max":_vm.selection.to_date},model:{value:(_vm.selection.from_date),callback:function ($$v) {_vm.$set(_vm.selection, "from_date", $$v)},expression:"selection.from_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menuFrom = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menuFrom.save(_vm.selection.from_date)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{ref:"menuTo",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.selection.to_date},on:{"update:returnValue":function($event){_vm.$set(_vm.selection, "to_date", $event)}},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"slot":"activator","label":"To date","append-icon":"event","readonly":"","error-messages":_vm.errors.collect('to date'),"data-vv-name":"to date","required":""},slot:"activator",model:{value:(_vm.selection.to_date),callback:function ($$v) {_vm.$set(_vm.selection, "to_date", $$v)},expression:"selection.to_date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"no-title":"","scrollable":"","min":_vm.selection.from_date},model:{value:(_vm.selection.to_date),callback:function ($$v) {_vm.$set(_vm.selection, "to_date", $$v)},expression:"selection.to_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menuTo = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menuTo.save(_vm.selection.to_date)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-btn',{attrs:{"color":"secondary"},on:{"click":function($event){_vm.frmSearch()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("search")]),_vm._v("\n                  search\n                ")],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-key":"id","loading":_vm.getLoading,"rows-per-page-items":[20],"pagination":_vm.pagination,"total-items":_vm.totalItems},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n              "+_vm._s(props.header.text)+"\n            ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.po_number))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("currency")(props.item.total_value)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_date)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("formatDate")(props.item.updated_date)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.approver))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)],1)}
var PoReport_staticRenderFns = []
var PoReport_esExports = { render: PoReport_render, staticRenderFns: PoReport_staticRenderFns }
/* harmony default export */ var report_PoReport = (PoReport_esExports);
// CONCATENATED MODULE: ./src/components/report/PoReport.vue
function PoReport_injectStyle (ssrContext) {
  __webpack_require__("7+7V")
}
var PoReport_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PoReport___vue_template_functional__ = false
/* styles */
var PoReport___vue_styles__ = PoReport_injectStyle
/* scopeId */
var PoReport___vue_scopeId__ = "data-v-3f9a5efd"
/* moduleIdentifier (server only) */
var PoReport___vue_module_identifier__ = null
var PoReport_Component = PoReport_normalizeComponent(
  PoReport,
  report_PoReport,
  PoReport___vue_template_functional__,
  PoReport___vue_styles__,
  PoReport___vue_scopeId__,
  PoReport___vue_module_identifier__
)

/* harmony default export */ var components_report_PoReport = (PoReport_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin-user/Admin.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Admin = ({
  name: 'admin'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10918352","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin-user/Admin.vue
var Admin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"display-1 mb-3"},[_vm._v("Admin users")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)}
var Admin_staticRenderFns = []
var Admin_esExports = { render: Admin_render, staticRenderFns: Admin_staticRenderFns }
/* harmony default export */ var admin_user_Admin = (Admin_esExports);
// CONCATENATED MODULE: ./src/components/admin-user/Admin.vue
function Admin_injectStyle (ssrContext) {
  __webpack_require__("KjLl")
}
var Admin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Admin___vue_template_functional__ = false
/* styles */
var Admin___vue_styles__ = Admin_injectStyle
/* scopeId */
var Admin___vue_scopeId__ = "data-v-10918352"
/* moduleIdentifier (server only) */
var Admin___vue_module_identifier__ = null
var Admin_Component = Admin_normalizeComponent(
  Admin,
  admin_user_Admin,
  Admin___vue_template_functional__,
  Admin___vue_styles__,
  Admin___vue_scopeId__,
  Admin___vue_module_identifier__
)

/* harmony default export */ var components_admin_user_Admin = (Admin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin-user/AdminDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AdminDetail = ({
  name: 'admin-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      selectedEmployeeId: '',
      dialog: false,
      dialogForm: false,
      rowsPerPageItems: [10, 20, 40, { text: 'All', value: -1 }],
      headers: [{
        text: 'Actions',
        align: 'left',
        sortable: false
      }, {
        text: 'Employee ID',
        align: 'left',
        value: 'employee_id'
      }, {
        text: 'First name',
        align: 'left',
        value: 'first_name'
      }, {
        text: 'Last name',
        align: 'left',
        value: 'last_name'
      }, {
        text: 'Email',
        align: 'left',
        value: 'email'
      }, {
        text: 'Phone number',
        align: 'left',
        value: 'phone'
      }],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchAllAdminUsers', 'deleteAdminUser']), {

    editAdminById: function editAdminById(id) {
      this.$router.push({ name: 'changeAdmin', params: { id: id } });
    },

    toggleDialog: function toggleDialog(id, employeeId) {
      this.selectedId = id;
      this.selectedEmployeeId = employeeId;
      this.dialog = true;
    },

    deleteCompanyById: function deleteCompanyById() {
      var _this = this;

      this.deleteAdminUser(this.selectedId).then(function () {
        _this.dialog = false;
        var response = _this.getResponse;
        _this.snackbar = true;
        _this.text = response.status === 200 ? 'Deleted successfully.' : response.data.message;
        _this.color = response.status === 200 ? 'success' : 'error';
      });
    }
  }),
  mounted: function mounted() {
    this.fetchAllAdminUsers();
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllCompanies']), {
    admin_users: function admin_users() {
      return this.$store.state.admin.admin_users;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfadf59","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin-user/AdminDetail.vue
var AdminDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete admin user "+_vm._s(_vm.selectedEmployeeId)+"?")]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-left"},[_vm._v("You are going to delete this selected admin user.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":"","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":function($event){_vm.deleteCompanyById()}}},[_vm._v("\n              delete\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Details")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","color":"accent","to":"/admin/new"}},[_vm._v("new admin user")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(!_vm.getLoading)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":"true","headers":_vm.headers,"items":_vm.admin_users,"search":_vm.search,"item-key":"id","rows-per-page-items":_vm.rowsPerPageItems},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v("\n            "+_vm._s(props.header.text)+"\n          ")])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent lighten-1"},on:{"click":function($event){_vm.editAdminById(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Change")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"error lighten-1"},on:{"click":function($event){_vm.toggleDialog(props.item.id, props.item.employee_id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.employee_id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("phone")(props.item.phone)))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e(),_vm._v(" "),(_vm.getLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)],1)}
var AdminDetail_staticRenderFns = []
var AdminDetail_esExports = { render: AdminDetail_render, staticRenderFns: AdminDetail_staticRenderFns }
/* harmony default export */ var admin_user_AdminDetail = (AdminDetail_esExports);
// CONCATENATED MODULE: ./src/components/admin-user/AdminDetail.vue
function AdminDetail_injectStyle (ssrContext) {
  __webpack_require__("HUqv")
  __webpack_require__("HOju")
}
var AdminDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AdminDetail___vue_template_functional__ = false
/* styles */
var AdminDetail___vue_styles__ = AdminDetail_injectStyle
/* scopeId */
var AdminDetail___vue_scopeId__ = "data-v-2cfadf59"
/* moduleIdentifier (server only) */
var AdminDetail___vue_module_identifier__ = null
var AdminDetail_Component = AdminDetail_normalizeComponent(
  AdminDetail,
  admin_user_AdminDetail,
  AdminDetail___vue_template_functional__,
  AdminDetail___vue_styles__,
  AdminDetail___vue_scopeId__,
  AdminDetail___vue_module_identifier__
)

/* harmony default export */ var components_admin_user_AdminDetail = (AdminDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin-user/NewAdmin.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewAdmin = ({
  name: 'new-admin',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      admin: {
        company_code: [],
        employee_id: '',
        email: '',
        password: '',
        retype_password: '',
        first_name: '',
        last_name: '',
        phone: ''
      },
      accessMenu: {
        auth_id: '',
        menu_sub_id: []
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      e2: true,
      e3: true
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllCompanies', 'getAllowedMenuItems'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addNewAdminUser', 'fetchAllCompanies', 'fetchMenuItems']), {
    clear: function clear() {
      this.$refs.form.reset();
      this.$validator.reset();
    },


    onFormSubmit: function onFormSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var payload = { admin: _this.admin, menu: _this.accessMenu };
          _this.addNewAdminUser(payload).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Added successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
            if (response.status === 200) {
              _this.clear();
            }
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    if (this.getAllCompanies.length === 0) {
      this.fetchAllCompanies();
    }

    if (this.getAllowedMenuItems.length === 0) {
      this.fetchMenuItems();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b313d32e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin-user/NewAdmin.vue
var NewAdmin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Create new admin user")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Employee ID","error-messages":_vm.errors.collect('employee id'),"data-vv-name":"employee id","required":""},model:{value:(_vm.admin.employee_id),callback:function ($$v) {_vm.$set(_vm.admin, "employee_id", $$v)},expression:"admin.employee_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"First name","error-messages":_vm.errors.collect('first name'),"data-vv-name":"first name","required":""},model:{value:(_vm.admin.first_name),callback:function ($$v) {_vm.$set(_vm.admin, "first_name", $$v)},expression:"admin.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Last name","error-messages":_vm.errors.collect('last name'),"data-vv-name":"last name","required":""},model:{value:(_vm.admin.last_name),callback:function ($$v) {_vm.$set(_vm.admin, "last_name", $$v)},expression:"admin.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"E-mail","error-messages":_vm.errors.collect('email'),"data-vv-name":"email","required":"","hint":"e.g. your.name@example.com","persistent-hint":""},model:{value:(_vm.admin.email),callback:function ($$v) {_vm.$set(_vm.admin, "email", $$v)},expression:"admin.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"label":"Phone number","error-messages":_vm.errors.collect('phone number'),"data-vv-name":"phone number","required":"","mask":"+### ## ### ####","hint":"e.g. +855 10 123 4567","persistent-hint":""},model:{value:(_vm.admin.phone),callback:function ($$v) {_vm.$set(_vm.admin, "phone", $$v)},expression:"admin.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"required":"","label":"Password","name":"password","error-messages":_vm.errors.collect('password'),"data-vv-name":"password","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text'},model:{value:(_vm.admin.password),callback:function ($$v) {_vm.$set(_vm.admin, "password", $$v)},expression:"admin.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:password|min:6'),expression:"'required|confirmed:password|min:6'"}],attrs:{"required":"","label":"Password confirmation","error-messages":_vm.errors.collect('password confirmation'),"data-vv-name":"password confirmation","append-icon":_vm.e3 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e3 = !_vm.e3); },"type":_vm.e3 ? 'password' : 'text'},model:{value:(_vm.admin.retype_password),callback:function ($$v) {_vm.$set(_vm.admin, "retype_password", $$v)},expression:"admin.retype_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"item-text":"description","item-value":"company_code","label":"Company code","multiple":"","chips":"","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","hint":"Assign this admin to one or more company code","persistent-hint":"","required":""},model:{value:(_vm.admin.company_code),callback:function ($$v) {_vm.$set(_vm.admin, "company_code", $$v)},expression:"admin.company_code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllowedMenuItems,"item-text":"title","item-value":"id","label":"Accessible menu","multiple":"","chips":"","error-messages":_vm.errors.collect('accessible menu'),"data-vv-name":"accessible menu","hint":"Assign this admin to one or more menu. <i>Dashboard</i> and <i>My profile</i> menu will be default to all user.","persistent-hint":"","required":""},model:{value:(_vm.accessMenu.menu_sub_id),callback:function ($$v) {_vm.$set(_vm.accessMenu, "menu_sub_id", $$v)},expression:"accessMenu.menu_sub_id"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.onFormSubmit}},[_vm._v("save\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent"},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/admin","light":""}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var NewAdmin_staticRenderFns = []
var NewAdmin_esExports = { render: NewAdmin_render, staticRenderFns: NewAdmin_staticRenderFns }
/* harmony default export */ var admin_user_NewAdmin = (NewAdmin_esExports);
// CONCATENATED MODULE: ./src/components/admin-user/NewAdmin.vue
function NewAdmin_injectStyle (ssrContext) {
  __webpack_require__("NvIb")
}
var NewAdmin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewAdmin___vue_template_functional__ = false
/* styles */
var NewAdmin___vue_styles__ = NewAdmin_injectStyle
/* scopeId */
var NewAdmin___vue_scopeId__ = "data-v-b313d32e"
/* moduleIdentifier (server only) */
var NewAdmin___vue_module_identifier__ = null
var NewAdmin_Component = NewAdmin_normalizeComponent(
  NewAdmin,
  admin_user_NewAdmin,
  NewAdmin___vue_template_functional__,
  NewAdmin___vue_styles__,
  NewAdmin___vue_scopeId__,
  NewAdmin___vue_module_identifier__
)

/* harmony default export */ var components_admin_user_NewAdmin = (NewAdmin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin-user/ChangeAdmin.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangeAdmin = ({
  name: 'change-admin',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      admin: {},
      menu: [],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      e2: true,
      e3: true
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse', 'getAllCompanies', 'getAllowedMenuItems', 'getAccessibleMenu'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changeAdminUser', 'fetchAllCompanies', 'setActiveAdmin', 'fetchMenuItems']), {
    clear: function clear() {
      this.$refs.form.reset();
      this.$validator.reset();
    },


    onFormSubmit: function onFormSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var payload = {
            admin: _this.admin,
            menu: _this.menu
          };
          _this.changeAdminUser(payload).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    },

    editAdminPasswordById: function editAdminPasswordById(id) {
      this.$router.push({ name: 'changeAdminPassword', params: { id: id } });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    if (this.getAllCompanies.length === 0) {
      this.fetchAllCompanies();
    }

    if (this.getAllowedMenuItems.length === 0) {
      this.fetchMenuItems();
    }

    this.setActiveAdmin(this.id).then(function () {
      _this2.admin = assign_default()({}, _this2.$store.state.admin.admin_user);
      _this2.menu = assign_default()([], _this2.getAccessibleMenu);
    }).catch(function (error) {
      console.log(error);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c6583aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin-user/ChangeAdmin.vue
var ChangeAdmin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Change")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Employee ID","error-messages":_vm.errors.collect('employee id'),"data-vv-name":"employee id","required":""},model:{value:(_vm.admin.employee_id),callback:function ($$v) {_vm.$set(_vm.admin, "employee_id", $$v)},expression:"admin.employee_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"First name","error-messages":_vm.errors.collect('first name'),"data-vv-name":"first name","required":""},model:{value:(_vm.admin.first_name),callback:function ($$v) {_vm.$set(_vm.admin, "first_name", $$v)},expression:"admin.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Last name","error-messages":_vm.errors.collect('last name'),"data-vv-name":"last name","required":""},model:{value:(_vm.admin.last_name),callback:function ($$v) {_vm.$set(_vm.admin, "last_name", $$v)},expression:"admin.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"E-mail","error-messages":_vm.errors.collect('email'),"data-vv-name":"email","required":"","hint":"e.g. your.name@example.com","persistent-hint":""},model:{value:(_vm.admin.email),callback:function ($$v) {_vm.$set(_vm.admin, "email", $$v)},expression:"admin.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"label":"Phone number","error-messages":_vm.errors.collect('phone number'),"data-vv-name":"phone number","required":"","mask":"+### ## ### ####","hint":"e.g. +855 10 123 4567","persistent-hint":""},model:{value:(_vm.admin.phone),callback:function ($$v) {_vm.$set(_vm.admin, "phone", $$v)},expression:"admin.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllCompanies,"item-text":"description","item-value":"company_code","label":"Company code","multiple":"","chips":"","error-messages":_vm.errors.collect('company code'),"data-vv-name":"company code","hint":"Assign this admin to one or more company code","persistent-hint":"","required":""},model:{value:(_vm.admin.company_code),callback:function ($$v) {_vm.$set(_vm.admin, "company_code", $$v)},expression:"admin.company_code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.getAllowedMenuItems,"item-text":"title","item-value":"id","label":"Accessible menu","multiple":"","chips":"","error-messages":_vm.errors.collect('accessible menu'),"data-vv-name":"accessible menu","hint":"Assign this admin to one or more menu. <i>Dashboard</i> and <i>My profile</i> menu will be default to all user.","persistent-hint":"","required":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"accent"},on:{"click":function($event){_vm.editAdminPasswordById(_vm.id)}}},[_vm._v("change password")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":function($event){_vm.onFormSubmit()}}},[_vm._v("update\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary"},on:{"click":function($event){_vm.clear()}}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/admin"}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeAdmin_staticRenderFns = []
var ChangeAdmin_esExports = { render: ChangeAdmin_render, staticRenderFns: ChangeAdmin_staticRenderFns }
/* harmony default export */ var admin_user_ChangeAdmin = (ChangeAdmin_esExports);
// CONCATENATED MODULE: ./src/components/admin-user/ChangeAdmin.vue
function ChangeAdmin_injectStyle (ssrContext) {
  __webpack_require__("a1z8")
}
var ChangeAdmin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeAdmin___vue_template_functional__ = false
/* styles */
var ChangeAdmin___vue_styles__ = ChangeAdmin_injectStyle
/* scopeId */
var ChangeAdmin___vue_scopeId__ = "data-v-2c6583aa"
/* moduleIdentifier (server only) */
var ChangeAdmin___vue_module_identifier__ = null
var ChangeAdmin_Component = ChangeAdmin_normalizeComponent(
  ChangeAdmin,
  admin_user_ChangeAdmin,
  ChangeAdmin___vue_template_functional__,
  ChangeAdmin___vue_styles__,
  ChangeAdmin___vue_scopeId__,
  ChangeAdmin___vue_module_identifier__
)

/* harmony default export */ var components_admin_user_ChangeAdmin = (ChangeAdmin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin-user/ChangeAdminPassword.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangeAdminPassword = ({
  name: 'change-password',
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      e2: true,
      e3: true,
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      admin: {
        new_password: '',
        retype_password: ''
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLoading', 'getResponse'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['changeAdminPassword']), {

    formSubmit: function formSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var payload = {
            id: _this.id,
            admin: _this.admin
          };
          _this.changeAdminPassword(payload).then(function () {
            var response = _this.getResponse;
            _this.snackbar = true;
            _this.text = response.status === 200 ? 'Changed successfully.' : response.data.message;
            _this.color = response.status === 200 ? 'success' : 'error';
          });
        }
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af165a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin-user/ChangeAdminPassword.vue
var ChangeAdminPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('v-card-title',[_c('div',[_c('h1',{staticClass:"title"},[_vm._v("Password")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"required":"","name":"newPassword","label":"New password","error-messages":_vm.errors.collect('new password'),"data-vv-name":"new password","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text'},model:{value:(_vm.admin.new_password),callback:function ($$v) {_vm.$set(_vm.admin, "new_password", $$v)},expression:"admin.new_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:newPassword|min:6'),expression:"'required|confirmed:newPassword|min:6'"}],attrs:{"required":"","label":"Password confirmation","error-messages":_vm.errors.collect('password confirmation'),"data-vv-name":"password confirmation","append-icon":_vm.e3 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e3 = !_vm.e3); },"type":_vm.e3 ? 'password' : 'text'},model:{value:(_vm.admin.retype_password),callback:function ($$v) {_vm.$set(_vm.admin, "retype_password", $$v)},expression:"admin.retype_password"}})],1)],1),_vm._v(" "),_c('div',[_c('span',{staticClass:"caption"},[_vm._v("*After password reset, the new password will be effective next time user log in.")])])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"accent","loading":_vm.getLoading,"disable":_vm.getLoading},on:{"click":_vm.formSubmit}},[_vm._v("update")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/admin"}},[_vm._v("cancel")])],1)],1)])],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":"","right":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)}
var ChangeAdminPassword_staticRenderFns = []
var ChangeAdminPassword_esExports = { render: ChangeAdminPassword_render, staticRenderFns: ChangeAdminPassword_staticRenderFns }
/* harmony default export */ var admin_user_ChangeAdminPassword = (ChangeAdminPassword_esExports);
// CONCATENATED MODULE: ./src/components/admin-user/ChangeAdminPassword.vue
function ChangeAdminPassword_injectStyle (ssrContext) {
  __webpack_require__("IcqS")
}
var ChangeAdminPassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangeAdminPassword___vue_template_functional__ = false
/* styles */
var ChangeAdminPassword___vue_styles__ = ChangeAdminPassword_injectStyle
/* scopeId */
var ChangeAdminPassword___vue_scopeId__ = "data-v-7af165a4"
/* moduleIdentifier (server only) */
var ChangeAdminPassword___vue_module_identifier__ = null
var ChangeAdminPassword_Component = ChangeAdminPassword_normalizeComponent(
  ChangeAdminPassword,
  admin_user_ChangeAdminPassword,
  ChangeAdminPassword___vue_template_functional__,
  ChangeAdminPassword___vue_styles__,
  ChangeAdminPassword___vue_scopeId__,
  ChangeAdminPassword___vue_module_identifier__
)

/* harmony default export */ var components_admin_user_ChangeAdminPassword = (ChangeAdminPassword_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js


















































vue_esm["default"].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: '/signin',
  name: 'signIn',
  component: components_user_Signin
}, {
  path: '/',
  redirect: '/dashboard'
}, {
  path: '',
  component: components_dashboard_Main,
  children: [{
    path: 'dashboard',
    name: 'Dashboard',
    component: components_dashboard_Dashboard,
    meta: { requiresAuth: true }
  }, {
    path: 'approver',
    component: components_mobile_user_Approver,
    children: [{
      path: '',
      name: 'approverDetail',
      component: components_mobile_user_ApproverDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newApprover',
      component: components_mobile_user_NewApprover,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changeApprover',
      props: true,
      component: components_mobile_user_ChangeApprover
    }, {
      path: 'change-approver-password/:id',
      name: 'ChangeApproverPassword',
      params: true,
      component: components_mobile_user_ChangeApproverPassword,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'limit',
    component: components_approval_limit_Limit,
    children: [{
      path: '',
      name: 'limitDetail',
      component: components_approval_limit_LimitDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newLimit',
      component: NewLimit,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changeLimit',
      props: true,
      component: components_approval_limit_ChangeLimit,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'workflow',
    component: components_workflow_Workflow,
    children: [{
      path: '',
      name: 'WorkflowDetail',
      component: components_workflow_WorkflowDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newWorkflow',
      component: components_workflow_NewWorkflow,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changeWorkflow',
      props: true,
      component: components_workflow_ChangeWorkflow,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'company',
    component: components_company_Company,
    children: [{
      path: '',
      name: 'companyDetail',
      component: components_company_CompanyDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newCompany',
      component: components_company_NewCompany,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changeCompany',
      props: true,
      component: components_company_ChangeCompany,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'division',
    component: components_division_Division,
    children: [{
      path: '',
      name: 'divisionDetail',
      component: components_division_DivisionDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newDivision',
      component: components_division_NewDivision,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changeDivision',
      props: true,
      component: components_division_ChangeDivision,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'department',
    component: components_department_Department,
    children: [{
      path: '',
      name: 'departmentDetail',
      component: components_department_DepartmentDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newDepartment',
      component: components_department_NewDepartment,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changeDepartment',
      props: true,
      component: components_department_ChangeDepartment,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'release-code',
    component: components_rank_Rank,
    children: [{
      path: '',
      name: 'releaseCodeDetail',
      component: components_rank_RankDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newReleaseCode',
      component: components_rank_NewRank,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changeReleaseCode',
      props: true,
      component: components_rank_ChangeRank,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'plant',
    component: components_plant_Plant,
    children: [{
      path: '',
      name: 'plantDetail',
      component: components_plant_PlantDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newPlant',
      component: components_plant_NewPlant,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changePlant',
      props: true,
      component: components_plant_ChangePlant,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'profile',
    component: components_user_Profile,
    children: [{
      path: '',
      name: 'profileDetail',
      component: components_user_ProfileDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'changepassword',
      name: 'changePassword',
      component: components_user_ChangePassword,
      meta: { requiresAuth: true }
    }]
  }, {
    path: 'pr-report',
    name: 'pr-report',
    component: components_report_PrReport,
    meta: { requiresAuth: true }
  }, {
    path: 'po-report',
    name: 'po-report',
    component: components_report_PoReport,
    meta: { requiresAuth: true }
  }, {
    path: 'admin',
    component: components_admin_user_Admin,
    children: [{
      path: '',
      name: 'adminDetail',
      component: components_admin_user_AdminDetail,
      meta: { requiresAuth: true }
    }, {
      path: 'new',
      name: 'newAdmin',
      component: components_admin_user_NewAdmin,
      meta: { requiresAuth: true }
    }, {
      path: 'change/:id',
      name: 'changeAdmin',
      props: true,
      component: components_admin_user_ChangeAdmin,
      meta: { requiresAuth: true }
    }, {
      path: 'changepassword/:id',
      name: 'changeAdminPassword',
      props: true,
      component: components_admin_user_ChangeAdminPassword,
      meta: { requiresAuth: true }
    }]
  }]
}];
var router = new vue_router_esm["a" /* default */]({
  // mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    var allowPath = store.getters.getAllowedMenuPath;
    var AUTH_TOKEN = localStorage.getItem('accesstoken');
    if (AUTH_TOKEN) {
      if (allowPath.length > 0) {
        var isAllowed = allowPath.some(function (element) {
          return to.fullPath.startsWith(element);
        });
        if (isAllowed) {
          next();
        } else {
          next({ path: '/', replace: true });
        }
      }
    } else {
      next({ path: '/signin', query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/store/modules/users.js





var users__mutations;






var users_state = {
  users: [],
  activeUser: {},
  err: false,
  isPasswordReset: false,
  errMessage: ''
};

var users_getters = {
  getActiveUser: function getActiveUser(state) {
    return state.activeUser;
  },
  getToken: function getToken(state) {
    return state.activeUser.token;
  },
  getErr: function getErr(state) {
    return state.err;
  },
  getErrMessage: function getErrMessage(state) {
    return state.errMessage;
  }
};

var users_mutations = (users__mutations = {}, defineProperty_default()(users__mutations, SET_USER, function (state, payload) {
  assign_default()(state.activeUser, payload);
}), defineProperty_default()(users__mutations, SIGN_OUT, function (state) {
  state.activeUser = {};
}), defineProperty_default()(users__mutations, SET_ERR, function (state, payload) {
  state.err = payload;
}), defineProperty_default()(users__mutations, SET_PASSWORD_RESET_FLAG, function (state, payload) {
  state.isPasswordReset = payload;
}), defineProperty_default()(users__mutations, SET_ERR_MESSAGE, function (state, payload) {
  state.errMessage = payload;
}), defineProperty_default()(users__mutations, CHANGE_USER_PROFILE, function (state, payload) {
  state.activeUser = payload;
}), defineProperty_default()(users__mutations, CHANGE_USER_PICTURE, function (state, payload) {
  state.activeUser.small_photo = payload.small_photo;
  state.activeUser.normal_photo = payload.normal_photo;
}), users__mutations);

var users_actions = {
  signIn: function signIn(_ref, payload) {
    var _this = this;

    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(SET_LOADING, true);
              commit(SET_ERR, false);
              _context.next = 4;
              return httpInstance.post('/auth/login', {
                employee_id: payload.user.employee_id,
                password: payload.user.password
              }).then(function (response) {
                commit(SET_ERR, false);
                commit(LOAD_RESPONSE, response);
                dispatch('setActiveUser', response.data);
                commit(GET_ALL_MENU_ITEMS, response.data.menus);
                localStorage.setItem('accesstoken', response.data.token);
                axios_default.a.defaults.headers.common['accesstoken'] = 'Bearer ' + response.data.token;
                setTimeout(function () {
                  commit(SET_LOADING, false);
                  var redirect = payload.redirect ? payload.redirect : '/';
                  src_router.replace(redirect);
                }, 500);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                setTimeout(function () {
                  commit(SET_LOADING, false);
                  commit(SET_ERR, true);
                }, 500);
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  setActiveUser: function setActiveUser(_ref2, payload) {
    var commit = _ref2.commit;

    commit(SET_USER, payload);
  },
  signOut: function signOut(_ref3) {
    var commit = _ref3.commit;

    commit(SIGN_OUT);
    localStorage.removeItem('accesstoken');
    commit(SET_LOADING, false);
    src_router.replace('/signin');
  },
  changeUserProfile: function changeUserProfile(_ref4, payload) {
    var _this2 = this;

    var commit = _ref4.commit,
        state = _ref4.state;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit(SET_LOADING, true);
              _context2.next = 3;
              return httpInstance.put('/auth/' + payload.id + '/update-profile', {
                company_code: state.activeUser.company_code,
                employee_id: payload.employee_id,
                first_name: payload.firstName,
                last_name: payload.lastName,
                email: payload.email,
                phone: payload.phone
              }).then(function (response) {
                commit(CHANGE_USER_PROFILE, response.data);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  changePassword: function changePassword(_ref5, payload) {
    var _this3 = this;

    var commit = _ref5.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit(SET_LOADING, true);
              _context3.next = 3;
              return httpInstance.post('/auth/change-password', {
                old_password: payload.old_password,
                new_password: payload.new_password,
                retype_password: payload.retype_password
              }).then(function (response) {
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  uploadPicture: function uploadPicture(_ref6, payload) {
    var _this4 = this;

    var commit = _ref6.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var formData;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit(SET_LOADING, true);
              formData = new FormData();

              formData.append(payload.name, payload.file);
              _context4.next = 5;
              return pictureUploadInstance.post('user/photo', formData).then(function (response) {
                commit(SET_USER, {
                  normal_photo: response.data.file_path
                });
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  sendForgotPassCode: function sendForgotPassCode(_ref7, payload) {
    var _this5 = this;

    var commit = _ref7.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit(SET_LOADING, true);
              _context5.next = 3;
              return httpInstance.post('auth/email-confirm-reset-password', payload).then(function (response) {
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
                commit(SET_PASSWORD_RESET_FLAG, true);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  resetPasswordWithCode: function resetPasswordWithCode(_ref8, payload) {
    var _this6 = this;

    var commit = _ref8.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit(SET_LOADING, true);
              _context6.next = 3;
              return httpInstance.post('auth/confirm-code/reset-password', payload).then(function (response) {
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
                commit(SET_PASSWORD_RESET_FLAG, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
};

/* harmony default export */ var users = ({
  state: users_state,
  getters: users_getters,
  mutations: users_mutations,
  actions: users_actions
});
// CONCATENATED MODULE: ./src/store/modules/workflow.js




var workflow__mutations;





var workflow_state = {
  approvalProfiles: [],
  activeApprovalProfile: {},
  approvalLimits: [],
  approvalUsers: [],
  userDevices: [],
  activeApprovalUser: {},
  workflow: [],
  activeWorkflow: {}
};

var workflow_getters = {
  getApprovalProfiles: function getApprovalProfiles(state) {
    return state.approvalProfiles;
  },
  getActiveApprovalProfile: function getActiveApprovalProfile(state) {
    return state.activeApprovalProfile;
  },
  getApprovalLimits: function getApprovalLimits(state) {
    return state.approvalLimits;
  },
  getNextMinLimit: function getNextMinLimit(state) {
    if (state.approvalLimits.length > 0) {
      return state.approvalLimits[state.approvalLimits.length - 1].total_value_to || 0;
    }
    return 0;
  },
  getApprovalUsers: function getApprovalUsers(state) {
    return state.approvalUsers;
  },
  getActiveApprovalUser: function getActiveApprovalUser(state) {
    return state.activeApprovalUser;
  },
  getWorkflow: function getWorkflow(state) {
    return state.workflow;
  },
  getActiveWorkflow: function getActiveWorkflow(state) {
    return state.activeWorkflow;
  },
  getUserDevices: function getUserDevices(state) {
    return state.userDevices;
  },
  getUserNotNullDevices: function getUserNotNullDevices(state) {
    var notNullDevices = [];
    state.userDevices.forEach(function (d) {
      if (d.device_name != null) {
        notNullDevices.push(d);
      }
    });
    return notNullDevices;
  }
};

var workflow_mutations = (workflow__mutations = {}, defineProperty_default()(workflow__mutations, GET_APPROVAL_PROFILES, function (state, payload) {
  state.approvalProfiles = payload;
}), defineProperty_default()(workflow__mutations, SET_ACTIVE_APPROVAL_PROFILE, function (state, payload) {
  state.activeApprovalProfile = payload;
}), defineProperty_default()(workflow__mutations, ADD_APPROVAL_PROFILE, function (state, payload) {
  state.approvalProfiles.push(payload);
}), defineProperty_default()(workflow__mutations, CHANGE_APPROVAL_PROFILE, function (state, payload) {
  var atIndex = state.approvalProfiles.findIndex(function (d) {
    return d.id === payload.id;
  });
  state.approvalProfiles.splice(atIndex, 1);
  state.approvalProfiles.splice(atIndex, 0, payload);
}), defineProperty_default()(workflow__mutations, DELETE_APPROVAL_PROFILE, function (state, id) {
  var atIndex = state.approvalProfiles.findIndex(function (d) {
    return d.id === id;
  });
  state.approvalProfiles.splice(atIndex, 1);
}), defineProperty_default()(workflow__mutations, GET_APPROVAL_LIMITS, function (state, payload) {
  state.approvalLimits = payload;
}), defineProperty_default()(workflow__mutations, DELETE_APPROVAL_LIMIT, function (state, id) {
  var atIndex = state.approvalLimits.findIndex(function (d) {
    return d.id === id;
  });
  state.approvalLimits.splice(atIndex, 1);
}), defineProperty_default()(workflow__mutations, ADD_APPROVAL_LIMIT, function (state, payload) {
  state.approvalLimits.push(payload);
}), defineProperty_default()(workflow__mutations, CHANGE_APPROVAL_LIMIT, function (state, payload) {
  var atIndex = state.approvalLimits.findIndex(function (d) {
    return d.id === payload.id;
  });
  state.approvalLimits.splice(atIndex, 1);
  state.approvalLimits.splice(atIndex, 0, payload);
}), defineProperty_default()(workflow__mutations, GET_APPROVAL_USERS, function (state, payload) {
  state.approvalUsers = payload;
}), defineProperty_default()(workflow__mutations, ADD_APPROVAL_USER, function (state, payload) {
  state.approvalUsers.push(payload);
}), defineProperty_default()(workflow__mutations, SET_ACTIVE_APPROVAL_USER, function (state, payload) {
  state.activeApprovalUser = payload;
}), defineProperty_default()(workflow__mutations, CHANGE_APPROVAL_USER, function (state, payload) {
  var atIndex = state.approvalUsers.findIndex(function (u) {
    return u.id === payload.id;
  });
  state.approvalUsers.splice(atIndex, 1);
  state.approvalUsers.splice(atIndex, 0, payload);
}), defineProperty_default()(workflow__mutations, DELETE_APPROVAL_USER, function (state, id) {
  var atIndex = state.approvalUsers.findIndex(function (u) {
    return u.id === id;
  });
  state.approvalUsers.splice(atIndex, 1);
}), defineProperty_default()(workflow__mutations, BLOCK_APPROVAL_USER, function (state, payload) {
  var atIndex = state.approvalUsers.findIndex(function (u) {
    return u.id === payload.id;
  });
  state.approvalUsers[atIndex].is_blocked = payload.is_blocked;
}), defineProperty_default()(workflow__mutations, GET_USER_DEVICES, function (state, payload) {
  state.userDevices = payload;
}), defineProperty_default()(workflow__mutations, BLOCK_USER_DEVICE, function (state, payload) {
  var atIndex = state.userDevices.findIndex(function (d) {
    return d.id === payload.id;
  });
  state.userDevices[atIndex].is_blocked = payload.is_blocked;
}), defineProperty_default()(workflow__mutations, GET_WORKFLOW, function (state, payload) {
  state.workflow = payload;
}), defineProperty_default()(workflow__mutations, SET_ACTIVE_WORKFLOW, function (state, payload) {
  state.activeWorkflow = payload;
}), defineProperty_default()(workflow__mutations, ADD_WORKFLOW, function (state, payload) {
  state.workflow.push(payload);
}), defineProperty_default()(workflow__mutations, CHANGE_WORKFLOW, function (state, payload) {
  var atIndex = state.workflow.findIndex(function (d) {
    return d.id === payload.id;
  });
  state.workflow.splice(atIndex, 1);
  state.workflow.splice(atIndex, 0, payload);
}), defineProperty_default()(workflow__mutations, DELETE_WORKFLOW, function (state, id) {
  var atIndex = state.workflow.findIndex(function (d) {
    return d.id === id;
  });
  state.workflow.splice(atIndex, 1);
}), workflow__mutations);

var workflow_actions = {
  fetchAllApprovalProfiles: function fetchAllApprovalProfiles(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(SET_LOADING, true);
              _context.next = 3;
              return httpInstance.get('approval-profile/list-unlimited').then(function (response) {
                commit(GET_APPROVAL_PROFILES, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  setActiveApprovalProfile: function setActiveApprovalProfile(_ref2, id) {
    var _this2 = this;

    var commit = _ref2.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit(SET_LOADING, true);
              _context2.next = 3;
              return httpInstance.get('approval-profile/' + id + '/get').then(function (response) {
                commit(SET_ACTIVE_APPROVAL_PROFILE, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fetchActiveApprovalProfile: function fetchActiveApprovalProfile(_ref3, id) {
    var _this3 = this;

    var commit = _ref3.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit(SET_LOADING, true);
              _context3.next = 3;
              return axios_default.a.all([httpInstance.get('approval-profile/' + id + '/get'), httpInstance.get('approval-limit/approval-profile/' + id + '/list')]).then(axios_default.a.spread(function (activeProfile, limits) {
                limits.data.sort(function (a, b) {
                  return a.total_value_to - b.total_value_to;
                });
                commit(SET_ACTIVE_APPROVAL_PROFILE, activeProfile.data);
                commit(GET_APPROVAL_LIMITS, limits.data);
                commit(SET_LOADING, false);
              }));

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  addApprovalProfile: function addApprovalProfile(_ref4, payload) {
    var _this4 = this;

    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit(SET_LOADING, true);
              _context4.next = 3;
              return httpInstance.post('approval-profile/add', {
                description: payload.description,
                company_code: payload.company_code,
                type: payload.type
              }).then(function (response) {
                dispatch('fetchAllApprovalProfiles');
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeApprovalProfile: function changeApprovalProfile(_ref5, payload) {
    var _this5 = this;

    var commit = _ref5.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit(SET_LOADING, true);
              _context5.next = 3;
              return httpInstance.put('approval-profile/' + payload.id + '/update', {
                description: payload.description,
                company_code: payload.company_code,
                type: payload.type
              }).then(function (response) {
                commit(CHANGE_APPROVAL_PROFILE, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  deleteApprovalProfile: function deleteApprovalProfile(_ref6, id) {
    var _this6 = this;

    var commit = _ref6.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit(SET_LOADING, true);
              _context6.next = 3;
              return httpInstance.delete('approval-profile/' + id + '/delete').then(function (response) {
                commit(DELETE_APPROVAL_PROFILE, id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  fetchApprovalLimits: function fetchApprovalLimits(_ref7, id) {
    var _this7 = this;

    var commit = _ref7.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return httpInstance.get('approval-limit/approval-profile/' + id + '/list').then(function (response) {
                commit(GET_APPROVAL_LIMITS, response.data);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  deleteApprovalLimit: function deleteApprovalLimit(_ref8, id) {
    var _this8 = this;

    var commit = _ref8.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit(SET_LOADING, true);
              _context8.next = 3;
              return httpInstance.delete('approval-limit/' + id + '/delete').then(function (response) {
                commit(DELETE_APPROVAL_LIMIT, id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  addApprovalLimit: function addApprovalLimit(_ref9, payload) {
    var _this9 = this;

    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit(SET_LOADING, true);
              _context9.next = 3;
              return httpInstance.post('approval-limit/add', {
                approval_profile_id: payload.approval_profile_id,
                max_value_from: payload.total_value_from,
                max_value_to: payload.total_value_to,
                is_unlimited: payload.is_unlimited
              }).then(function (response) {
                dispatch('fetchApprovalLimits', payload.approval_profile_id);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  changeApprovalLimit: function changeApprovalLimit(_ref10, payload) {
    var _this10 = this;

    var commit = _ref10.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit(SET_LOADING, true);
              _context10.next = 3;
              return httpInstance.put('approval-limit/1/update', {
                approval_profile_id: payload.approval_profile_id,
                max_value_from: payload.total_value_from,
                max_value_to: payload.total_value_to,
                is_unlimited: payload.is_unlimited
              }).then(function (response) {
                commit(CHANGE_APPROVAL_LIMIT, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fetchApprovalUsers: function fetchApprovalUsers(_ref11) {
    var _this11 = this;

    var commit = _ref11.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
      return regenerator_default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit(SET_LOADING, true);
              _context11.next = 3;
              return httpInstance.get('user/list-unlimited').then(function (response) {
                commit(GET_APPROVAL_USERS, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  addApprovalUser: function addApprovalUser(_ref12, payload) {
    var _this12 = this;

    var commit = _ref12.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
      return regenerator_default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              commit(SET_LOADING, true);
              _context12.next = 3;
              return httpInstance.post('user/create', payload).then(function (response) {
                console.log(response);
                commit(LOAD_RESPONSE, response);
                commit(ADD_APPROVAL_USER, payload);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  setActiveApprovalUser: function setActiveApprovalUser(_ref13, id) {
    var _this13 = this;

    var commit = _ref13.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
      return regenerator_default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit(SET_LOADING, true);
              _context13.next = 3;
              return httpInstance.get('user/' + id + '/one').then(function (response) {
                commit(SET_ACTIVE_APPROVAL_USER, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  changeApprovalUser: function changeApprovalUser(_ref14, payload) {
    var _this14 = this;

    var commit = _ref14.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
      return regenerator_default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              commit(SET_LOADING, true);
              _context14.next = 3;
              return httpInstance.put('user/' + payload.id + '/update', {
                company_code: payload.company_code,
                rank_id: payload.rank_id,
                employee_id: payload.employee_id,
                email: payload.email,
                salutation: payload.salutation,
                first_name: payload.first_name,
                last_name: payload.last_name
              }).then(function (response) {
                commit(CHANGE_APPROVAL_USER, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  changeApprovalPassword: function changeApprovalPassword(_ref15, payload) {
    var _this15 = this;

    var commit = _ref15.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
      return regenerator_default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              commit(SET_LOADING, true);
              _context15.next = 3;
              return httpInstance.put('/auth/mibile-user/' + payload.id + '/change-password', payload.user).then(function (response) {
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  deleteApprovalUser: function deleteApprovalUser(_ref16, id) {
    var _this16 = this;

    var commit = _ref16.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
      return regenerator_default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              commit(SET_LOADING, true);
              _context16.next = 3;
              return httpInstance.delete('user/' + id + '/delete').then(function (response) {
                commit(DELETE_APPROVAL_USER, id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  },
  blockApprovalUser: function blockApprovalUser(_ref17, payload) {
    var _this17 = this;

    var commit = _ref17.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
      return regenerator_default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return httpInstance.get('auth/user/' + payload.id + '/block').then(function (response) {
                commit(BLOCK_APPROVAL_USER, payload);
                commit(LOAD_RESPONSE, response);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
              });

            case 2:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17);
    }))();
  },
  fetchBlockedDevices: function fetchBlockedDevices(_ref18, id) {
    var _this18 = this;

    var commit = _ref18.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
      return regenerator_default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              commit(SET_LOADING, true);
              _context18.next = 3;
              return httpInstance.get('user/user-device/list').then(function (response) {
                commit(GET_USER_DEVICES, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18);
    }))();
  },
  fetchUserDevices: function fetchUserDevices(_ref19, id) {
    var _this19 = this;

    var commit = _ref19.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
      return regenerator_default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              commit(SET_LOADING, true);
              _context19.next = 3;
              return httpInstance.get('user/user-device/' + id + '/list').then(function (response) {
                commit(GET_USER_DEVICES, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19);
    }))();
  },
  blockUserDevice: function blockUserDevice(_ref20, payload) {
    var _this20 = this;

    var commit = _ref20.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20() {
      return regenerator_default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return httpInstance.get('auth/user-token/' + payload.id + '/block').then(function (response) {
                commit(BLOCK_USER_DEVICE, payload);
                commit(LOAD_RESPONSE, response);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
              });

            case 2:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20);
    }))();
  },
  fetchWorkflow: function fetchWorkflow(_ref21) {
    var _this21 = this;

    var commit = _ref21.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21() {
      return regenerator_default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              commit(SET_LOADING, true);
              _context21.next = 3;
              return httpInstance.get('approval-workflow-setting/list-unlimited').then(function (response) {
                commit(GET_WORKFLOW, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this21);
    }))();
  },
  searchWorkflow: function searchWorkflow(_ref22, payload) {
    var _this22 = this;

    var commit = _ref22.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22() {
      return regenerator_default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              commit(SET_LOADING, true);
              _context22.next = 3;
              return httpInstance.get('approval-workflow-setting/list?companyId=' + payload.companyId + '&divisionId=' + payload.divisionId + '&plantId=' + payload.plantId + '&departmentId=' + payload.departmentId + '&approvalProfileId=' + payload.approvalProfileId).then(function (response) {
                console.log(response);
                commit(GET_WORKFLOW, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this22);
    }))();
  },
  setActiveWorkflow: function setActiveWorkflow(_ref23, id) {
    var _this23 = this;

    var commit = _ref23.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23() {
      return regenerator_default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              commit(SET_LOADING, true);
              _context23.next = 3;
              return httpInstance.get('approval-workflow-setting/' + id + '/one').then(function (response) {
                console.log(response);
                commit(SET_ACTIVE_WORKFLOW, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this23);
    }))();
  },
  addWorkflow: function addWorkflow(_ref24, payload) {
    var _this24 = this;

    var commit = _ref24.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee24() {
      return regenerator_default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              commit(SET_LOADING, true);
              _context24.next = 3;
              return httpInstance.post('approval-workflow-setting/create', payload).then(function (response) {
                commit(ADD_WORKFLOW, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                commit(LOAD_RESPONSE, error.response);
                console.log(error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this24);
    }))();
  },
  changeWorkflow: function changeWorkflow(_ref25, payload) {
    var _this25 = this;

    var commit = _ref25.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee25() {
      return regenerator_default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              commit(SET_LOADING, true);
              _context25.next = 3;
              return httpInstance.put('approval-workflow-setting/' + payload.id + '/update', {
                company_id: payload.company_id,
                plant_id: payload.plant_id,
                division_id: payload.division_id,
                department_id: payload.department_id,
                approval_limit_id: payload.approval_limit_id,
                employee_id_level_1: payload.approval_level_1,
                employee_id_level_2: payload.approval_level_2,
                employee_id_level_3: payload.approval_level_3,
                employee_id_level_4: payload.approval_level_4,
                employee_id_level_5: payload.approval_level_5,
                employee_id_level_6: payload.approval_level_6,
                employee_id_level_7: payload.approval_level_7,
                employee_id_level_8: payload.approval_level_8,
                requisitioner: payload.requisitioner
              }).then(function (response) {
                commit(CHANGE_WORKFLOW, payload);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this25);
    }))();
  },
  deleteWorkflow: function deleteWorkflow(_ref26, id) {
    var _this26 = this;

    var commit = _ref26.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee26() {
      return regenerator_default.a.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              commit(SET_LOADING, true);
              _context26.next = 3;
              return httpInstance.delete('approval-workflow-setting/' + id + '/delete').then(function (response) {
                commit(DELETE_WORKFLOW, id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this26);
    }))();
  }
};

/* harmony default export */ var workflow = ({
  state: workflow_state,
  getters: workflow_getters,
  mutations: workflow_mutations,
  actions: workflow_actions
});
// CONCATENATED MODULE: ./src/store/modules/report.js





var report__mutations;




var report_state = {
  reportPr: [],
  reportPo: []
};
var report_getters = {
  getPrReport: function getPrReport(state) {
    return state.reportPr;
  },
  getPoReport: function getPoReport(state) {
    return state.reportPo;
  }
};
var report_mutations = (report__mutations = {}, defineProperty_default()(report__mutations, GET_PR_REPORT, function (state, payload) {
  state.reportPr = assign_default()([], payload);
}), defineProperty_default()(report__mutations, GET_PO_REPORT, function (state, payload) {
  state.reportPo = assign_default()([], payload);
}), report__mutations);
var report_actions = {
  searchPO: function searchPO(_ref, payload) {
    var _this = this;

    var commit = _ref.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var offset, company;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!payload.company) {
                _context.next = 6;
                break;
              }

              commit(SET_LOADING, true);
              offset = (payload.page - 1) * 20;
              company = payload.company === 'CMI' ? 'CMCR' : payload.company;
              _context.next = 6;
              return httpInstance.get('purchase/order/admin/report-summary?company=' + company + '&division=' + payload.division + '&department=' + payload.department + '&plant=' + payload.plant + '&from_date=' + payload.from_date + '&to_date=' + payload.to_date + '&offset=' + offset).then(function (response) {
                commit(GET_PO_REPORT, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  searchPR: function searchPR(_ref2, payload) {
    var _this2 = this;

    var commit = _ref2.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var offset, company;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!payload.company) {
                _context2.next = 6;
                break;
              }

              commit(SET_LOADING, true);
              offset = (payload.page - 1) * 20;
              company = payload.company === 'CMI' ? 'CMCR' : payload.company;
              _context2.next = 6;
              return httpInstance.get('purchase/requisition/admin/report-summary?company=' + company + '&division=' + payload.division + '&department=' + payload.department + '&plant=' + payload.plant + '&from_date=' + payload.from_date + '&to_date=' + payload.to_date + '&offset=' + offset).then(function (response) {
                commit(GET_PR_REPORT, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

/* harmony default export */ var report = ({
  state: report_state,
  getters: report_getters,
  mutations: report_mutations,
  actions: report_actions
});
// CONCATENATED MODULE: ./src/store/modules/dashboard.js




var dashboard__mutations;




var dashboard_state = {
  pendingPR: 0,
  pendingPO: 0,
  totalUser: 0,
  currentLoginUsers: []
};

var dashboard_getters = {
  getPendingPR: function getPendingPR(state) {
    return state.pendingPR;
  },
  getPendingPO: function getPendingPO(state) {
    return state.pendingPO;
  },
  getTotalUser: function getTotalUser(state) {
    return state.totalUser;
  },
  getCurrentLoginUsers: function getCurrentLoginUsers(state) {
    return state.currentLoginUsers;
  }
};

var dashboard_mutations = (dashboard__mutations = {}, defineProperty_default()(dashboard__mutations, GET_PENDING_PR, function (state, payload) {
  state.pendingPR = payload;
}), defineProperty_default()(dashboard__mutations, GET_PENDING_PO, function (state, payload) {
  state.pendingPO = payload;
}), defineProperty_default()(dashboard__mutations, GET_TOTAL_USERS, function (state, payload) {
  state.totalUser = payload;
}), defineProperty_default()(dashboard__mutations, GET_LOGIN_USERS, function (state, payload) {
  state.currentLoginUsers = payload;
}), dashboard__mutations);

var dashboard_actions = {
  fetchPendingPR: function fetchPendingPR(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return httpInstance.get('purchase/total-pr').then(function (response) {
                commit(GET_PENDING_PR, response.data);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fetchPendingPO: function fetchPendingPO(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return httpInstance.get('purchase/total-po').then(function (response) {
                commit(GET_PENDING_PO, response.data);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fetchTotalUser: function fetchTotalUser(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return httpInstance.get('auth/mibile-user/total').then(function (response) {
                commit(GET_TOTAL_USERS, response.data);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
              });

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchCurrentLoginUsers: function fetchCurrentLoginUsers(_ref4) {
    var _this4 = this;

    var commit = _ref4.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return httpInstance.get('user/current-login/list').then(function (response) {
                commit(GET_LOGIN_USERS, response.data);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
              });

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
};

/* harmony default export */ var dashboard = ({
  state: dashboard_state,
  getters: dashboard_getters,
  actions: dashboard_actions,
  mutations: dashboard_mutations
});
// CONCATENATED MODULE: ./src/store/modules/admin.js




var admin__mutations;





var admin_state = {
  admin_users: [],
  admin_user: {},
  accessible_menu: []
};

var admin_getters = {
  getAccessibleMenu: function getAccessibleMenu(state) {
    return state.accessible_menu;
  }
};

var admin_mutations = (admin__mutations = {}, defineProperty_default()(admin__mutations, GET_ALL_ADMIN, function (state, payload) {
  state.admin_users = payload;
}), defineProperty_default()(admin__mutations, SET_ACTIVE_ADMIN, function (state, payload) {
  state.admin_user = payload;
}), defineProperty_default()(admin__mutations, SET_ACCESSIBLE_MENU, function (state, payload) {
  state.accessible_menu = [];
  var menuItems = [];
  if (payload.length > 0) {
    payload.forEach(function (element) {
      element.menu_subs.forEach(function (sub) {
        menuItems.push(sub.id);
      });
    });
  }
  state.accessible_menu = menuItems;
}), defineProperty_default()(admin__mutations, ADD_ADMIN, function (state, payload) {
  state.admin_users.push(payload);
}), defineProperty_default()(admin__mutations, CHANGE_ADMIN, function (state, payload) {
  var atIndex = state.admin_users.findIndex(function (admin) {
    return admin.id === payload.id;
  });
  state.admin_users.splice(atIndex, 1);
  state.admin_users.splice(atIndex, 0, payload);
}), defineProperty_default()(admin__mutations, CHANGE_ACCESSIBLE_MENU, function (state, payload) {
  state.accessible_menu.push(payload);
}), defineProperty_default()(admin__mutations, DELETE_ADMIN, function (state, _id) {
  var atIndex = state.admin_users.findIndex(function (admin) {
    return admin.id === _id;
  });
  state.admin_users.splice(atIndex, 1);
}), admin__mutations);

var admin_actions = {
  fetchAllAdminUsers: function fetchAllAdminUsers(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(SET_LOADING, true);
              _context.next = 3;
              return httpInstance.get('auth/list').then(function (response) {
                commit(GET_ALL_ADMIN, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                commit(SET_LOADING, false);
                console.log(error.response);
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  addNewAdminUser: function addNewAdminUser(_ref2, payload) {
    var _this2 = this;

    var commit = _ref2.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit(SET_LOADING, true);
              _context2.next = 3;
              return httpInstance.post('auth/create-admin-user', payload.admin).then(function (response) {
                commit(ADD_ADMIN, payload.admin);
                payload.menu.auth_id = response.data.id;
                payload.menu.menu_sub_id.push(1, 10); // set dashbord and my profile menu default to all users
                httpInstance.post('menu/add-permission', payload.menu).then(function (res) {
                  commit(LOAD_RESPONSE, res);
                  commit(SET_LOADING, false);
                }).catch(function (err) {
                  console.log(err.response);
                });
              }).catch(function (error) {
                commit(LOAD_RESPONSE, error.response);
                console.log(error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  setActiveAdmin: function setActiveAdmin(_ref3, _id) {
    var _this3 = this;

    var commit = _ref3.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit(SET_LOADING, true);
              _context3.next = 3;
              return axios_default.a.all([httpInstance.get('/auth/' + _id + '/get'), httpInstance.get('menu/auth/' + _id + '/list')]).then(axios_default.a.spread(function (admin, menu) {
                commit(SET_ACTIVE_ADMIN, admin.data);
                commit(SET_ACCESSIBLE_MENU, menu.data);
                commit(SET_LOADING, false);
              })).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  changeAdminUser: function changeAdminUser(_ref4, payload) {
    var _this4 = this;

    var commit = _ref4.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit(SET_LOADING, true);
              _context4.next = 3;
              return axios_default.a.all([httpInstance.put('/auth/' + payload.admin.id + '/update-profile', {
                employee_id: payload.admin.employee_id,
                first_name: payload.admin.first_name,
                last_name: payload.admin.last_name,
                email: payload.admin.email,
                phone: payload.admin.phone,
                company_code: payload.admin.company_code
              }), httpInstance.put('menu/auth/' + payload.admin.id + '/update-permission', { menu_sub_id: payload.menu })]).then(axios_default.a.spread(function (admin, menu) {
                commit(CHANGE_ADMIN, admin.data);
                commit(SET_ACCESSIBLE_MENU, menu.data);
                commit(LOAD_RESPONSE, admin);
                commit(SET_LOADING, false);
              })).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  deleteAdminUser: function deleteAdminUser(_ref5, _id) {
    var _this5 = this;

    var commit = _ref5.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit(SET_LOADING, true);
              _context5.next = 3;
              return httpInstance.delete('auth/' + _id + '/delete-admin-user').then(function (response) {
                commit(DELETE_ADMIN, _id);
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  changeAdminPassword: function changeAdminPassword(_ref6, payload) {
    var _this6 = this;

    var commit = _ref6.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit(SET_LOADING, true);
              _context6.next = 3;
              return httpInstance.post('/auth/' + payload.id + '/change-password', {
                new_password: payload.admin.new_password,
                retype_password: payload.admin.retype_password
              }).then(function (response) {
                commit(LOAD_RESPONSE, response);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                console.log(error.response);
                commit(LOAD_RESPONSE, error.response);
                commit(SET_LOADING, false);
              });

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
};

/* harmony default export */ var modules_admin = ({
  state: admin_state,
  getters: admin_getters,
  mutations: admin_mutations,
  actions: admin_actions
});
// CONCATENATED MODULE: ./src/store/modules/menu.js




var menu__mutations;




function getMenu(navMenu) {
  var menuItems = [];
  if (navMenu.length > 0) {
    navMenu.forEach(function (element) {
      if (element.name === 'Reports') {
        menuItems.push({ divider: true });
        menuItems.push({ header: 'Reports' });
      } else if (element.name === 'Master Data') {
        menuItems.push({ divider: true });
        menuItems.push({ header: 'Master Data' });
      } else if (element.name === 'System Administration') {
        menuItems.push({ divider: true });
        menuItems.push({ header: 'System Administration' });
      }
      element.menu_subs.forEach(function (sub) {
        var row = {};
        row.icon = sub.icon;
        row.title = sub.title;
        row.to = sub.to;
        row.id = sub.id;
        menuItems.push(row);
      });
    });
  }
  return menuItems;
}

var menu_state = {
  nav_menu_items: [],
  menu_list_options: []
};

var menu_getters = {
  getMenuForDrawer: function getMenuForDrawer(state) {
    return getMenu(state.nav_menu_items);
  },

  getAllowedMenuItems: function getAllowedMenuItems(state) {
    var menu = [];
    var menuItems = getMenu(state.menu_list_options);
    menuItems.forEach(function (sub) {
      if (sub.id !== 1 && sub.id !== 10) {
        menu.push(sub);
      }
    });
    return menu;
  },

  getAllowedMenuPath: function getAllowedMenuPath(state) {
    var allMenu = getMenu(state.nav_menu_items);
    var menuPath = [];
    allMenu.forEach(function (menu) {
      if (menu.id) {
        menuPath.push(menu.to);
      }
    });
    return menuPath;
  }
};

var menu_mutations = (menu__mutations = {}, defineProperty_default()(menu__mutations, GET_ALL_MENU_ITEMS, function (state, payload) {
  payload.forEach(function (sub) {
    sub.menu_subs.sort(function (x, y) {
      return x.id - y.id;
    });
  });
  payload.sort(function (a, b) {
    return a.id - b.id;
  });
  state.nav_menu_items = payload;
}), defineProperty_default()(menu__mutations, GET_MENU_LIST_OPTIONS, function (state, payload) {
  payload.sort(function (a, b) {
    return a.id - b.id;
  });
  state.menu_list_options = payload;
}), menu__mutations);

var menu_actions = {
  fetchMenuItems: function fetchMenuItems(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(SET_LOADING, true);
              _context.next = 3;
              return httpInstance.get('menu/list').then(function (response) {
                commit(GET_MENU_LIST_OPTIONS, response.data);
                commit(SET_LOADING, false);
              }).catch(function (error) {
                commit(SET_LOADING, false);
                console.log(error.response);
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

/* harmony default export */ var modules_menu = ({
  state: menu_state,
  getters: menu_getters,
  mutations: menu_mutations,
  actions: menu_actions
});
// CONCATENATED MODULE: ./src/store/index.js











vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    masterData: master_data,
    users: users,
    workflow: workflow,
    report: report,
    dashboard: dashboard,
    admin: modules_admin,
    menu: modules_menu
  },
  plugins: [Object(vuex_persistedstate_es["a" /* default */])()],
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/vue2-filters/dist/vue2-filters.js
var vue2_filters = __webpack_require__("OjAt");
var vue2_filters_default = /*#__PURE__*/__webpack_require__.n(vue2_filters);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82311ac2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











vue_esm["default"].use(vuetify_default.a, {
  theme: {
    primary: '#007d41',
    primaryDarker: '#004f18',
    primaryLighter: '#48ad6d',
    secondary: '#2962ff',
    accent: '#2962ff',
    accentDarker: '#0039cb',
    accentLighter: '#768fff'
  }
});

vue_esm["default"].config.productionTip = false;

var config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
};
vue_esm["default"].use(vee_validate_esm["a" /* default */], config);

vue_esm["default"].filter('formatDate', function (value) {
  if (value) {
    return moment_default()(String(value)).format('DD/MM/YYYY hh:mm:ss A');
  }
});

vue_esm["default"].filter('phone', function (phone) {
  return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{2})(\d{3})(\d{3})/, '+$1 $2 $3 $4');
});

vue_esm["default"].use(vue2_filters_default.a);

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  store: store,
  router: src_router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Nh5J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NvIb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NxF2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qfis":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rloa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U+vW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UYk3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V3l2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WSIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WdJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X1fd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XcLm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xm9g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a1z8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eMzH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fTaf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g4Dl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i4Wl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iTkg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ku0l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m0LY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m0t3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pfEV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rXGo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rsSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t1Ci":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5l6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xL8a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y2aF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yS44":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zfNP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zvnK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.625d7b39150c83a772c9.js